import React, { useEffect, useState } from 'react';
import { useContext } from 'react';

import { bool } from 'prop-types';
import { StyledMenu } from './Menu.styled';
import { Container, Row, Col } from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Products } from '../Products/Products';
import { Distributers } from '../Distributers/Distributers';
import CartContext from '../../store/cart-context';



const useStyles = makeStyles((theme) => ({

   heading: {
      fontSize: '17px',
      flexBasis: '100.33%',
      flexShrink: 0,
      textAlign: 'left',
   },
   productCard: {
   }
}));

let removeCartId = [];
window.currentSelected = {
   'category1': 'SMD2499FS',
   'category2': 'SWB3052GS',
   'category3': 'SJG2254FS',
   'category4': 'SDW6757ES',
   'category5': 'SCR3042FB',
   'category6': 'SHC3662FS',
   // 'category7': 'SMO1652DS',
   'category7': 'SMO1759JS',
   'category8': 'SWB3085HS',
   'category9': 'STR3065HS',
   'category10': 'SSG3065JS',
   'category11': 'SKCD24U0GS'

}

window.wallOvenCategory = {
   'wallOvenOnly': 'SWB3052GS',
   'comboWallOven': 'SWB3085HS'
}

var hideFridge = true;
var hoodRange = true;

var distributor_data = [];

const Menu = ({ open, ...props }) => {

   const cartCtx = useContext(CartContext);
   const isHidden = open ? true : false
   const classes = useStyles();
   const [expanded, setExpanded] = React.useState(false);
   const [removeCartBtn, setremoveCartBtn] = React.useState(false);

   const [allProducts, setAllProducts] = useState(Products);

   window.handleChangeGlobal = (panel) => {

      // console.log("******** handleChangeGlobal **********");
      // console.log(panel);
      // alert("handleChangeGlobal")

      if (panel == 'first') {
         firstDrawer();
      }
      if (panel == 'second') {
         secondDrawer();
      }
      if (panel == 'third') {
         thirdDrawer();
      }
      if (panel == 'fourth') {
         fourthDrawer();
      }
      if (panel == 'fifth') {
         fifthDrawer();
      }
      if (panel == 'sixth') {
         sixthDrawer();
      }
      if (panel == 'seventh') {
         seventhDrawer();
      }
      if (panel == 'eighth') {
         eighthDrawer();
      }
      if (panel == 'ninth') {
         ninthDrawer();
      }
      if (panel == 'tenth') {
         tenthDrawer();
      }
      if (panel == 'eleventh') {
         eleventhDrawer();
      }
   }

   window.handleChange = (panel) => (event, isExpanded) => {
      // setExpanded(isExpanded ? panel : false);
      if (window.pauseRendering || window.pauseIconClick || window.pauseClick) return;

      if (isExpanded) {
         setExpanded(panel);


      } else {
         setExpanded(false);

      };

   };

   const [camData, setCamData] = useState("");

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {

            console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   const [orientationPotrait, setOrientation] = useState(true);
   window.checkOrientationStatus = (orientationStatus) => {
      // alert(window.orientation);
      setOrientation(orientationStatus);
   }
   useEffect(() => {
      // blocking second products ************** Temporary Change ***************
      // document.querySelector('.cartMainDiv').classList.add('Mui-disabled');
      // document.querySelector('.cartBtnMain2').classList.add("Mui-disabled");
      // document.querySelector('#panel2bh-content').disabled = true;
      // removeCartId = [];
      var add = document.querySelectorAll('.addToCartBtn')
      var addDownload = document.querySelectorAll('.addToCartBtnDownload')
      add.forEach(ele => ele.classList.add('display'))
      addDownload.forEach(ele => ele.classList.add('display'))
      var remove = document.querySelectorAll('.removeFromCartBtn')
      remove.forEach(ele => ele.classList.remove('display'))
      // document.querySelectorAll('.removeFromCartBtn').map(ele => ele.style.display = 'none')
      for (let i in cartCtx.items) {
         console.log('useEffect', cartCtx.items[i].id)
         document.querySelector('#' + cartCtx.items[i].id + ' .addToCartBtn').classList.remove('display');
         document.querySelector('#' + cartCtx.items[i].id + ' .removeFromCartBtn').classList.add('display');
         document.querySelector('#' + cartCtx.items[i].category + '.icon_stable').classList.add('selectDrawerMain');
         // console.log(removeCartId);
      }
      document.querySelector('#' + window.currentSelected.category1).classList.add("selected");
      // console.log("@@@ Menu Componenet loaded again@@@@@@@@");
      // console.log(window.currentSelected.category2);
      document.querySelector('#' + window.currentSelected.category2).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category3).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category4).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category5).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category6).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category7).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category8).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category9).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category10).classList.add("selected");
      document.querySelector('#' + window.currentSelected.category11).classList.add("selected");
   });
   const addToCartHandler = (e) => {

      // alert("addToCartHandler");
      // var cardIndex = e.nativeEvent.path.findIndex((element) => element.classList.contains("cartMainDiv"))
      // console.log(cardIndex)
      // var elem = e.nativeEvent.path[cardIndex];
      var newTarget = e.target;
      // console.log('newTarget', newTarget);
      var newElem = newTarget.closest(".cartMainDiv");
      // console.log('newElem', newElem)
      if (e.nativeEvent.path != undefined) {
         var cardIndex = e.nativeEvent.path.findIndex((element) => element.classList.contains("cartMainDiv"))
         // console.log(cardIndex)
         var elem = e.nativeEvent.path[cardIndex];


      } else {
         var elem;
         var toElement = e.nativeEvent.toElement

         if (navigator.appCodeName == 'Mozilla') {
            // var elem = e.currentTarget
            toElement = e.nativeEvent.target

            elem = e.nativeEvent.target.lastChild.parentElement.parentElement.parentElement.parentElement;
         }
         else if (toElement.classList.contains('cartText')) {
            elem = e.nativeEvent.toElement.lastChild.parentElement.parentElement.parentElement.parentElement;
         } else {
            elem = e.nativeEvent.toElement.lastChild.parentElement.parentElement;
         }
      }

      elem = newElem;
      // console.log(e)

      // console.log(toElement)

      // console.log(elem)


      if (expanded == 'panel1') {
         var itemToAdd = Products.category1.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category1.items[itemToAdd]);


      } else if (expanded == 'panel2') {
         var itemToAdd = Products.category2.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category2.items[itemToAdd]);
      }
      else if (expanded == 'panel3') {
         var itemToAdd = Products.category3.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category3.items[itemToAdd]);
      }
      else if (expanded == 'panel4') {
         var itemToAdd = Products.category4.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category4.items[itemToAdd]);
      }
      else if (expanded == 'panel5') {
         var itemToAdd = Products.category5.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category5.items[itemToAdd]);
      }
      else if (expanded == 'panel6') {
         var itemToAdd = Products.category6.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category6.items[itemToAdd]);
      }
      else if (expanded == 'panel7') {
         var itemToAdd = Products.category7.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category7.items[itemToAdd]);
      } else if (expanded == 'panel8') {
         var itemToAdd = Products.category8.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category8.items[itemToAdd]);
      } else if (expanded == 'panel9') {
         var itemToAdd = Products.category9.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category9.items[itemToAdd]);
      } else if (expanded == 'panel10') {
         var itemToAdd = Products.category10.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category10.items[itemToAdd]);
      } else if (expanded == 'panel11') {
         var itemToAdd = Products.category11.items.findIndex((element) => element.id == elem.id);
         cartCtx.additem(Products.category11.items[itemToAdd]);
      }

   }
   const removeCartHandler = (e) => {

      //var cardIndex = e.nativeEvent.path.findIndex((element) => element.classList.contains("cartMainDiv"))
      // console.log(cardIndex)
      // var elem = e.nativeEvent.path[cardIndex];
      if (e.nativeEvent.path != undefined) {
         var cardIndex = e.nativeEvent.path.findIndex((element) => element.classList.contains("cartMainDiv"))
         // console.log(cardIndex)
         var elem = e.nativeEvent.path[cardIndex];
      }
      else {
         var elem;
         var toElement = e.nativeEvent.toElement

         var newTarget = e.target;
         // console.log('newTarget', newTarget);
         var newElem = newTarget.closest(".cartMainDiv");
         if (navigator.appCodeName == 'Mozilla') {
            // var elem = e.currentTarget
            toElement = e.nativeEvent.target
            elem = e.nativeEvent.target.lastChild.parentElement.parentElement.parentElement.parentElement;
         } else if (toElement.classList.contains('cartText')) {
            elem = e.nativeEvent.toElement.lastChild.parentElement.parentElement.parentElement.parentElement;
         } else {
            elem = e.nativeEvent.toElement.lastChild.parentElement.parentElement;
         }

      }


      // console.log('newElem', newElem)
      // console.log(elem);
      // console.log(newElem.id)
      // console.log(elem.id);
      elem = newElem
      cartCtx.removeItem(elem.id);
      document.querySelector('#' + elem.id + ' .addToCartBtn').classList.add('display');
      document.querySelector('#' + elem.id + ' .removeFromCartBtn').classList.remove('display');
      for (let i in cartCtx.items) {
         document.querySelector('#' + cartCtx.items[i].category + '.icon_stable').classList.remove('selectDrawerMain');
      }

   }


   var displayTextsOnCompleted = null;

   window.selectProduct = async function (evnt, divID) {
      //const selectProduct = async e => {
      // async function selectProduct(evnt) {

      // console.log("select Product", evnt);
      

      if (evnt != undefined) {
         if (evnt.target.classList.contains('cartText') || evnt.target.classList.contains('cartBtnMain')) {
            return
         }
      }

      if(document.querySelector(".awardHotspotText")){ 
         document.querySelector(".awardHotspotText").style.display = 'none'
     }
      window.menuScrollTop = window.$('#scroll_panel').scrollTop();
      // console.log('window.menuScrollTop',window.menuScrollTop)

      // console.log('$$$$$window.pauseIconClick',window.pauseIconClick);
      window.previousSelectedCartMainDiv = window.$('.cartMainDiv.selected');
      // console.log('*** AAATONI firstDrawer');
      var itemToAdd = Products.category1.items.findIndex((element) => element.name === window.currentSelected.category1);
      if (window.pauseRendering || window.pauseIconClick || window.pauseClick) return;

      //evnt.persist();
      window.pauseClick = true;
      window.pauseIconClick = true;
      const e = Object.assign({}, evnt); //AAATONI

      if (evnt !== undefined) {
         if (e.nativeEvent.path !== undefined) {
            var cardIndex = e.nativeEvent.path.findIndex((element) => element.classList.contains("cartMainDiv"))
            // console.log(cardIndex)
            var elem = e.nativeEvent.path[cardIndex];

            // console.log(elem.id);
         } else if (navigator.appCodeName == 'Mozilla') {
            // console.log(e)
            var elem = e.currentTarget
         }
         else {
            var elem = e.nativeEvent.toElement.lastChild.parentElement.parentElement.parentElement;
            // console.log(e);
         }
      }


      if (divID != undefined) {
         var x = document.getElementById(divID);
         elem = x;
      }

      // console.log(e.currentTarget.id);
      // console.log("********************** Yes");
      // console.log(elem);
      window.localStorage.setItem('current_product', elem.id);
      //window.$("#maincanvasContainer").fadeOut(300,function (element) {
      // document.querySelector('.cartMainDiv.selected').classList.remove("selected");
      // document.getElementById(elem.id).classList.add("selected");
      var itemToAdd = null;
      var previousItem = null;
      // Always selected menu
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'

     
      if (expanded == 'panel1') {
         // document.querySelector('#container').style.pointerEvents = "none";
         itemToAdd = Products.category1.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category1.items.findIndex((element) => element.id === window.currentSelected.category1);

         console.log("panel1");
         // console.log(Products.category1.items[itemToAdd].productShow);



         window.currentSelected.category1 = elem.id;
         document.querySelector('#panel1bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         //this is for temporary 
         window.scene.instanceSet('SMD3070_Screen_Anim', 'visible', true);

         window.stopAllAnim();

         if (document.getElementById(window.currentSelected.category1 + '_open_drawer_text') != null) {
            document.getElementById(window.currentSelected.category1 + '_open_drawer_text').innerHTML = "Open Drawer";
         }
         if (document.getElementById(window.currentSelected.category1 + '_control_panel_text') != null) {
            // document.getElementById(window.currentSelected.category1 + '_control_panel_text').innerHTML = "View the Control Panel";
         }
         if (previousItem === itemToAdd) {
            return;
         }
         if (document.getElementById("SMD3070ASS_Drawer_Oven").classList.contains('selected')) {

            console.log("##SMD3070ASS_Drawer_Oven##");

            document.getElementById("drawer24").style.visibility = "hidden"; //@uthor YK
            window.setTimeout(function () {
               window.$('#select_SMD3070AS_drawer').attr('checked', false);
               window.$('#select_SMD3070AS_walloven').attr('checked', false);
               window.$('#radioBtn1').removeClass('checked1');
               window.$('#radioBtn2').removeClass('checked2');
            }, 500)
            document.getElementById("animContainer").style.display = "none";
            document.getElementById("internalcalloutsContainer").style.display = "none";

            window.draweOvenInterval = setInterval(function () {
               console.log('check if drawer is selected??????????????');
               if (window.check_SMD3070AS == false) {
                  firstDrawerDemo(itemToAdd, previousItem);
                  clearInterval(window.draweOvenInterval);

                  displayTextsOnCompleted = function () {

                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_13');
                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_14');
                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_15');

                  };

                  window.scene.groupApplyState('table_on');
                  window.scene.groupApplyState('SMD3070ASS_Oven_Self_on');
                  window.scene.clearRefine();
               }

            }, 1000)
            if (window.check_SMD3070AS) {

               document.getElementById("select_SMD3070AS").style.display = "flex";
               document.getElementById("container_accordian").style.display = "none";

               window.hideClickToAnimation();
               if (window.pauseIconClick) return;
               window.pauseIconClick = true;

               if (window.pauseClick) return;
               window.pauseClick = true;

               window.check_SMD3070AS = false;
            } else {
               window.check_SMD3070AS = true;
            }


         } else {

            if (window.currentSelected.category2 == 'SMD3070AS') {
               window.currentSelected.category2 = "SWA3052DS";
            }


            // set all values to local storage except 30"
            window.localStorage.setItem('microwave', Products.category1.items[itemToAdd].productShow);

            // set special condition to localstorage for SMD499FS drawer
            if (Products.category1.items[itemToAdd].productShow == "SMD2449FS_on") {
               window.localStorage.setItem('microwave', 'SMD2499FS_on');
            }


            window.check_SMD3070AS = true;
            window.SMD3070ASStatus.selectedModel = "";
            window.SMD3070ASWallovenToDrawer = '';
            firstDrawerDemo(itemToAdd, previousItem); //AAATONI.
            window.scene.groupApplyState('microwave_Table_Big_door_On');
            window.scene.groupApplyState('SMD3070ASS_Oven_Self_off');

            document.getElementById("select_SMD3070AS").style.display = "none";
            window.scene.clearRefine();

         }

         if (document.getElementById("KB6524PSY").classList.contains('selected') || document.getElementById("SMD3070ASS_Drawer_Oven").classList.contains('selected')) {
            document.getElementById("panel11bh-header").classList.add("opacityCard");
            document.getElementById("category11").classList.add("opacityCard");
         }else{
            document.getElementById("panel11bh-header").classList.remove("opacityCard");
            document.getElementById("category11").classList.remove("opacityCard");
         }



      } else if (expanded == 'panel2') {
         itemToAdd = Products.category2.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category2.items.findIndex((element) => element.id === window.currentSelected.category2);

         // console.log("Panel 2 group state *********");
         // console.log(itemToAdd);
         // console.log(Products.category2.items[itemToAdd].productShow);

         window.currentSelected.category2 = elem.id;

         document.querySelector('#panel2bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('wall_oven', Products.category2.items[itemToAdd].productShow);

         window.stopAllAnim();

         if (document.getElementById(window.currentSelected.category2 + '_wall_oven_text') != null) {
            document.getElementById(window.currentSelected.category2 + '_wall_oven_text').innerHTML = "Open Oven";
            // console.log('text')
         }
         if (document.getElementById(window.currentSelected.category2 + '_oven_panel_text') != null) {
            document.getElementById(window.currentSelected.category2 + '_oven_panel_text').innerHTML = "Control Panel";
         }
         if (document.getElementById("SMD3070AS").classList.contains('selected')) {

            setTimeout(() => {

               window.scene.gotoPosInTime(0.7722699999999995, 0.021736, -15.897910034865845, -4.236294529364063, 214.66329650582966, 1000, function () { window.scene.groupApplyState('wall_ovan_2in1_off') }, window.slowinout2);

            }, 2000);

         }
         if (document.getElementById("SWB3052DS").classList.contains('selected')) {

            setTimeout(() => {
               if (window.SMD3070ASStatus.selectedModel != 'SMD3070AS_walloven') {
                  window.scene.gotoPosInTime(1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.6029752581640646, 214.66329650582966, 1000, function () { }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });

               }

            }, 2000);

         }
         if (document.getElementById("SWB3052GS").classList.contains('selected')) {

            setTimeout(() => {
               if (window.SMD3070ASStatus.selectedModel != 'SMD3070AS_walloven') {
                  window.scene.gotoPosInTime(1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.6029752581640646, 214.66329650582966, 1000, function () { }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });

               }

            }, 2000);

         }
         if (document.getElementById("SWA3052DS").classList.contains('selected')) {

            setTimeout(() => {
               // alert('##'+window.SMD3070ASStatus.selectedModel)
               if (window.SMD3070ASStatus.selectedModel != 'SMD3070AS_walloven') {

                  window.scene.gotoPosInTime(1.204889788350463, 0.1845901777476891, -22.657609373593054, -1.6360708802969677, 134.06101132436365, 1000, function () { }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
               }
            }, 2000);
            window.scene.groupApplyState('wall_ovan_2in1_on');

         }
         if (document.getElementById("SWA3052GS").classList.contains('selected')) {

            setTimeout(() => {
               // alert('##'+window.SMD3070ASStatus.selectedModel)
               if (window.SMD3070ASStatus.selectedModel != 'SMD3070AS_walloven') {
                  window.scene.gotoPosInTime(1.204889788350463, 0.1845901777476891, -22.657609373593054, -1.6360708802969677, 134.06101132436365, 1000, function () { }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });

               }
            }, 2000);
            window.scene.groupApplyState('wall_ovan_2in1_on');

         }

         if (document.getElementById("SMD3070AS").classList.contains('selected')) {

            window.currentSelected.category2 = 'SWA3052DS';
            window.localStorage.setItem('wall_oven', 'SWA3052DS_on');
            document.getElementById('SWB3052DS').classList.remove('selected');
            document.getElementById('SWB3052GS').classList.remove('selected');
            document.getElementById('SSC2489GS').classList.remove('selected');

         }
         if (previousItem === itemToAdd) {
            return;
         }
         secondDrawerDemo(itemToAdd, previousItem);
      }
      else if (expanded == 'panel3') {
         itemToAdd = Products.category3.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category3.items.findIndex((element) => element.id === window.currentSelected.category3);

         //AAATONI window.scene.groupApplyState(Products.category3.items[itemToAdd].productShow);
         window.currentSelected.category3 = elem.id;
         document.querySelector('#panel3bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('refrigerator', Products.category3.items[itemToAdd].productShow);


         window.stopAllAnim();
         if (document.getElementById(window.currentSelected.category3 + '_refrigerator_door_text') != null) {
            document.getElementById(window.currentSelected.category3 + '_refrigerator_door_text').innerHTML = "Open Door";
            // console.log(window.currentSelected.category3,'textchange')
         }

         if (previousItem === itemToAdd) {
            return;
         }
         thirdDrawerDemo(itemToAdd, previousItem);

      }
      else if (expanded == 'panel4') {
         itemToAdd = Products.category4.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category4.items.findIndex((element) => element.id === window.currentSelected.category4);

         window.currentSelected.category4 = elem.id;
         document.querySelector('#panel4bh-content' + ' .cartMainDiv.selected').classList.remove("selected");

         
         document.getElementById(elem.id).classList.add("selected");
         window.localStorage.setItem('dishwasher', Products.category4.items[itemToAdd].productShow);
         console.log(Products.category4.items[itemToAdd].productShow)
         window.stopAllAnim();

         if (document.getElementById(window.currentSelected.category4 + '_dishwasher_text') != null) {
            document.getElementById(window.currentSelected.category4 + '_dishwasher_text').innerHTML = "Open";
            console.log(window.currentSelected.category4, 'textchange')
         }

         if (previousItem === itemToAdd) {
            return;
         }
         fourthDrawerDemo(itemToAdd, previousItem);
      }
      else if (expanded == 'panel5') {
         itemToAdd = Products.category5.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category5.items.findIndex((element) => element.id === window.currentSelected.category5);


         window.currentSelected.category5 = elem.id;
         document.querySelector('#panel5bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('cooktop', Products.category5.items[itemToAdd].productShow);
         window.stopAllAnim();
         if (previousItem === itemToAdd) {
            return;
         }
         console.log('### fifthDrawer');
         fifthDrawerDemo(itemToAdd, previousItem);

      }
      else if (expanded == 'panel6') {
         itemToAdd = Products.category6.items.findIndex((element) => element.id === elem.id);
         previousItem = Products.category6.items.findIndex((element) => element.id === window.currentSelected.category6);
         var previousItem7 = Products.category7.items.findIndex((element) => element.id === window.currentSelected.category7);


         window.currentSelected.category6 = elem.id;
         document.querySelector('#panel6bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('rangehood', Products.category6.items[itemToAdd].productShow);

         window.stopAllAnim();

         if (window.mob) {
            window.scene.gotoPosInTime(2.107800541229233, -0.1277788857512855, 10.522524798176256, 6.9890517124872888, 127.95918253135886, 1000, undefined, window.slowinout2);

         } else {
            console.log("calling sixth from panel");

         }

         if (document.getElementById("SHC3042FS").classList.contains('selected')) {
            document.querySelector("#SHC3042FS .downloadSpecSix").style.display = 'none';
         }

         if (previousItem === itemToAdd) {
            return;
         }
         sixthDrawerDemo(itemToAdd, previousItem, previousItem7);
      }
      else if (expanded == 'panel7') {
         itemToAdd = Products.category7.items.findIndex((element) => element.id === elem.id);
         previousItem = Products.category7.items.findIndex((element) => element.id === window.currentSelected.category7);
         var previousItem6 = Products.category6.items.findIndex((element) => element.id === window.currentSelected.category6);


         window.currentSelected.category7 = elem.id;
         document.querySelector('#panel7bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('over_range', Products.category7.items[itemToAdd].productShow);

         window.stopAllAnim();

         if (window.mob) {
            window.scene.gotoPosInTime(2.107800541229233, -0.1277788857512855, 10.522524798176256, 6.9890517124872888, 127.95918253135886, 1000, undefined, window.slowinout2);

         } else {
            console.log("calling seventh from panel");


         }

         if (previousItem === itemToAdd) {
            return;
         }
         seventhDrawerDemo(itemToAdd, previousItem, previousItem6);
      }
      else if (expanded == 'panel77777') {
         console.log("panel7");
         itemToAdd = Products.category7.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category7.items.findIndex((element) => element.id === window.currentSelected.category7);

         console.log(itemToAdd, previousItem);


         window.currentSelected.category7 = elem.id;
         document.querySelector('#panel7bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");
         window.localStorage.setItem('over_range', Products.category7.items[itemToAdd].productShow);
         if (document.getElementById(window.currentSelected.category7 + '_over_range_text_open') != null) {
            document.getElementById(window.currentSelected.category7 + '_over_range_text_open').innerHTML = "Open Microwave";
         }
         if (previousItem === itemToAdd) {
            return;
         }
         console.log(itemToAdd, previousItem);
         seventhDrawerDemo(itemToAdd, previousItem);
      } else if (expanded == 'panel8') {
         itemToAdd = Products.category8.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category8.items.findIndex((element) => element.id === window.currentSelected.category8);

         // console.log("Panel 2 group state *********");
         // console.log(itemToAdd);
         // console.log(Products.category8.items[itemToAdd].productShow);

         window.currentSelected.category8 = elem.id;

         // document.querySelector('#panel8bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('wall_oven', Products.category8.items[itemToAdd].productShow);

         window.stopAllAnim();
         

         if (document.getElementById(window.currentSelected.category8 + '_wall_oven_text') != null) {
            document.getElementById(window.currentSelected.category8 + '_wall_oven_text').innerHTML = "Open Oven";
            // console.log('text')
         }
         if (document.getElementById(window.currentSelected.category8 + '_oven_panel_text') != null) {
            document.getElementById(window.currentSelected.category8 + '_oven_panel_text').innerHTML = "Control Panel";
         }
         if (document.getElementById("SWB3085HS").classList.contains('selected')) {
            window.scene.groupApplyState('SWB3052DS_off');
            document.getElementById("panel11bh-header").classList.add("opacityCard");
            document.getElementById("category11").classList.add("opacityCard");
            setTimeout(() => {

               window.scene.gotoPosInTime(1.31955506266146, -0.03542038991033637, -8.853827071541772, -3.602975258164064, 214.66329650582966, 1000, function () { }, window.slowinout2);

            }, 2000);


         }
         if (previousItem === itemToAdd) {
            return;
         }
         eighthDrawerDemo(itemToAdd, previousItem);
      } else if (expanded == 'panel9') {

         console.log("expand_panel9");
         itemToAdd = Products.category9.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category9.items.findIndex((element) => element.id === window.currentSelected.category9);


         window.currentSelected.category9 = elem.id;
         document.querySelector('#panel9bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('combo_cooktop', Products.category9.items[itemToAdd].productShow);
         if (window.mob) {
            window.scene.gotoPosInTime(1.1738393715580993, 0.5584866776461629, -12.218268501958836, 4.368326018130022, 295, 1000, undefined, window.slowinout2);

         } else {
            window.scene.gotoPosInTime(1.1738393715580993, 0.5584866776461629, -26.218268501958836, 4.368326018130022, 270, 1000, undefined, window.slowinout2);

         }
         window.stopAllAnim();
         if (previousItem === itemToAdd) {
            return;
         }
         ninthDrawerDemo(itemToAdd, previousItem);
         // Enable Popup for combo cooktop
         document.getElementById("select_STR3065HS").style.display = "flex";
         document.getElementById("select_cooktop").style.display = "none";

         window.pauseIconClick = false;


      } else if (expanded == 'panel10') {

         // console.log("expand_panel10");
         itemToAdd = Products.category10.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category10.items.findIndex((element) => element.id === window.currentSelected.category10);

         // console.log("element ID", elem.id)
         window.currentSelected.category10 = elem.id;
         document.querySelector('#panel10bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         window.localStorage.setItem('ranges', Products.category10.items[itemToAdd].productShow);
         if (window.mob) {
            var temp_array = [1.0780228394506648, 0.3107990595397148, -4.0863900941049085, -29.902466457453913, 270];
         } else {
            var temp_array = [1.0780228394506648, 0.3107990595397148, -4.0863900941049085, -45, 250];

         }
         // alert("7290")
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
            window.scene.setDoFTargetObject("new_sharp_cooktop-0");

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_cooktop-0", true) });
         window.stopAllAnim();
         if (previousItem === itemToAdd) {
            return;
         }
         tenthDrawerDemo(itemToAdd, previousItem);
         // Enable Popup for combo cooktop
         // document.getElementById("select_STR3065HS").style.display = "flex";
         // document.getElementById("select_cooktop").style.display = "none";

         window.pauseIconClick = false;
      }
      else if (expanded == 'panel11') {
         // console.log("expand_panel10");
         itemToAdd = Products.category11.items.findIndex((element) => element.id == elem.id);
         previousItem = Products.category11.items.findIndex((element) => element.id === window.currentSelected.category11);

         // console.log("element ID", elem.id)
         window.currentSelected.category11 = elem.id;
         document.querySelector('#panel11bh-content' + ' .cartMainDiv.selected').classList.remove("selected");
         document.getElementById(elem.id).classList.add("selected");

         console.log(Products.category11.items[itemToAdd].productShow)

         window.localStorage.setItem('pedestal', Products.category11.items[itemToAdd].productShow);
         window.stopAllAnim();
         if (previousItem === itemToAdd) {
            return;
         }
         eleventhDrawerDemo(itemToAdd, previousItem);

         window.pauseIconClick = false;
      }
      // });
      setTimeout(function () {
         window.$('#scroll_panel').scrollTop(window.menuScrollTop);
      }, 2000)

   }

   let allIcon = document.querySelectorAll('.icon_stable');
   var table = false;
   //var fDrawer = true;
   var hotspots = document.getElementsByClassName('hotspot');
   var animations = document.getElementsByClassName('animation');


   const hideInternals = () => {
      if (window.currentConfig.hideVisibleInternal == "") {

         return;
      } else {
         window.scene.groupApplyState("'" + window.currentConfig.hideVisibleInternal + "'");
         // console.log('hide',window.currentConfig.hideVisibleInternal)
      }

   }

   const distributor = () => {
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
         if (this.readyState == 4 && this.status == 200) {
            var ldata = JSON.parse(this.responseText);
            // var ldata = (this.responseText);
            // console.log(ldata[0].distributor);
            // console.log('ldata',ldata.distributor);
            distributor_data = ldata[0].distributor;
         }
      };
      xhttp.open("GET", "https://www.hmxmedia.com/wp-content/sharp/distributor-v4.php", true);
      xhttp.send();

   }

   distributor();

   const firstDrawer = () => {

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      if (window.SMD3070AS_drawer_install) {
         console.log("window.SMD3070AS_drawer_install already selected");
         // return;
      }

      window.HideAlldrawers();

      if (window.pauseIconClick) return;
      window.pauseIconClick = true;
      console.log('*** AAATONI firstDrawer');
      console.log(window.SMD3070ASStatus.selectedModel);
      console.log(window.currentSelected.category1);
      var itemToAdd = Products.category1.items.findIndex((element) => element.name === window.currentSelected.category1);
      if (itemToAdd < 0) {
         itemToAdd = 0;
      }
      console.log(itemToAdd);
      if (window.pauseRendering) return;
      if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_walloven') {
         window.select_SMD3070AS('select_SMD3070AS_walloven');

         window.$('.icon_stable.selectDrawer').removeClass('selectDrawer');
         window.$('#category1').addClass('selectDrawer');
         setExpanded('panel1');
         setTimeout(function () {
            window.setMenuScroll('panel1bh-header')
         }, 500);
         document.getElementById("SMD3070AS_control_panel_text").innerHTML = "Control Panel";
         document.getElementById("SMD3070AS_open_drawer_text").innerHTML = "Open Drawer";
         var animations = document.getElementsByClassName('animation');

         for (var i = 0; i < animations.length; i++) {
            animations[i].style.visibility = 'hidden';
         }
         // window.delaysecondpanelIntersect();
         setTimeout(function () {
            window.scene.gotoPosInTime(0.7722699999999993, 0.021736, -10.819723820266901, -29.537376308222903, 191.63863092705785, 1000, undefined, undefined, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
            window.updateCalloutPopupVisibility('SMD3070ASS_Drawer_Oven', 'SMD3070AS_allDrawerss');
            window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_3');
            window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_4');
            window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_16');
            window.scene.clearRefine();
         }, 200)

         // } 
         return;
      } else if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_drawer') {
         // Handling Double Camera angle
         window.SMD3070AS_drawer_install = true;

         console.log("Inside SMD3070AS_drawer");

         if (window.STR3065HS_table_cooktop) {

            console.log("window.STR3065HS_table_cooktop Condition");

            document.getElementById("hotspot9").style.visibility = 'hidden';
            document.getElementById("hotspot10").style.visibility = 'hidden';

            // this is for Island table cooktop
            window.scene.groupApplyState('STR3065HS_Table_OFF', {}, function () {
               window.scene.groupApplyState('Old_Centre_Table_ON');

            });
            window.scene.groupApplyState('Marble_Fill_OFF');
            window.scene.groupApplyState('Rangehood_Cabinet_OFF');

            // Enable last selected Range Hood
            window.scene.groupApplyState(window.localStorage.getItem('rangehood'));

            // Enable Microwave
            window.scene.groupApplyState(window.localStorage.getItem('microwave'));
            window.scene.groupApplyState('New_Drawer_Part_Off');

            // Enable last selected Cooktop
            window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
            window.STR3065HS_table_cooktop = false;

         }
         if (window.STR3065HS_cooktop) {
            console.log("Cooktop Combo for first Drawer Demo");

            // this is for side platform cooktop
            window.scene.groupApplyState('Cooktop_Regular_Cabinet_On');
            window.scene.groupApplyState('Marble_Fill_OFF');
            window.scene.groupApplyState('STR3065HS_OFF');

            // Enable last selected Cooktop
            window.scene.groupApplyState(window.localStorage.getItem('cooktop'));

            setTimeout(() => {
               window.scene.groupApplyState('New_Drawer_Part_Off');

               // Enable Microwave
               window.scene.groupApplyState(window.localStorage.getItem('microwave'));

            }, 2000);

            window.STR3065HS_cooktop = false;

         }
         if (window.SWB3085HS_walloven) {


            window.SWB3085HS_walloven = false;

            window.scene.groupApplyState('SWB3085HS_OFF', {}, function () {

               window.scene.groupApplyState('SWB3085HS_INT_OFF');

               window.scene.groupApplyState('Double_self_on');

               // Enable last selected Cooktop
               window.scene.groupApplyState(window.localStorage.getItem('wall_oven'));

               setTimeout(() => {

                  window.scene.groupApplyState('New_Drawer_Part_Off');
                  window.scene.groupApplyState('SMD3070ASS_Oven_Self_on');

                  // window.scene.groupApplyState('Double_self_on');

               }, 1500);

            });
         }

         window.select_SMD3070AS('select_SMD3070AS_drawer');
         window.$('.icon_stable.selectDrawer').removeClass('selectDrawer');
         window.$('#category1').addClass('selectDrawer');
         setExpanded('panel1');
         setTimeout(function () {
            window.setMenuScroll('panel1bh-header')
         }, 500);

         // firstDrawerDemo(5);
         // firstDrawerDemo(0);
         window.cookTop = false;
         window.overTheRange = false;
         window.hoodRange = false;
         window.comboCookTop = false;

         window.yMinLimit = 3.4721705271702347;
         window.yMaxLimit = 2.4192280571000184;
         window.valueForMin = 6;
         window.valueForMax = 0;
         window.setZoomValue(-60, -35, 60, 30, 140, 165, 130);
         window.scene.setDoFTargetObject("new_sharp_tableoven-0");
         window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
         setTimeout(() => {
            window.scene.groupApplyState('Table_on');
         }, 1000);
         window.setTimeout(function () {
            window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_on', {}, function () {
               window.scene.groupApplyState('SMD3070ASS_Oven_Self_on');
               window.scene.groupApplyState('microwave_Table_Big_door_Off');
               window.scene.groupApplyState('SMD3070AS_in_color_close');
            });
         }, 1000);

         window.scene.groupApplyState('microwave_Table_Big_door_off'); window.scene.groupApplyState('microwave_Table_Big_door_off');
         var temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 30, 152.46605138838333];
         window.HideAlldrawers();
         window.hide_drawer_callouts_anim();
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            // This GOTOPOS should come after the async functions
            // console.log("calling delayfirstpanelIntersect start");
            window.scene.groupApplyState('Side_Table_off');
            window.delayfirstpanelIntersect();
            // console.log("calling delayfirstpanelIntersect end");
            window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_13');
            window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_14');
            window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_15');

            // Off all Dishwasher to remove Intersection
            window.scene.groupApplyState('SDW6757ES_off');
            window.scene.groupApplyState('SDW6747GS_off');
            window.scene.groupApplyState('SDW6767HS_off');
            window.scene.groupApplyState('SDW6888JS_OFF');
            window.scene.groupApplyState('SDW6506JS_off');


            window.scene.clearRefine();
            setTimeout(function () {
               //  window.FadeInSharp();
               document.getElementById("animContainer").style.display = "block";
               document.getElementById("internalcalloutsContainer").style.display = "block";
               document.getElementById("container_accordian").style.display = "block";
               window.updateCalloutPopupVisibility('SMD3070ASS_Drawer_Oven', 'SMD3070ASS_Drawer_Oven_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
               window.updateCalloutPopupVisibility('SMD3070AS', 'SMD3070AS_allDrawerss');
               document.getElementById('infoIcon').style.display = 'none';
               document.getElementById('reset_canvas').style.display = 'none';
               window.$('#pointsContainer').show();
            }, 4000)

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });

         var animations = document.getElementsByClassName('animation');

         for (var i = 0; i < animations.length; i++) {
            animations[i].style.visibility = 'hidden';
         }
         document.getElementById("hotspot4").style.visibility = 'hidden';
         document.getElementById("SMD3070ASS_Drawer_Oven_control_panel_text").innerHTML = "Control Panel";
         document.getElementById("SMD3070ASS_Drawer_Oven_open_drawer_text").innerHTML = "Open Drawer";
         document.getElementById("SMD3070ASS_Drawer_Oven_microwave_drawer_build_walloven_text").innerHTML = "Install beneath a single, built-in wall oven";
         document.getElementById("hotspot6").style.visibility = "hidden";
         document.getElementById("hotspot7").style.visibility = "hidden";
         window.scene.animPlayInTime('SMD3070AS_Drrawerr_case', 0, 1);
         window.scene.animPlayInTime('SMD3070AS_Drrawer_screen', 0, 1);
         window.scene.clearRefine();
         return;
      }


      firstDrawerDemo(itemToAdd);
      return;


   }
   const secondDrawer = () => {
      console.log("secondDrawer");
      // window.internalFadeInSharp();
      // if(second_Drawer){
      //   setExpanded('panel2');
      //   second_Drawer = false;
      //  }else {
      //   //setExpanded(false);
      //   second_Drawer = true;
      //  }
      if (window.pauseIconClick) return;
      window.pauseIconClick = true;
      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }
      // console.log('*** AAATONI secondDrawer');
      var itemToAdd = Products.category2.items.findIndex((element) => element.name === window.currentSelected.category2);
      if (window.pauseRendering) return;

      secondDrawerDemo(itemToAdd);
      return;
   }
   const thirdDrawer = () => {
      if (window.pauseIconClick) return;
      window.pauseIconClick = true;
      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }
      // console.log('*** AAATONI thirdDrawer');
      var itemToAdd = Products.category3.items.findIndex((element) => element.name === window.currentSelected.category3);
      thirdDrawerDemo(itemToAdd);
      return;
   }
   const fourthDrawer = () => {
      if (window.pauseIconClick) return;
      window.pauseIconClick = true;
      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      
      // console.log('*** AAATONI fourthDrawer');
      var itemToAdd = Products.category4.items.findIndex((element) => element.name === window.currentSelected.category4);
      fourthDrawerDemo(itemToAdd);

      return;
   }
   const fifthDrawerTrigger = () => {

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      document.getElementById("select_cooktop").style.display = "flex";
      document.getElementById("select_STR3065HS").style.display = "none";

      document.getElementById("main-menu").style.pointerEvents = "none";

      var hideAllCallouts = document.getElementsByClassName('allDrawers');
      for (var i = 0; i < hideAllCallouts.length; i++) {
         hideAllCallouts[i].style.display = 'none';
      }

      var animations = document.getElementsByClassName('animation');

      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }

      var internalcallout = document.getElementsByClassName('internalcallout');

      for (var i = 0; i < internalcallout.length; i++) {
         internalcallout[i].style.visibility = 'hidden';
      }

      document.getElementById('demoDiv').style.height = '1230px';
      if (expanded == 'panel2') {
         // console.log("here is panel 2 fifth expanded");
         document.getElementById("scroll_panel").scrollTo(0, 250);
      } else if (expanded == 'panel3') {
         // console.log("here is panel3 in fifth else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 425);
      } else if (expanded == 'panel7') {
         // console.log("here is panel7 in fifth else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 405);
      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 246);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 240);
         }
      }
      setTimeout(function () {
         window.setMenuScroll('panel5bh-header')
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category5.icon_stable').classList.add('selectDrawer');

      setExpanded('panel5');
   }
   const fifthDrawer = () => {
      if (window.pauseIconClick) return;
      window.pauseIconClick = true;
      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      console.log('*** AAATONI fifthDrawer');
      var itemToAdd = Products.category5.items.findIndex((element) => element.name === window.currentSelected.category5);
      document.getElementById("select_cooktop").style.display = "none";

      fifthDrawerDemo(itemToAdd);
      return;

   }
   // var hoodRange = false;
   const sixthDrawer = () => {
      if (window.pauseIconClick) return;
      window.pauseIconClick = true;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      // console.log('*** AAATONI sixthDrawer');
      var itemToAdd = Products.category6.items.findIndex((element) => element.name === window.currentSelected.category6);

      sixthDrawerDemo(itemToAdd);
      return;
   }
   const seventhDrawer = () => {
      // window.internalFadeInSharp();
      // if(seventh_Drawer){
      //   setExpanded('panel7');
      //   seventh_Drawer = false;
      //  }else {
      //  // setExpanded(false);
      //   seventh_Drawer = true;
      //  }
      if (window.pauseIconClick) return;
      window.pauseIconClick = true;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }
      // console.log('*** AAATONI seventhDrawer');
      var itemToAdd = Products.category7.items.findIndex((element) => element.name === window.currentSelected.category7);

      seventhDrawerDemo(itemToAdd);
      return;
   }
   const eighthDrawer = () => {
      // window.internalFadeInSharp();
      // if(eighth_Drawer){
      //   setExpanded('panel2');
      //   eighth_Drawer = false;
      //  }else {
      //   //setExpanded(false);
      //   eighth_Drawer = true;
      //  }

      // temporary return
      // return;

      if (window.pauseIconClick) return;
      window.pauseIconClick = true;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      // console.log('*** AAATONI eighthDrawer');
      var itemToAdd = Products.category8.items.findIndex((element) => element.name === window.currentSelected.category8);
      if (window.pauseRendering) return;

      eighthDrawerDemo(itemToAdd);
      return;

   }
   const ninthDrawer = () => {
      console.log("ninthDrawer");

      if (window.pauseIconClick) return;
      window.pauseIconClick = true;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      // console.log('*** AAATONI ninthDrawer');
      var itemToAdd = Products.category9.items.findIndex((element) => element.name === window.currentSelected.category9);
      if (window.pauseRendering) return;
      // alert(itemToAdd);

      ninthDrawerDemo(itemToAdd);
      return;
   }
   const tenthDrawer = () => {
      console.log("tenthDrawer");

      if (window.pauseIconClick) return;
      window.pauseIconClick = true;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      var itemToAdd = Products.category10.items.findIndex((element) => element.name === window.currentSelected.category10);
      if (window.pauseRendering) return;

      // alert(itemToAdd);
      tenthDrawerDemo(itemToAdd);
      return;


   }
   const eleventhDrawer = () => {
      console.log("elventhDrawer");

      if (window.pauseIconClick) return;
      window.pauseIconClick = true;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }

      var itemToAdd = Products.category11.items.findIndex((element) => element.name === window.currentSelected.category11);
      if (window.pauseRendering) return;

      // alert(itemToAdd);
      eleventhDrawerDemo(itemToAdd);
      return;


   }


   async function firstDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         if (!window.preventFade) {
            await window.FadeInSharp(); //AAATONI
         } else {
            window.preventFade = false;
            window.pauseIconClick = false;
            window.pauseClick = false;
         }
         // await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      window.scene.setDoFTargetObject("new_sharp_tableoven-0");
      document.getElementById('internalLoader').classList.remove('show');
      window.scene.clearRefine();
      if (cb) {
         setTimeout(function c1() {
            if (window.ranges_position == 'side') {
               document.getElementById("hotspot11").style.visibility = 'visible';
               document.getElementById("hotspot2").style.visibility = 'hidden';
            } else {
               document.getElementById("hotspot2").style.visibility = 'visible';
               document.getElementById("hotspot11").style.visibility = 'hidden';
            }

            document.getElementById("hotspot3").style.visibility = 'visible';
            cb();
         }, bCategoryChanged ? 1800 : 800);
      }


   }

   //const firstDrawerDemo = (itemToAdd, previousItem) => {
   async function firstDrawerDemo(itemToAdd, previousItem) {

      let temp_congigurePlace = window.congigurePlace;

      window.congigurePlace = "first";

      var fridge_timer = 0;
      window.drawer_position = 'selected'
     
      document.getElementById('internalLoader').classList.remove('show');
      document.getElementById('internalLoader').classList.add('hide');
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";
      //// window.internalFadeInSharp();
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      console.log("********* firstDrawerDemo calling ************");
      // console.log(window.currentConfig.currentDrawer);
      // window.dishwasherToDrawer = false;
      // window.SMD3070ASStatus.selectedModel = '';

      // Al Drawer hide of SMD2499FS in mobile
      if (window.mob) {
         document.getElementById('SMD2499FS_allDrawerss').style.display = 'none';
      }
      // off covered cubbord
      window.scene.groupApplyState('New_Drawer_Part_Off');

      window.scene.groupApplyState('Old_Centre_Table_ON');
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');


      // Surbhi gotopos with conditions
      var temp_array;
     
      console.log("window.currentConfig.currentDrawer", window.currentConfig);
      if (window.currentConfig.currentDrawer == "walloven") {

         window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
        
         setTimeout(() => {
            window.scene.groupApplyState('Table_on');
         }, 1000);
         temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 30, 152.46605138838333];
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            // This GOTOPOS should come after the async functions
            // console.log("calling delayfirstpanelIntersect start");
            window.scene.groupApplyState('Side_Table_off');
            window.delayfirstpanelIntersect();
            // console.log("calling delayfirstpanelIntersect end");

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });

      } else if (window.currentConfig.currentDrawer == "ranges" || window.currentConfig.currentDrawer == "awards") {
         temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 30, 152.46605138838333];
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            window.scene.groupApplyState('Side_Table_off');
            window.delayfirstpanelIntersect();
            // window.ranges_position = "";

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
      }
      else if (window.currentConfig.currentDrawer == "comboWallOven") {

         console.log("window.currentConfig.currentDrawer", window.currentConfig.currentDrawer);

         console.log("the above condition is working for the walloven and microwave")
         console.log("window.currentSelected.category8 == SWB3085HS", window.currentSelected.category8);

         window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
         setTimeout(() => {
            window.scene.groupApplyState('Table_on');
         }, 1000);

         temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 60, 152.46605138838333];
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            // This GOTOPOS should come after the async functions
            // console.log("calling delayfirstpanelIntersect start");
            window.scene.groupApplyState('Side_Table_off');

            window.delayfirstpanelIntersectcategory8microwave();

            // console.log("calling delayfirstpanelIntersect end");

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
      }
      else if (window.currentConfig.currentDrawer == "dishwasher") {

         console.log("-----Inside the dishwasher ---------");
         window.scene.groupApplyState('Table_off'); 
         window.scene.groupApplyState('SMD2449FS_off');
         window.scene.groupApplyState(window.currentSelected.category1 + '_off');
         document.getElementById('internalLoader').classList.remove('show');
         document.getElementById('internalLoader').classList.add('hide');

         temp_array = [0.3839546928204136, 0.01747399999999999, -7.056169551853671, 80, 165.75512627108762];

         window.GotoPosInTimeNamedValue(temp_array, window.config.dishwasher, function () {

            // This GOTOPOS should come after the async functions
            // console.log("calling delayfirstpanelIntersect start");
            window.delayfirstpanelIntersect();
            // console.log("calling delayfirstpanelIntersect end");

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_dishwasher-0", true) });


         //end
         setTimeout(() => {
            window.scene.groupApplyState('Side_Table_off');
            window.scene.groupApplyState(window.currentSelected.category4 + '_off');
         }, 3500);

         if (document.getElementById('SMD3070AS').classList.contains('selected')) {
            window.scene.groupApplyState('SMD3070AS_in_on');
            window.scene.groupApplyState('Oven_3070AS_Table_Door_On');
            window.scene.groupApplyState('microwave_Table_Big_door_Off');
         }
      }
      else {


         window.currentConfig.currentDrawer = "microwave";
         console.log("-----Inside the else first ---------");
         // alert('Table onnnnn')   

         if (temp_congigurePlace == "third") {

            console.log("----- Coming From Fridge ---------");

            window.scene.groupApplyState('Old_Centre_Table_OFF');
            window.scene.groupApplyState('microwave_Table_Big_door_Off');
            window.scene.groupApplyState('Table_off');
            window.scene.groupApplyState('Without_Table_Shadow');

            // Remove all Microwave Drawer
            window.scene.groupApplyState('SMD2449FS_off');
            window.scene.groupApplyState('SMD2489ES_off');
            window.scene.groupApplyState('SMD2470ASY_off');
            window.scene.groupApplyState('SMD2470AH_off');
            window.scene.groupApplyState('KB6524PSY_off');
            window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_off');

            fridge_timer = 1700;

         }

         if (window.mob) {
            var temp_array = [2.616657, 0.00002599999999997049, 5.8600740700999925, -15.311314182589758, 152.46605138838333];
            window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
               document.querySelector('#container').style.pointerEvents = "auto";
               window.scene.groupApplyState('Side_Table_off');
            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
         } else {

            var temp_array = [2.616657, 0.000025999999999998247, 2.8600740700999916, -15.311314182589758, 152.46605138838333];
            window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
               document.querySelector('#container').style.pointerEvents = "auto";
               window.scene.groupApplyState('Side_Table_off');
               window.scene.groupApplyState('New_Drawer_Part_Off');
            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
         }
      }
      window.scene.setDoFTargetObject("MICROWAVE_88-0");
      window.scene.groupApplyState('SMD2470AH_in_off');
      setTimeout(() => {
         // Off all Dishwasher to remove Intersection
         window.scene.groupApplyState('SDW6757ES_off');
         window.scene.groupApplyState('SDW6747GS_off');
         window.scene.groupApplyState('SDW6767HS_off');
         window.scene.groupApplyState('SDW6888JS_OFF');
         window.scene.groupApplyState('SDW6506JS_off');

      }, 4000);
      //previousItem will be null when we call it from firstDrawer function.
      //use this feature to apply the special functionallity needed for firstDrawer().
      var bCategoryChanged = (previousItem == null) ? true : false;
      // var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      if (document.getElementById(window.currentSelected.category1 + '_open_drawer_text') != null) {
         document.getElementById(window.currentSelected.category1 + '_open_drawer_text').innerHTML = "Open Drawer";
      }
      if (document.getElementById(window.currentSelected.category1 + '_control_panel_text') != null) {
      }
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }

      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }

      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         // console.log("EEEeeeeeeewwwwwwww");
         // console.log(Products.category1.items[previousItem].id);
         if (!window.preventFade) {
            await window.FadeOutSharp(); //AAATONI
         }

         // console.log('AAATONI. after FadeOutSharp');
         // console.log('AAATONI. starting groupApplyStates');
         // //Hide previous appliance
      } else {
         window.scene.groupApplyState('Wall_oven_hide_part_on');
         window.scene.groupApplyState('Microwave_drawer_hide_On');
         setExpanded('panel1');
      }
      window.cookTop = false;
      window.overTheRange = false;
      window.hoodRange = false;
      window.comboCookTop = false;


      window.yMinLimit = 3.4721705271702347;
      window.yMaxLimit = 2.4192280571000184;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-60, -35, 60, 30, 140, 165, 130);
      // console.log("firstDrawerDemo");
      // console.log(window.currentSelected.category1);
      if (!window.scene.getInstanceByName("Table9-0").visible) {
         // window.scene.groupApplyState('Table_on');
         //AAATONI deferred obj
      }

      // console.log(window.currentConfig.hideVisibleInternal);
      hideInternals();

      if (bCategoryChanged) {
         //TODO: Question. Is it needed always? never?
         window.scene.groupApplyState('Microwave_drawer_hide_Off');
      }

      // Special condition if normal Drawer call from 30 inch model
      if (window.localStorage.getItem('wall_oven') == "SWA3052DS_on") {

         // off 30" inch model
         window.scene.groupApplyState('SMD3070AS_off');
         window.scene.groupApplyState('self_3070_new_off');

         // off single wall oven
         window.scene.groupApplyState('SWA3052DS_off');
         window.scene.groupApplyState('singal_oven_self_off');

         // on double wall oven as per CF
         window.scene.groupApplyState('SWB3052DS_on');
         window.scene.groupApplyState('SWB3052DS_internals_on');
         window.scene.groupApplyState('Double_self_on');

         window.localStorage.setItem('wall_oven', 'SWB3052DS_on');
         window.currentSelected.category2 = "SWB3052DS";

      }

      // Reset change View Control 
      document.getElementById("SMD2499FS_control_panel_text").innerHTML = "Control Panel";
      document.getElementById("SMD2489ES_control_panel_text").innerHTML = "Control Panel";
      document.getElementById("SMD2470ASY_control_panel_text").innerHTML = "Control Panel";
      document.getElementById("SMD2470AH_control_panel_text").innerHTML = "Control Panel";
      document.getElementById("KB6524PSY_control_panel_text").innerHTML = "Control Panel";
      document.getElementById("SMD3070ASS_Drawer_Oven_control_panel_text").innerHTML = "Control Panel";

      // Off Combo Cooktop  
      window.scene.groupApplyState('STR3065HS_Table_OFF');
      window.scene.groupApplyState('STR3065HS_OFF');
      
      if (window.STR3065HS_table_cooktop) {

         console.log('STR3065HS_table_cooktop');
         // this is for Island table cooktop
         window.scene.groupApplyState('STR3065HS_Table_OFF', {}, function () {
            window.scene.groupApplyState('Old_Centre_Table_ON');
            window.scene.groupApplyState('Double_self_on');
         });
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('Rangehood_Cabinet_OFF');

         // Enable last selected Range Hood
         window.scene.groupApplyState(window.localStorage.getItem('rangehood'));

         // Enable Microwave
         window.scene.groupApplyState(window.localStorage.getItem('microwave'));
         window.scene.groupApplyState('New_Drawer_Part_Off');

         // Enable last selected Cooktop
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));

         window.STR3065HS_table_cooktop = false;

      }
      if (window.STR3065HS_cooktop) {

         console.log("STR3065HS_cooktop");

         console.log("Cooktop Combo for first Drawer Demo");

         // this is for side platform cooktop
         window.scene.groupApplyState('Cooktop_Regular_Cabinet_On');
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('STR3065HS_OFF');
         window.scene.groupApplyState('New_Drawer_Part_Off');
         // Enable last selected Cooktop
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
         setTimeout(() => {
            window.scene.groupApplyState('New_Drawer_Part_Off');
            // Enable Microwave
            window.scene.groupApplyState(window.localStorage.getItem('microwave'));

         }, 1200);

         window.STR3065HS_cooktop = false;

      }
      setTimeout(function () {
         // Off SWB product from walloven
         if (window.SWB3085HS_walloven) {
            window.SWB3085HS_walloven = false;
            // Enable last selected Cooktop
            window.scene.groupApplyState(window.localStorage.getItem('wall_oven'));
            window.scene.groupApplyState('SWB3085HS_OFF', {}, function () {
               setTimeout(() => {
                  window.scene.groupApplyState('SWB3085HS_INT_OFF');
                  if (window.currentSelected.category2 == "SSC2489GS") {
                     window.scene.groupApplyState('Double_self_off');
                  } else if (window.currentSelected.category2 == "SWA3052DS" || window.currentSelected.category2 == "SWA3052GS") {
                     window.scene.groupApplyState('Double_self_off');
                     window.scene.groupApplyState('singal_oven_self_on');
                  }
               }, 1200);
            });
         }
      }, 2000);
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      // alert(window.currentSelected.category1);
      //use switch case
      window.TrophyHotspot = false;
      window.hideAlexaBoxCallouts();
      window.reverseState();
      if (!(window.currentSelected.category1 == 'KB6524PSY' || window.currentSelected.category1 == 'SMD3070ASS_Drawer_Oven')) {
            window.pedestalAddRemove();
            window.pedestalCompability = true;
      }

      if ((window.currentSelected.category1 == 'KB6524PSY' || window.currentSelected.category1 == 'SMD3070ASS_Drawer_Oven')) {
         window.pedestalCompability = false;
      }
   window.pedestalComp();
      window.pedestalHotspotVisibilty();
      window.clearPreviousSelectedAwardHotspot();
      switch (window.currentSelected.category1) {
         case 'SMD2499FS':
            document.getElementById('internalLoader').classList.remove('show');
            document.getElementById('internalLoader').classList.add('hide');
            setTimeout(() => {
               window.scene.groupApplyState('Table_on', {}, function () {
                  window.scene.groupApplyState('SMD2449FS_On', {}, function () {
                     window.scene.groupApplyState('SMD2449FS_On');
                     window.scene.groupApplyState('With_Table_Shadow');
                     window.scene.groupApplyState('microwave_Table_Big_door_On');
                     window.scene.groupApplyState('SMD2449FS_internal_on');//AAATONI deferred obj
                     window.scene.groupApplyState('Double_self_on');
                    if(window.pedestalInstall){
                        window.SKCD24U0GSPedestalInstall();
                    }
                     // Off Other Products
                     window.scene.groupApplyState('SMD2489ES_Off');
                     window.scene.groupApplyState('SMD2470ASY_Off');
                     window.scene.groupApplyState('SMD2470AH_Off');
                     window.scene.groupApplyState('KB6524PSY_Off');
                     window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                     window.scene.groupApplyState('SMD2479JS_OFF');
                     window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
                     window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
                     window.currentConfig.hideVisibleInternal = "SMD2449FS_internal_off";
                  });
               });
            }, fridge_timer);
            document.getElementById('alexaBox-container').style.display = 'block';
            displayTextsOnCompleted = function () {
               window.setTimeout(function () {
                  window.updateCalloutPopupVisibility('SMD2499FS', 'SMD2499FS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  window.updateHotspotVisibility('SMD2499FS', 'animation1');
                  window.updateHotspotVisibility('SMD2499FS', 'animation1_2');
                  window.scene.groupApplyState('Microwave_Drawer_Oven_Icon_ON', {}, function () {
                     window.AwardAnimation("SMD2499FS", "Microwave_Drawer_Oven_Icon");
                  });
                  window.updateHotspotVisibility('SMD2499FS', 'SMD2499FS_alexaBox');
               }, 1000);

            };
            break;
         case 'SMD2489ES':
            await window.FadeOutSharp();
            setTimeout(() => {
               window.scene.groupApplyState('Table_on', {}, function () {
                  document.getElementById('alexaBox-container').style.display = 'block';
                  window.scene.groupApplyState('SMD2489ES_On', {}, function () {
                     document.getElementById('internalLoader').classList.remove('show');
                     document.getElementById('internalLoader').classList.add('hide');
                     window.scene.groupApplyState('With_Table_Shadow');
                     window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                     window.scene.groupApplyState('SMD2470ASY_Off');
                     window.scene.groupApplyState('SMD2470AH_Off');
                     window.scene.groupApplyState('KB6524PSY_Off');
                     window.scene.groupApplyState('SMD2479JS_OFF');
                     window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
                     window.scene.groupApplyState('Double_self_on');
                     // alert('SMD2489ES')
                     if(window.pedestalInstall){
                           window.SKMD24U0ESPedestalInstall();
                     }
                     setTimeout(() => {
                        window.scene.groupApplyState('SMD2449FS_Off');
                        window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                        window.scene.groupApplyState('SMD2489ES_in_on');
                        window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
                        window.scene.groupApplyState('microwave_Table_Big_door_On');
                        window.currentConfig.hideVisibleInternal = "SMD2489ES_in_off";
                        window.updateCalloutPopupVisibility('SMD2489ES', 'SMD2489ES_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                        // enable animation callouts
                        window.updateHotspotVisibility('SMD2489ES', 'animation1_9');
                        window.updateHotspotVisibility('SMD2489ES', 'animation1_10');
                        window.scene.groupApplyState('Microwave_Drawer_Oven_Icon_ON', {}, function () {
                           window.AwardAnimation("SMD2489ES", "Microwave_Drawer_Oven_Icon");
                        });
                        window.updateHotspotVisibility('SMD2489ES', 'SMD2489ES_alexaBox');

                     }, 1000);
                  });
               });
            }, fridge_timer);
            break;
         case 'SMD2470ASY':
            setTimeout(() => {
               window.scene.groupApplyState('Table_on', {}, function () {
               window.scene.groupApplyState('SMD2470ASY_On', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SMD2449FS_Off');
                  window.scene.groupApplyState('SMD2489ES_Off');
                  window.scene.groupApplyState('SMD2470AH_Off');
                  window.scene.groupApplyState('KB6524PSY_Off');
                  window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                  window.scene.groupApplyState('SMD2479JS_OFF');
                  window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
                  window.scene.groupApplyState('Double_self_on');
                  window.scene.groupApplyState('SMD2470ASY_Door_On');
                  window.scene.groupApplyState('SMD2470AH_OFF');
                  window.scene.groupApplyState('SMD2470ASY_ON');
                  window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
                  window.scene.groupApplyState('microwave_Table_Big_door_On');
                  window.currentConfig.hideVisibleInternal = "SMD2470AH_in_off";
                  window.scene.groupApplyState('silver');
                  if(window.pedestalInstall){
                     window.SKMD24U0ESPedestalInstall();
                  }
                  window.updateCalloutPopupVisibility('SMD2470ASY', 'SMD2470ASY_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  // enable animation callouts
                  window.updateHotspotVisibility('SMD2470ASY', 'animation1_5');
                  window.updateHotspotVisibility('SMD2470ASY', 'animation1_6');
                  window.AwardAnimation("SMD2470ASY", "Microwave_Drawer_Oven_Icon");
                  window.scene.groupApplyState('Microwave_Drawer_Oven_Icon_ON', {}, function () {
                     window.AwardAnimation("SMD2470ASY", "Microwave_Drawer_Oven_Icon");
                  });
                  });

                  setTimeout(() => {
                     window.scene.groupApplyState('SMD2470AH_Internal_Dark_Off');
                     window.scene.groupApplyState('SMD2470AH_Door_Off');
                     // console.log("SMD2470AH_Door_Off");
                  }, 10); //TODO: Question. Why we need a delay here?
               });

            }, fridge_timer);

            break;
         case 'SMD2470AH':
            setTimeout(() => {
               window.scene.groupApplyState('Table_on', {}, function () {
                  window.scene.groupApplyState('With_Table_Shadow');
                  // window.scene.groupApplyState('SMD2470AH_On');
                  window.scene.groupApplyState('SMD2470AH_On', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SMD2449FS_Off');
                  window.scene.groupApplyState('SMD2489ES_Off');
                  window.scene.groupApplyState('SMD2470ASY_Off');
                  window.scene.groupApplyState('KB6524PSY_Off');
                  window.scene.groupApplyState('SMD2479JS_OFF');
                  window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
                  window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                  window.scene.groupApplyState('Double_self_on');
                  window.scene.groupApplyState('SMD2470AH_Door_On');
                  window.scene.groupApplyState('SMD2470ASY_Door_Off');
                  window.scene.groupApplyState('SMD2470AH_in_on');
                  window.scene.groupApplyState('SMD2470AH_on');
                  window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
                  window.scene.groupApplyState('microwave_Table_Big_door_On');
                  window.scene.groupApplyState('SMD2470AH_Internal_Dark_Off');
                  window.currentConfig.hideVisibleInternal = "SMD2470AH_in_off";
               });
                  if(window.pedestalInstall){
                     window.SKMD24U0ESPedestalInstall();
                  }
                  setTimeout(() => {
                     window.scene.groupApplyState('black');
                  }, 1)
                  window.updateCalloutPopupVisibility('SMD2470AH', 'SMD2470AH_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  // enable animation callouts
                  window.updateHotspotVisibility('SMD2470AH', 'animation1_7');
                  window.updateHotspotVisibility('SMD2470AH', 'animation1_8');
               });
            }, fridge_timer);
            break;
         case 'KB6524PSY':
            setTimeout(() => {
               document.getElementById("hotspot13").style.visibility = 'hidden';
               window.scene.groupApplyState('Table_on', {}, function () {
               window.scene.groupApplyState('KB6524PSY_On', {}, function () {
                  window.pedestalInstall = false;
                  window.scene.groupApplyState('With_Table_Shadow');
                  // window.scene.groupApplyState('KB6524PSY_On');
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  document.getElementById('KB6524PSY_control_panel_text').innerHTML = "Zoom In To Control Panel";
                  window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_ON', {}, function () {
                     window.scene.groupApplyState('SKMD24U0ES_Pedestal_OFF');
                     window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
                     document.getElementById("animation11_3").style.visibility = 'hidden';
                     document.getElementById("animation11_3").style.display = 'none';
                  })
                  window.scene.groupApplyState('SMD2449FS_Off');
                  window.scene.groupApplyState('SMD2489ES_Off');
                  window.scene.groupApplyState('SMD2470ASY_Off');
                  window.scene.groupApplyState('SMD2470AH_Off');
                  window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                  window.scene.groupApplyState('SMD2479JS_OFF');
                  window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
                  window.scene.groupApplyState('Double_self_on');
                  window.scene.groupApplyState('KB6524PSY_in_on');
                  window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
                  window.scene.groupApplyState('microwave_Table_Big_door_On');
                  window.currentConfig.hideVisibleInternal = "KB6524PSY_in_off";
                  window.updateCalloutPopupVisibility('KB6524PSY', 'KB6524PSY_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  window.updateHotspotVisibility('KB6524PSY', 'animation1_11');
                  window.updateHotspotVisibility('KB6524PSY', 'animation1_12');
                  window.scene.groupApplyState('Microwave_Drawer_Oven_Icon_ON', {}, function () {
                     window.AwardAnimation("KB6524PSY", "Microwave_Drawer_Oven_Icon");
                  });
                  });
                  displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                     }, 2000);
                  };
               });
            }, fridge_timer);
            break;
         case 'SMD3070ASS_Drawer_Oven':
            window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_On', {}, function () {
               console.log("** SMD3070ASS_Drawer_Oven **");
               // Handling Double Camera angle
               window.SMD3070AS_drawer_install = true;
               window.pedestalInstall = false;
               document.getElementById('internalLoader').classList.add('show');
               // document.getElementById('internalLoader').classList.add('hide');
               window.setTimeout(function () {
                  window.updateCalloutPopupVisibility('SMD3070ASS_Drawer_Oven', 'SMD3070ASS_Drawer_Oven_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  window.scene.groupApplyState('microwave_Table_Big_door_off');
                  document.getElementById('internalLoader').classList.remove('show');
               }, 2000);
               document.getElementById("hotspot13").style.visibility = 'hidden';
               window.scene.groupApplyState('table_on');
               window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_OFF');
               window.scene.groupApplyState('SKMD24U0ES_Pedestal_OFF');
               window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
               window.scene.groupApplyState('Table_Dull_Pedestal_ON');
               document.getElementById("animation11_3").style.visibility = 'hidden';
               document.getElementById("animation11_3").style.display = 'none';
               window.scene.groupApplyState('microwave_Table_Big_door_off');
               window.scene.groupApplyState('Double_self_on');
               window.scene.groupApplyState('SMD2449FS_Off');
               window.scene.groupApplyState('SMD2489ES_Off');
               window.scene.groupApplyState('SMD2470ASY_Off');
               window.scene.groupApplyState('SMD2470AH_Off');
               window.scene.groupApplyState('KB6524PSY_Off');
               window.scene.groupApplyState('SMD2479JS_OFF');
               window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
            });
            break;
         case 'SMD2479JS':
            setTimeout(() => {
               window.scene.groupApplyState('Table_on', {}, function () {
                  setTimeout(() => {
                     // Off Other Products
                     window.scene.groupApplyState('SMD2479JS_ON', {}, function () {
                        document.getElementById('internalLoader').classList.remove('show');
                        document.getElementById('internalLoader').classList.add('hide');
                        window.scene.groupApplyState('SMD2449FS_Off');
                        window.scene.groupApplyState('SMD2489ES_off');
                        window.scene.groupApplyState('SMD2470ASY_Off');
                        window.scene.groupApplyState('SMD2470AH_Off');
                        window.scene.groupApplyState('KB6524PSY_Off');
                        window.scene.groupApplyState('SMD2440JS_Drawer_Oven_OFF');
                        window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                        window.scene.groupApplyState('Double_self_on');
                        if(window.pedestalInstall){
                           window.SKMD24U0ESPedestalInstall();
                        }
                     });
                  }, 400);
               });
            });
            document.getElementById('alexaBox-container').style.display = 'block';
            displayTextsOnCompleted = function () {
               window.setTimeout(function () {
                  window.updateCalloutPopupVisibility('SMD2479JS', 'SMD2479JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  window.updateHotspotVisibility('SMD2479JS', 'animation1_111');
                  window.updateHotspotVisibility('SMD2479JS', 'animation1_1112');
                  window.updateHotspotVisibility('SMD2479JS', 'SMD2479JS_alexaBox');
                  window.scene.groupApplyState('Microwave_Drawer_Oven_Icon_ON', {}, function () {
                     window.AwardAnimation("SMD2479JS", "Microwave_Drawer_Oven_Icon");
                  });
               }, 2600);
            };
            break;
         case 'SMD2440JS':
            setTimeout(() => {
               window.scene.groupApplyState('Table_on', {}, function () {
                  setTimeout(() => {
                     window.scene.groupApplyState('SMD2440JS_Drawer_Oven_ON', {}, function () {
                        document.getElementById('internalLoader').classList.remove('show');
                        document.getElementById('internalLoader').classList.add('hide');
                        window.scene.groupApplyState('SMD2449FS_Off');
                        window.scene.groupApplyState('SMD2489ES_off');
                        window.scene.groupApplyState('SMD2470ASY_Off');
                        window.scene.groupApplyState('SMD2470AH_Off');
                        window.scene.groupApplyState('KB6524PSY_Off');
                        window.scene.groupApplyState('SMD2479JS_OFF');
                        window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_Off');
                        if(window.pedestalInstall){
                           window.SKMD24U0ESPedestalInstall();
                        }
                     });
                  }, 400);
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SMD2440JS', 'SMD2440JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     window.updateHotspotVisibility('SMD2440JS', 'animation1_1111');
                     window.updateHotspotVisibility('SMD2440JS', 'animation1_11112');
                  }, 2000);
                  // };
               });
            });
            break;
         default:
            break;
      }
      document.getElementById("scroll_panel").scrollTo(0, 0);
      setTimeout(function () {
         window.setMenuScroll('panel1bh-header')
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category1.icon_stable').classList.add('selectDrawer');
      if (bCategoryChanged) { //TODO: this is needed?
         if (window.mob) {
            if (window.isiphone) {
               document.getElementById('demoDiv').style.height = '1550px';
            } else {
               document.getElementById('demoDiv').style.height = '1460px';
            }
         }
         else {
            document.getElementById('demoDiv').style.height = '1055px';
         }
      }
      window.scene.groupApplyState('Fridge_side_wall_on');
      window.scene.groupApplyState('New_Drawer_Part_Off');
      if (previousItem == 5 && window.SMD3070AS_walloven == true) {
         await window.sleep(4000);
      }
      if (itemToAdd < 0) {
         itemToAdd = 0;
      }
      console.log("bCategoryChanged", bCategoryChanged);
      // console.log("displayTextsOnCompleted", displayTextsOnCompleted);
      firstDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      if (bCategoryChanged) { //TODO: this is needed?
         window.hide_all_oven();
      } else {
         window.scene.groupApplyState('SMD2449FS_ovenlight_off');
      }
   }

   async function secondDrawerDemoOnCompleted(bCategoryChanged, cb) {
      console.log("secondDrawerDemoOnCompleted");
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      if (document.getElementById('SMD3070AS').classList.contains('selected')) {
         // Apply DOF
         window.scene.setDoFTargetObject("ovan_SMD3070AS43-0");
      } else {
         // Apply DOF
         window.scene.setDoFTargetObject("new_sharp_oven-0");
      }

      if (cb) {
         setTimeout(function c2() {
            if (window.ranges_position == 'side') {
               document.getElementById("hotspot11").style.visibility = 'visible';
               document.getElementById("hotspot2").style.visibility = 'hidden';
            } else {
               document.getElementById("hotspot2").style.visibility = 'visible';
               document.getElementById("hotspot11").style.visibility = 'hidden';
            }
            document.getElementById("hotspot3").style.visibility = 'visible';
            //document.getElementById("hotspot4").style.visibility = 'visible';
            cb();
         }, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }
   // const secondDrawerDemo = () => {
   async function secondDrawerDemo(itemToAdd, previousItem) {
      window.congigurePlace = "second";
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      window.pedestalCompability = true;
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      console.log("secondDrawerDemo");
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      document.getElementById("SMD3070AS").classList.remove('selected');
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      // console.log("********* secondDrawerDemo calling ************");
      // console.log(window.currentConfig.currentDrawer);
      if (window.currentConfig.currentDrawer == 'reset') {

      }
      if (document.getElementById('SWB3052GS').classList.contains('selected')) {
         document.querySelector("#SWB3052GS .downloadSpecTwo").style.display = 'none';
      }
      window.pedestalComp();
      // Surbhi gotopos with conditionsg4638
      var temp_array;
      if (window.currentConfig.currentDrawer == "microwave") {

         window.scene.groupApplyState('Fridge_side_wall_on');
         // console.log("-----Inside the microwave ---------");
         // alert("3");
         temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 30, 152.46605138838333];
         // console.log(window.config.microwave_drawers);
         window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.microwave_drawers, function () {
            // alert("come inside");
            // This GOTOPOS should come after the async functions
            // console.log("calling delaysecondpanelIntersect start");
            window.delaysecondpanelIntersect();
            // console.log("calling delaysecondpanelIntersect end");
            setTimeout(function () {
               window.scene.groupApplyState('Fridge_side_wall_off');
            }, 800);

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
      }
      else if (window.currentConfig.currentDrawer == "fridge") {
         // console.log("-----Inside second Drawer Fridge ---------");
         if (window.currentSelected.category2 == "SWB3052DS") {
            var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -7.947901675616224, 214.66329650582966];
         }
         if (window.currentSelected.category2 == "SWB3052GS") {
            var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -7.947901675616224, 214.66329650582966];
         }
         else if (window.currentSelected.category2 == "SWA3052DS") {
            var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -7.947901675616224, 214.66329650582966];
         }
         else if (window.currentSelected.category2 == "SWA3052GS") {
            var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -7.947901675616224, 214.66329650582966];
         }
         else if (window.currentSelected.category2 == "SSC2489GS") {
            var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -7.947901675616224, 214.66329650582966];
         }
         window.GotoPosInTimeNamedValue(temp_array, window.config.wall_ovens, function () {
            // This GOTOPOS should come after the async functions
            // console.log("calling delaysecondpanelIntersect start");
            window.delaysecondpanelIntersect();
            // console.log("calling delaysecondpanelIntersect end");

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
      }
      else if (window.currentConfig.currentDrawer == "range") {
         // console.log("-----Inside the Range ---------");
         window.scene.groupApplyState('Fridge_side_wall_off');
         if (document.getElementById("SMD3070AS").classList.contains('selected')) {
            var temp_array = [0.7722699999999993, 0.021736, -13.208294483756275, -49.79664726071187, 134.07480498151855];
            // alert('Inside the Range if');
         } else {
            if (window.currentSelected.category2 == "SWB3052DS") {
               var temp_array = [1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.602975258164065, 214.66329650582966];
            }
            if (window.currentSelected.category2 == "SWB3052GS") {
               var temp_array = [1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.602975258164065, 214.66329650582966];
            }
            else if (window.currentSelected.category2 == "SWA3052DS") {
               var temp_array = [1.204889788350463, 0.1845901777476891, -22.657609373593054, -1.6360708802969677, 134.06101132436365];
            }
            else if (window.currentSelected.category2 == "SWA3052GS") {
               var temp_array = [1.204889788350463, 0.1845901777476891, -22.657609373593054, -1.6360708802969677, 134.06101132436365];
            }
            else if (window.currentSelected.category2 == "SSC2489GS") {
               var temp_array = [1.1492684864308695, 0.11167088, -15.774983705791877, -24.077078660630587, 128.02438969442684];
            }
         }

         window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.wall_ovens, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
            // alert('menu js 1')
         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
      } else {
         window.setTimeout(function () {
            if (document.getElementById("SMD3070AS").classList.contains('selected')) {
               var temp_array = [0.7722699999999993, 0.021736, -13.208294483756275, -49.79664726071187, 134.07480498151855];
               // alert('Inside the secondDrawerDemo else if');
            } else {
               var temp_array = [1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.6029752581640646, 214.66329650582966]; //load cam value
            }
            window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.wall_ovens, function () {
               document.querySelector('#container').style.pointerEvents = "auto";
            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
            setTimeout(function () {
               window.scene.groupApplyState('Fridge_side_wall_off');
            }, 800);
         }, 300)
      }

      window.currentConfig.currentDrawer = "walloven";
      // console.log('AAATONI. secondDrawerDemo:',itemToAdd);
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      if (document.getElementById(window.currentSelected.category2 + '_wall_oven_text') != null) {
         document.getElementById(window.currentSelected.category2 + '_wall_oven_text').innerHTML = "Open Oven";
         // console.log('text')
      }
      if (document.getElementById(window.currentSelected.category2 + '_oven_panel_text') != null) {
         document.getElementById(window.currentSelected.category2 + '_oven_panel_text').innerHTML = "Control Panel Close Up";
      }
      for (var j = 0; j < animations.length; j++) {
         animations[j].style.visibility = 'hidden';
      }
      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         if (window.SMD3070ASStatus.selectedModel != 'SMD3070AS_walloven') {
            await window.FadeOutSharp(); //AAATONI
         }
      }
      window.cookTop = false;
      window.overTheRange = false;
      window.hoodRange = false;
      window.comboCookTop = false;
      hideFridge = true;
      // console.log("hideFridge",hideFridge);
      window.scene.groupApplyState('SWA3052DS_oven_light_off');
      window.scene.groupApplyState('SWB3052DS_oven_light_off');
      window.scene.groupApplyState('SWB3052GS_oven_light_off');
      window.localStorage.setItem('wallOven', 'walloven');
      hideInternals();
      window.scene.groupApplyState('SWB3085HS_off');
      // console.log("**************************** okok");
      // console.log(window.SMD3070ASStatus.selectedModel);
      if (window.STR3065HS_cooktop) {
         document.getElementById("hotspot8").style.visibility = 'visible';
         setTimeout(() => {
            document.getElementById("hotspot2").style.visibility = 'hidden';
         }, 2000);
      }
      if (window.SWB3085HS_walloven) {
         window.SWB3085HS_walloven = false;
         setTimeout(() => {
            window.scene.groupApplyState('SWB3085HS_OFF');
            window.scene.groupApplyState('SWB3085HS_INT_OFF');
         }, 1000);
      }
      if (window.cooktop_position == "island") {
         setTimeout(() => {
            document.getElementById("hotspot2").style.visibility = 'hidden';
            document.getElementById("hotspot3").style.visibility = 'hidden';
         }, 2000);
      }
      // alert(window.currentSelected.category2);
      //use switch case
      window.hideAlexaBoxCallouts();
      window.reverseState();
      switch (window.currentSelected.category2) {
         case 'SWB3052DS':
            if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_walloven') {
               // alert("1");
               window.scene.groupApplyState('SWA3052DS_on');
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               document.getElementById("switch_popup").style.display = "flex";
               window.pauseClick = true;
               window.check_SMD3070AS = true;
               let promise = new Promise((resolve, reject) => {
                  var okBtn = document.getElementById('okBtn');
                  var closeswitchPopup = document.getElementById('closeswitch_popup');
                  okBtn.addEventListener('click', function (e) {
                     /// do something to process the answer
                     setTimeout(() => {
                        window.scene.gotoPosInTime(1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.602975258164064, 214.66329650582966, 1000, function () { }, window.slowinout2);
                     }, 500);
                     resolve(true);
                     //  
                  }, { once: true });
                  closeswitchPopup.addEventListener('click', function (e) {
                     /// do something to process the answer
                     reject(false);
                     window.$('#SWA3052DS').click();
                  }, { once: true });
               });
               let result = await promise; // wait until the promise resolves (*)
               // if(result == false){
               // alert(result)
               // }
               // alert('1'+result);
               window.FadeOutSharp();
               window.closeswitch_popup();
               window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
               window.scene.groupApplyState('Double_self_on');
               window.scene.groupApplyState('singal_oven_self_off');
               window.scene.groupApplyState('SWB3052DS_internals_on');
               window.scene.groupApplyState('SWA3052DS_off');
               window.scene.groupApplyState('SMD3070AS_off');
               window.scene.groupApplyState('self_3070_new_off');
               window.currentConfig.hideVisibleInternal = "SWB3052DS_internals_off";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SWB3052DS', 'SWB3052DS_allDrawerss');
                     window.updateHotspotVisibility('SWB3052DS', 'animation2_1_1');
                     window.updateHotspotVisibility('SWB3052DS', 'animation2');
                  }, 2000);
               };
               window.ok_switch_popup('select_SMD3070AS_drawer');
               window.SMD3070ASStatus.selectedModel = 'SMD3070AS_drawer'
            } else {
               // alert("2");
               window.scene.groupApplyState('SWB3052DS_on', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SWA3052DS_off');
                  window.scene.groupApplyState('SMD3070AS_off');
                  window.scene.groupApplyState('SSC2489GS_ovan_off');
                  window.scene.groupApplyState('Double_self_on', {}, function () {
                     window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
                     // window.scene.groupApplyState('Double_self_on');
                     window.scene.groupApplyState('singal_oven_self_off');
                     window.scene.groupApplyState('SWB3052DS_internals_on');
                     window.scene.groupApplyState('SWA3052DS_off');
                     window.scene.groupApplyState('SMD3070AS_off');
                     window.scene.groupApplyState('self_3070_new_off');
                     window.currentConfig.hideVisibleInternal = "SWB3052DS_internals_off";
                     displayTextsOnCompleted = function () {
                        window.setTimeout(function () {
                           window.updateCalloutPopupVisibility('SWB3052DS', 'SWB3052DS_allDrawerss');
                           window.updateHotspotVisibility('SWB3052DS', 'animation2_1_1');
                           window.updateHotspotVisibility('SWB3052DS', 'animation2');
                        }, 2000);
                     };
                  });
               });
            };
            break;
         case 'SWB3052GS':
            if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_walloven') {
               // alert("11");
               window.scene.groupApplyState('SWA3052DS_on');
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               document.getElementById("switch_popup").style.display = "flex";
               window.pauseClick = true;
               window.check_SMD3070AS = true;
               let promise = new Promise((resolve, reject) => {
                  var okBtn = document.getElementById('okBtn');
                  var closeswitchPopup = document.getElementById('closeswitch_popup');
                  okBtn.addEventListener('click', function (e) {
                     /// do something to process the answer
                     setTimeout(() => {
                        window.scene.gotoPosInTime(1.31955506266146, -0.03542038991033637, -8.853827071541769, -3.602975258164064, 214.66329650582966, 1000, function () { }, window.slowinout2);
                     }, 500);
                     resolve(true);
                  }, { once: true });
                  closeswitchPopup.addEventListener('click', function (e) {
                     /// do something to process the answer
                     reject(false);
                     window.$('#SWA3052DS').click();
                  }, { once: true });
               });
               let result = await promise; // wait until the promise resolves (*)
               // if(result == false){
               // alert(result)
               // }
               // alert('1'+result);
               window.FadeOutSharp();
               window.closeswitch_popup();
               window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
               window.scene.groupApplyState('Double_self_on');
               window.scene.groupApplyState('singal_oven_self_off');
               window.scene.groupApplyState('SWB3052DS_internals_on');
               window.scene.groupApplyState('SWA3052DS_off');
               window.scene.groupApplyState('SMD3070AS_off');
               window.scene.groupApplyState('self_3070_new_off');
               window.currentConfig.hideVisibleInternal = "SWB3052DS_internals_off";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SWB3052GS', 'SWB3052GS_allDrawerss');
                     window.updateHotspotVisibility('SWB3052GS', 'animation22_1_1');
                     window.updateHotspotVisibility('SWB3052GS', 'animation22');
                  }, 2000);
               };
               window.ok_switch_popup('select_SMD3070AS_drawer');
               window.SMD3070ASStatus.selectedModel = 'SMD3070AS_drawer'
            } else {
               // alert("22");
               window.scene.groupApplyState('SWB3052DS_on', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SWA3052DS_off');
                  window.scene.groupApplyState('SMD3070AS_off');
                  window.scene.groupApplyState('SSC2489GS_ovan_off');
                  window.scene.groupApplyState('Double_self_on', {}, function () {
                     window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
                     window.scene.groupApplyState('singal_oven_self_off');
                     window.scene.groupApplyState('SWB3052DS_internals_on');
                     window.scene.groupApplyState('SWA3052DS_off');
                     window.scene.groupApplyState('SMD3070AS_off');
                     window.scene.groupApplyState('self_3070_new_off');
                     window.currentConfig.hideVisibleInternal = "SWB3052DS_internals_off";
                     displayTextsOnCompleted = function () {
                        window.setTimeout(function () {
                           window.updateCalloutPopupVisibility('SWB3052GS', 'SWB3052GS_allDrawerss');
                           window.updateHotspotVisibility('SWB3052GS', 'animation22_1_1');
                           window.updateHotspotVisibility('SWB3052GS', 'animation22');
                        }, 2000);
                     };
                  });
               });
            };
            break;
         case 'SWA3052DS':
            window.scene.groupApplyState('SWA3052DS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SWB3052DS_off');
               window.scene.groupApplyState('SSC2489GS_ovan_off');
               window.scene.groupApplyState('SMD3070AS_off');
               window.scene.groupApplyState('single_wall_oven_filler_on');
               window.scene.groupApplyState('Double_self_off');
               window.scene.groupApplyState('wall_ovan_2in1_off');
               window.scene.groupApplyState('singal_oven_self_on');
               window.scene.groupApplyState('SWA3052DS_in_on');
               window.scene.groupApplyState('self_3070_new_off');
               window.currentConfig.hideVisibleInternal = "SWA3052DS_in_off";
               window.setTimeout(() => {
                  window.scene.gotoPosInTime(1.204889788350463, 0.1845901777476891, -22.657609373593054, -1.6360708802969677, 134.06101132436365, 1000, function () { }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
               }, 1000);
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SWA3052DS', 'SWA3052DS_allDrawerss');
                     window.updateHotspotVisibility('SWA3052DS', 'animation2_1');
                     window.updateHotspotVisibility('SWA3052DS', 'animation2_1_2');
                  }, 2000);
               };
               if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_walloven') {
                  window.setTimeout(() => { }, 1000);
                  window.scene.groupApplyState('SSC2489GS_off');
                  window.scene.groupApplyState('SWA3052DS_on');
                  window.scene.groupApplyState('SMD3070AS_on');
                  window.scene.groupApplyState('singal_oven_self_on');
                  window.scene.groupApplyState('Double_self_off');
                  window.scene.groupApplyState('SWB3052DS_off');
                  window.scene.groupApplyState('SSC2489GS_ovan_off');
                  window.scene.groupApplyState('wall_ovan_2in1_off');
                  window.scene.groupApplyState('self_3070_new_on');
               }
            });
            break;
         case 'SWA3052GS':
            window.scene.groupApplyState('SWA3052DS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SWB3052DS_off');
               window.scene.groupApplyState('SSC2489GS_ovan_off');
               window.scene.groupApplyState('SMD3070AS_off');
               window.scene.groupApplyState('single_wall_oven_filler_on');
               window.scene.groupApplyState('Double_self_off');
               window.scene.groupApplyState('wall_ovan_2in1_off');
               window.scene.groupApplyState('singal_oven_self_on');
               window.scene.groupApplyState('SWA3052DS_in_on');
               window.scene.groupApplyState('self_3070_new_off');
               window.currentConfig.hideVisibleInternal = "SWA3052DS_in_off";
               window.setTimeout(() => {
                  window.scene.gotoPosInTime(1.204889788350463, 0.1845901777476891, -22.657609373593054, -1.6360708802969677, 134.06101132436365, 1000,
                     function () { }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
               }, 1000);
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SWA3052GS', 'SWA3052GS_allDrawerss');
                     window.updateHotspotVisibility('SWA3052GS', 'animation22_1');
                     window.updateHotspotVisibility('SWA3052GS', 'animation22_1_2');
                  }, 2000);
               };
               if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_walloven') {
                  window.setTimeout(() => { }, 1000);
                  window.scene.groupApplyState('SSC2489GS_off');
                  window.scene.groupApplyState('SWA3052DS_on');
                  window.scene.groupApplyState('SMD3070AS_on');
                  window.scene.groupApplyState('singal_oven_self_on');
                  window.scene.groupApplyState('Double_self_off');
                  window.scene.groupApplyState('SWB3052DS_off');
                  window.scene.groupApplyState('SSC2489GS_ovan_off');
                  window.scene.groupApplyState('wall_ovan_2in1_off');
                  window.scene.groupApplyState('self_3070_new_on');
               }
            });
            break;
         case 'SSC2489GS':
            if (window.SMD3070ASStatus.selectedModel == 'SMD3070AS_walloven') {
               window.scene.groupApplyState('SWA3052DS_on', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
               });
               window.scene.groupApplyState('SWA3052DS_on');
               document.getElementById("switch_popup").style.display = "flex";
               window.pauseClick = true;
               window.check_SMD3070AS = true;
               let promise = new Promise((resolve, reject) => {
                  var okBtn = document.getElementById('okBtn');
                  var closeswitchPopup = document.getElementById('closeswitch_popup');
                  okBtn.addEventListener('click', function (e) {
                     /// do something to process the answer
                     setTimeout(() => {
                        window.scene.gotoPosInTime(1.1492684864308695, 0.11167088, -5.751961093514372, -22.622024443105172, 128.02438969442684, 1000, function () { }, window.slowinout2);
                     }, 500);
                     resolve(true);
                     //  
                  }, { once: true });
                  closeswitchPopup.addEventListener('click', function (e) {
                     /// do something to process the answer
                     reject(false);
                     window.$('#SWA3052DS').click();
                  }, { once: true });
               });
               let result = await promise; // wait until the promise resolves (*)
               // alert('1'+result);
               window.FadeOutSharp();
               window.closeswitch_popup();
               window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
               window.scene.groupApplyState('Double_self_off');
               window.scene.groupApplyState('singal_oven_self_off');
               window.scene.groupApplyState('SWA3052DS_off');
               window.scene.groupApplyState('self_3070_new_off');
               window.scene.groupApplyState('wall_ovan_2in1_off');
               window.scene.groupApplyState('SSC2489GS_Oven_Icon_ON');
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SSC2489GS', 'SSC2489GS_allDrawerss');
                     // enable animation callouts
                     window.updateHotspotVisibility('SSC2489GS', 'animation2_2');
                     window.updateHotspotVisibility('SSC2489GS', 'animation2_3');
                     window.AwardAnimation('SSC2489GS', 'SSC2489GS_Oven_Icon');
                  }, 2000);
               };
               window.ok_switch_popup('select_SMD3070AS_drawer');
               window.SMD3070ASStatus.selectedModel = 'SMD3070AS_drawer'
            }
            else {
               await window.FadeOutSharp();
               window.scene.groupApplyState('SSC2489GS_on', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SWB3052DS_off');
                  window.scene.groupApplyState('SWA3052DS_off');
                  window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
                  window.scene.groupApplyState('Double_self_off');
                  window.scene.groupApplyState('singal_oven_self_off');
                  window.scene.groupApplyState('SWA3052DS_off');
                  window.scene.groupApplyState('self_3070_new_off');
                  window.scene.groupApplyState('wall_ovan_2in1_off');
                  document.getElementById('alexaBox-container').style.display = 'block'
                  setTimeout(() => {
                     window.scene.gotoPosInTime(1.1492684864308695, 0.11167088, -15.774983705791877, -24.077078660630587, 128.02438969442684, 1000, function () { }, window.slowinout2);
                  }, 2000);
                  window.scene.groupApplyState('SSC2489GS_Oven_Icon_ON');
                  displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        window.updateCalloutPopupVisibility('SSC2489GS', 'SSC2489GS_allDrawerss');
                        // enable animation callouts
                        window.updateHotspotVisibility('SSC2489GS', 'animation2_2');
                        window.updateHotspotVisibility('SSC2489GS', 'animation2_3');
                        window.scene.groupApplyState('SSC2489GS_Oven_Icon_ON', {}, function () {
                           window.AwardAnimation('SSC2489GS', 'SSC2489GS_Oven_Icon');
                        })
                        window.updateHotspotVisibility('SSC2489GS', 'SSC2489GS_alexaBox');
                     }, 2000);
                  };
               });
            }
            break;
         case 'SMD3070AS':
            document.getElementById("SWB3052DS").classList.remove('selected');
            document.getElementById("SWB3052GS").classList.remove('selected');
            document.getElementById("SWA3052DS").classList.add('selected');
            document.getElementById("SWA3052GS").classList.add('selected');
            document.getElementById("SSC2489GS").classList.remove('selected');
            var btn;
            var draweOvenInterval;
            var SMD3070ASStatus = {
               'selectedModel': ''
            }
            window.SMD3070AS_walloven = true;
            // window.FadeOutSharp();
            document.getElementById("animContainer").style.display = "none";
            document.getElementById("internalcalloutsContainer").style.display = "block";
            window.scene.groupApplyState('SMD3070AS_in_color_close');
            document.getElementById('radioBtn2').classList.add('checked2');
            document.getElementById('radioBtn1').classList.remove('checked1');
            window.localStorage.setItem('wall_oven', 'SMD3070AS_on');
            clearInterval(window.draweOvenInterval);
            document.getElementById("select_SMD3070AS").style.display = "none";
            window.pauseIconClick = false;
            window.pauseClick = false;
            // console.log("-----Inside the 30inch wall oven ---------");
            setTimeout(function () {
               //New added @YK
               btn = document.getElementById("SMD3070AS");
               btn.classList.add('selected');
               // btn.click(event);
               var temp_array = [0.7722699999999993, 0.021736, -10.8197238202669, -29.537376308222907, 191.63863092705785];
               SMD3070ASStatus.selectedModel = 'SMD3070AS_walloven';
               // alert('SMD3070AS_walloven')
               window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.wall_ovens, function () {
                  document.querySelector('#container').style.pointerEvents = "auto";
                  setTimeout(function () {
                     // window.FadeInSharp();
                     document.getElementById('infoIcon').style.display = 'none';
                     document.getElementById('reset_canvas').style.display = 'none';
                     window.updateCalloutPopupVisibility('SMD3070ASS_Drawer_Oven', 'SMD3070AS_allDrawerss');
                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_3');
                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_4');
                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_16');
                     window.$('#pointsContainer').show();
                     document.getElementById("animContainer").style.display = "block";
                     if (window.mob) {
                        if (window.innerWidth < 760) {
                           document.getElementById("container_accordian").style.display = "none";
                        } else {
                           document.getElementById("container_accordian").style.display = "block";
                        }
                     }
                     else {
                        document.getElementById("container_accordian").style.display = "block";
                     }
                  }, 2000);
                  window.scene.setDoFTargetObject("ovan_SMD3070AS43-0");
                  window.scene.groupApplyState('Oven_3070AS_Table_Door_On');
                  window.scene.groupApplyState('microwave_Table_Big_door_Off');
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SMD3070AS', 'SMD3070AS_allDrawerss');
                     window.updateHotspotVisibility('SMD3070AS', 'animation1_3');
                     window.updateHotspotVisibility('SMD3070AS', 'animation1_4');
                     window.updateHotspotVisibility('SMD3070ASS_Drawer_Oven', 'animation1_16');
                  }, 2000);
                  window.scene.clearRefine();
               }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
            }, 800);
            setTimeout(function () {
               window.scene.groupApplyState('SSC2489GS_off');
               window.scene.groupApplyState('SWA3052DS_on');
               window.scene.groupApplyState('SMD3070AS_on');
               window.scene.groupApplyState('singal_oven_self_on');
               window.scene.groupApplyState('Double_self_off');
               window.scene.groupApplyState('SWB3052DS_off');
               window.scene.groupApplyState('SSC2489GS_ovan_off');
               window.scene.groupApplyState('wall_ovan_2in1_off');
               window.scene.groupApplyState('self_3070_new_on');
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
            }, 2000);
            break;
         default:
            break;
      }
      if (bCategoryChanged) {
         setExpanded('panel2');
      }
      window.scene.groupApplyState(Products.category2.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat2. bCategoryChanged=',bCategoryChanged);
         secondDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      });//AAATONI);
      //end
      window.yMinLimit = 2.092189365135304;
      window.yMaxLimit = 0.5924245719999998;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-60, -60, 60, 60, 105, 214.66329650582966, 130);
      if (window.mob) {
         if (window.isiphone) {
            document.getElementById('demoDiv').style.height = '1150px';
         } else {
            document.getElementById('demoDiv').style.height = '1320px';
         }
      } else {
         document.getElementById('demoDiv').style.height = '1082px';
      }
      setTimeout(function () {
         window.setMenuScroll('panel2bh-header')
      }, 500);

      if (window.mob) {
         document.getElementById("scroll_panel").scrollTo(0, 99);
      } else {
         document.getElementById("scroll_panel").scrollTo(0, 96);
      }
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category2.icon_stable').classList.add('selectDrawer');
      window.scene.groupApplyState('Side_Table_on');
      if (window.cooktop_position == "island") {
         document.getElementById("hotspot2").style.visibility = 'hidden';
         document.getElementById("hotspot3").style.visibility = 'hidden';
      }
      document.getElementById("hotspot4").style.visibility = 'hidden';
   }
   async function thirdDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      window.scene.setDoFTargetObject("new_sharp_fridge-0");
      if (cb) {
         setTimeout(function c3() {
            document.getElementById("hotspot4").style.visibility = 'visible';
            document.getElementById("hotspot5").style.visibility = 'hidden';
            if (window.ranges_position == 'side') {
               document.getElementById("hotspot11").style.visibility = 'visible';
               document.getElementById("hotspot2").style.visibility = 'hidden';
            } else {
               document.getElementById("hotspot2").style.visibility = 'visible';
               document.getElementById("hotspot11").style.visibility = 'hidden';
            }
            cb();
         }, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }
   // const thirdDrawerDemo = () => {
   async function thirdDrawerDemo(itemToAdd, previousItem) {
      // console.log("third drawer wallOVen")
      window.congigurePlace = "third";
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";
      window.pedestalCompability = true;
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      if (window.SWB3085HS_walloven) {
         document.querySelector("#hotspot4 .text").innerHTML = 'Wall Oven + Microwave Drawer\u2122 Ovens';
      }
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      // console.log("********* thirdDrawerDemo calling ************");
      // console.log(window.currentConfig.currentDrawer);
      window.scene.groupApplyState('SMD2449FS_off');
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      // Surbhi gotopos with conditions
      var temp_array;
      window.pedestalComp();
      if (window.currentConfig.currentDrawer == "walloven") {
         window.scene.groupApplyState('SMD2449FS_off');
         window.scene.groupApplyState('Without_Table_Shadow');
         window.hide_all_drawer_oven_product();
         window.scene.groupApplyState('microwave_Table_Big_door_Off');
         window.scene.groupApplyState('New_Drawer_Part_Off');
         window.scene.groupApplyState('Table_off');
         window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_OFF');
         if (window.STR3065HS_table_cooktop) {
            window.scene.groupApplyState('STR3065HS_Table_OFF');
            window.scene.groupApplyState('Old_Centre_Table_OFF');
            window.scene.groupApplyState('New_Drawer_Part_Off');
            window.scene.groupApplyState('Double_self_on');
         }
         console.log("-----Inside the third walloven ---------");
         setTimeout(function () {
            window.scene.groupApplyState('Fridge_side_wall_off');
            temp_array = [1.6138183634642238, -0.031195568723283523, 40.25270955747062, -9.524081900169746, 183.4195533700155];
            window.GotoPosInTimeNamedValue(temp_array, window.config.wall_ovens, function () {
               // This GOTOPOS should come after the async functions
               // console.log("calling delaythirdpanelIntersect start");
               window.delaythirdpanelIntersect();
               // console.log("calling delaythirdpanelIntersect end");
               setTimeout(function () {
               }, 800);
            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
         }, 700);
      } else {
         console.log("Fridge Else !");
         if (window.mob) {
            var temp_array = [2.9560062830167126, -0.008631049999999989, 31.091453363013745, -50.20181257637445, 250.50848160445744];
         } else {
            var temp_array = "";
            if (document.getElementById("SJG2254FS").classList.contains('selected')) {
               temp_array = [2.9560062830167126, -0.008631049999999987, 31.091453363013745, -50.20181257637445, 227.50848160445744];
            } else if (document.getElementById("SJG2351FS").classList.contains('selected')) {
               temp_array = [3.1338202830167106, -0.008631049999999989, 31.091453363013745, -50.20181257637445, 227.50848160445744];
            } else if (document.getElementById("SJF2955KS").classList.contains('selected')) {
               temp_array = [3.1338202830167106, -0.008631049999999989, 31.091453363013745, -50.20181257637445, 227.50848160445744];
            }

         }
         window.setTimeout(function () {
            window.scene.groupApplyState('Table_off');
            window.scene.groupApplyState('Without_Table_Shadow');
            window.hide_all_drawer_oven_product();
            window.scene.groupApplyState('microwave_Table_Big_door_Off');
            window.scene.groupApplyState('New_Drawer_Part_Off');
            if (window.STR3065HS_table_cooktop) {
               window.scene.groupApplyState('STR3065HS_Table_OFF');
               window.scene.groupApplyState('Old_Centre_Table_OFF');
               window.scene.groupApplyState('New_Drawer_Part_Off');
               window.scene.groupApplyState('Double_self_on');
            }
         }, 100);
         window.GotoPosInTimeNamedValue(temp_array, window.config.refrigerators, function () {
            window.scene.groupApplyState('Without_Table_Shadow');
            window.scene.groupApplyState('microwave_2_off');
            window.scene.groupApplyState('SMD2449FS_off');
            document.querySelector('#container').style.pointerEvents = "auto";
         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_fridge-0", true) });
      }

      window.currentConfig.currentDrawer = "fridge";
      // console.log('AAATONI. thirdDrawerDemo:',itemToAdd);
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;
      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      var internalcallout = document.getElementsByClassName('internalcallout');

      for (var i = 0; i < internalcallout.length; i++) {
         internalcallout[i].style.visibility = 'hidden';
      }

      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         await window.FadeOutSharp(); //AAATONI
         // console.log('AAATONI. after FadeOutSharp');
         // console.log('AAATONI. starting groupApplyStates');
         //Hide previous appliance
      }
      window.scene.clearRefine();
      window.cookTop = false;
      window.overTheRange = false;
      window.hoodRange = false;
      window.comboCookTop = false;

      window.scene.groupApplyState('SWA3052DS_oven_light_on');
      window.scene.groupApplyState('SWB3052DS_oven_light_on');
      window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
      window.scene.groupApplyState('Table_Dull_Pedestal_OFF');
      window.scene.groupApplyState('Without_Table_Shadow');
      window.scene.groupApplyState('Table_off');
      window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_OFF');
      if (document.getElementById(window.currentSelected.category3 + '_refrigerator_door_text') != null) {
         document.getElementById(window.currentSelected.category3 + '_refrigerator_door_text').innerHTML = "Open Door";
         // console.log(window.currentSelected.category3,'textchange')
      }
      document.getElementById("SWA3052DS_wall_oven_text").innerHTML = "Open Oven";
      document.getElementById("SWA3052GS_wall_oven_text").innerHTML = "Open Oven";
      table = true;
      setExpanded('panel3');
      window.yMinLimit = 3.4507602759231474;
      window.yMaxLimit = 2.0716327276110736;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-40, -60, 60, 60, 50, 300, 130);
      // console.log(window.currentConfig.hideVisibleInternal);
      hideInternals();
      if (window.cooktop_position == "island") {
         window.scene.groupApplyState('SDH3042DB_Table_off');
         window.scene.groupApplyState('SDH3652DB_Table_off');
         window.scene.groupApplyState('SCR3042FB_Table_OFF');
         window.scene.groupApplyState('Without_Table_Shadow');
         window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');
      }
      window.reverseState();
      window.scene.groupApplyState('Award_Trophy_ON');
      document.getElementById("hotspot12").style.visibility = 'visible';

      window.hideAlexaBoxCallouts();
      //use switch case
      switch (window.currentSelected.category3) {
         case 'SJG2254FS':
            window.scene.groupApplyState('SJG2254FS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               // alert('SMD2489ES')
               window.scene.groupApplyState('SJG2351FS_off');
               window.scene.groupApplyState('SJF2955KS_Refrigerator_OFF');
               window.scene.groupApplyState('SJG2254FS_internals_on');
               window.scene.groupApplyState("SJF2955KS_Refrigerator_Dull_OFF")
               window.currentConfig.hideVisibleInternal = "SJG2254FS_internals_off";
               displayTextsOnCompleted = function () {
                  // window.setTimeout(function () {
                     window.updateHotspotVisibility('SJG2254FS', 'animation3');
                     window.updateHotspotVisibility('SJG2254FS', 'animation3_1_1');
                     window.updateHotspotVisibility('SJG2254FS', 'animation3_1_2');
                     window.updateCalloutPopupVisibility('SJG2254FS', 'SJG2254FS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     document.getElementById("SJG2254FS_refrigerator_door_text").innerHTML = "Open Door"; // @uthor:YK.
                     document.getElementById("SJG2254FS_refrigerator_freezer_text").innerHTML = "Open Multi-Purpose Flex Drawer"; // @uthor:YK.
                     document.getElementById("SJG2254FS_refrigerator_drawer_text").innerHTML = "Open Freezer Drawer"; // @uthor:YK.
                  // }, 2000);
               };
            });
            break;
         case 'SJG2351FS':
            window.scene.groupApplyState('SJG2351FS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               // alert('SMD2489ES')
               window.scene.groupApplyState('SJG2254FS_off');
               window.scene.groupApplyState('SJF2955KS_Refrigerator_OFF');
               window.scene.groupApplyState('SJG2351FS_in_on');
               window.scene.groupApplyState("SJF2955KS_Refrigerator_Dull_OFF")
               window.currentConfig.hideVisibleInternal = "SJG2351FS_in_off";
               window.currentConfig.hideVisibleInternal = "SJG2351FS_in_off";
               if (window.mob) {
                  var temp_array = [3.1338202830167106, -0.008631049999999989, 31.091453363013745, -50.20181257637445, 250.50848160445744];
                  window.GotoPosInTimeNamedValue(temp_array, window.config.refrigerators, function () {
                  }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_fridge-0", true) });
               } else { }
               window.setTimeout(function () {
                  window.scene.groupApplyState('Table_off');
               }, 1000);
               
               displayTextsOnCompleted = function () {
                  // enable animation callouts
                  // window.setTimeout(function () {
                     window.updateHotspotVisibility('SJG2351FS', 'animation3_1');
                     window.updateHotspotVisibility('SJG2351FS', 'animation3_1_3');
                     window.updateHotspotVisibility('SJG2351FS', 'animation3_1_4');
                     window.updateCalloutPopupVisibility('SJG2351FS', 'SJG2351FS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  // }, 2000);
               };

            });
            break;
         case 'SJF2955KS':
            window.scene.groupApplyState('SJF2955KS_Refrigerator_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               
               window.scene.groupApplyState('SJG2254FS_off');
               window.scene.groupApplyState('SJG2351FS_off');
               window.currentConfig.hideVisibleInternal = "SJF2955KS_Refrigerator_Internal_OFF";
               if (window.mob) {
                  var temp_array = [3.1338202830167106, -0.008631049999999989, 31.091453363013745, -50.20181257637445, 250.50848160445744];
                  window.GotoPosInTimeNamedValue(temp_array, window.config.refrigerators, function () {
                  }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_fridge-0", true) });
               }
               displayTextsOnCompleted = function () {
                  // enable animation callouts
                  // window.setTimeout(function () {
                     window.updateHotspotVisibility('SJF2955KS', 'animation3_3');
                     // window.updateHotspotVisibility('SJF2955KS', 'animation3_3_1');
                     window.updateHotspotVisibility('SJF2955KS', 'animation3_3_2');
                     window.updateCalloutPopupVisibility('SJF2955KS', 'SJF2955KS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  // }, 2000);
               };

            });
            break; 
         default:
            break;
      }
      if (bCategoryChanged) {
         setExpanded('panel3');
      }
      window.scene.groupApplyState(Products.category3.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat2. bCategoryChanged=',bCategoryChanged);
         thirdDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      });//AAATONI);
      //end
      if (bCategoryChanged) {
         if (!window.scene.getInstanceByName("Table9-0").visible) {
         }
         window.scene.groupApplyState('Fridge_side_wall_on');
      }
      document.getElementById('demoDiv').style.height = '1130px';
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 148);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 144);
         }
      setTimeout(function () {
         window.setMenuScroll('panel3bh-header')
      }, 500);
      //cartdiv.style.display = 'none';
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category3.icon_stable').classList.add('selectDrawer');
      window.hide_all_oven();
      document.getElementById("hotspot2").style.visibility = 'hidden';
   }

   async function fourthDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      window.scene.setDoFTargetObject("new_sharp_dishwasher-0");
      if (cb) {
         setTimeout(cb, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }
   // const fourthDrawerDemo = () => {
   async function fourthDrawerDemo(itemToAdd, previousItem) {
      window.congigurePlace = "fourth";
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";

      // condition added for mob and isipad scroll issue
      if (window.mob || window.isipad && (window.innerWidth < window.innerHeight)) {
         document.querySelector('#panel4bh-content').style.height = '130vh';
      }
      window.pedestalCompability = true;
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      window.currentConfig.currentDrawer = "dishwasher";
      window.scene.groupApplyState('SMD3070ASS_Oven_Self_off');
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
      window.scene.groupApplyState('SMD2449FS_off');
      window.scene.groupApplyState('microwave_Table_Big_door_Off');
      window.scene.groupApplyState('Table_Dull_Pedestal_OFF');
      window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_OFF');
      window.scene.groupApplyState('Without_Table_Shadow');
      window.scene.groupApplyState('Table_off');
      window.dishwasherToDrawer = true;
      // Apply DOF
      // console.log('AAATONI. fourthDrawerDemo:',itemToAdd);
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.pedestalComp();
      // window.scene.clearRefine();
      if (document.getElementById('SMD3070AS').classList.contains('selected')) {
         window.scene.groupApplyState('Oven_3070AS_Table_Door_Off');
      }
      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         await window.FadeOutSharp(); //AAATONI
         // console.log('AAATONI. after FadeOutSharp');
         // console.log('AAATONI. starting groupApplyStates');
         //Hide previous appliance
         // window.scene.groupApplyState(Products.category4.items[previousItem].productShow.replace("_on","_off"));
      }
      window.scene.clearRefine();
      window.cookTop = false;
      window.overTheRange = false;
      window.hoodRange = false;
      window.comboCookTop = false
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      document.getElementById("hotspot1").style.visibility = 'visible';
      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }
      if (document.getElementById(window.currentSelected.category4 + '_dishwasher_control_text') != null) {
         document.getElementById(window.currentSelected.category4 + '_dishwasher_control_text').innerHTML = "Control Panel";
      }
      if (document.getElementById(window.currentSelected.category4 + '_dishwasher_text') != null) {
         document.getElementById(window.currentSelected.category4 + '_dishwasher_text').innerHTML = "View Interior";
      }
      window.yMinLimit = 0.9217299500000005;
      window.yMaxLimit = 6.035103303941548;
      window.valueForMin = 4.7;
      window.valueForMax = 0.9217299500000005;
      window.setZoomValue(-60, -25, 25, 60, 120, 150, 130);
      // console.log(window.currentConfig.hideVisibleInternal);
      hideInternals();
      // check if combo cooktop is ON
      if (window.STR3065HS_table_cooktop) {
         setTimeout(() => {
            window.scene.groupApplyState('STR3065HS_Table_OFF');
         }, 2000);
      }
      if (window.cooktop_position == "island") {
         window.scene.groupApplyState('SDH3042DB_Table_off');
         window.scene.groupApplyState('SDH3652DB_Table_off');
         window.scene.groupApplyState('SCR3042FB_Table_OFF');
         window.scene.groupApplyState('Without_Table_Shadow');
         window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');
      }
      window.hideAlexaBoxCallouts();
      window.reverseState();
      
      //use switch case
      console.log(window.currentSelected.category4, 'window.currentSelected------------')
      switch (window.currentSelected.category4) {
         case 'SDW6747GS':
            // fadein fadeout effect    
            //document.getElementById('maincanvasContainer').style.opacity = 0;
            //window.fading();
            window.scene.groupApplyState('SDW6747GS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6757ES_off');
               window.scene.groupApplyState('SDW6767HS_off');
               window.scene.groupApplyState('SDW6747GS_on');
               window.scene.groupApplyState('SDW6888JS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6736MS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6726MS_OFF');
               window.scene.groupApplyState('SDW6504MS_off');
               window.scene.groupApplyState('SDW6747GS_internals_on');
               window.currentConfig.hideVisibleInternal = "SDW6747GS_internals_off";

               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6747GS', 'SDW6747GS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     window.updateHotspotVisibility('SDW6747GS', 'animation4');
                     window.updateHotspotVisibility('SDW6747GS', 'animation41');
                  }, 2000);
               };
            });
            break;
         case 'SDW6767HS':
            await window.FadeOutSharp();
            window.scene.groupApplyState('SDW6767HS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6757ES_off');
               window.scene.groupApplyState('SDW6747GS_off');
               window.scene.groupApplyState('SDW6767HS_on');
               window.scene.groupApplyState('SDW6888JS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6736MS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6726MS_OFF');
               window.scene.groupApplyState('SDW6504MS_off');
               window.scene.groupApplyState('SDW6767HS_internal_on');
               window.currentConfig.hideVisibleInternal = "SDW6767HS_internal_off";
               document.getElementById('alexaBox-container').style.display = 'block'
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6767HS', 'SDW6767HS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     window.updateHotspotVisibility('SDW6767HS', 'animation44');
                     window.updateHotspotVisibility('SDW6767HS', 'animation441');
                     window.scene.groupApplyState('SDW6767HS_Dishwasher_Icon_ON', {}, function () {
                        window.AwardAnimation("SDW6767HS", "SDW6767HS_Dishwasher_Icon")
                     })
                     window.updateHotspotVisibility('SDW6767HS', 'dishwasher_alexaBox');
                  }, 2000);
               };
            });
            break;
         case 'SDW6757ES':
            // window.scene.groupApplyState('SDW6747GS_off');
            window.scene.groupApplyState('SDW6757ES_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6747GS_off');
               window.scene.groupApplyState('SDW6767HS_off');
               window.scene.groupApplyState('SDW6888JS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6757ES_in_on');
               window.scene.groupApplyState('SDW6736MS_OFF');
               window.scene.groupApplyState('SDW6726MS_OFF');
               window.scene.groupApplyState('SDW6504MS_off');
               window.currentConfig.hideVisibleInternal = "SDW6757ES_in_off";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6757ES', 'SDW6757ES_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SDW6757ES', 'animation4_1');
                     window.updateHotspotVisibility('SDW6757ES', 'animation4_11');
                  }, 2000);
               };
            });
            break;
         case 'SDW6888JS':
            window.scene.groupApplyState('SDW6888JS_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6767HS_off');
               window.scene.groupApplyState('SDW6757ES_off');
               window.scene.groupApplyState('SDW6747GS_off');
               window.scene.groupApplyState('SDW6888JS_ON');
               window.scene.groupApplyState('SDW6736MS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6726MS_OFF');
               window.scene.groupApplyState('SDW6504MS_off');
               window.currentConfig.hideVisibleInternal = "SDW6888JS_INT_OFF";
               document.getElementById('alexaBox-container').style.display = 'block'

               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6888JS', 'SDW6888JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SDW6888JS', 'animation444_1');
                     window.updateHotspotVisibility('SDW6888JS', 'animation444_11');
                     window.scene.groupApplyState('SDW6767HS_Dishwasher_Icon_ON', {}, function () {
                        window.AwardAnimation("SDW6888JS", "SDW6767HS_Dishwasher_Icon")
                     })
                     window.updateHotspotVisibility('SDW6888JS', 'dishwasher_alexaBox');
                     window.scene.groupApplyState('SDW6506JS_off');
                  }, 2000);
               };
            });
            break;
         case 'SDW6506JS':
            window.scene.groupApplyState('SDW6506JS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6767HS_off');
               window.scene.groupApplyState('SDW6757ES_off');
               window.scene.groupApplyState('SDW6747GS_off');
               window.scene.groupApplyState('SDW6888JS_OFF');
               window.scene.groupApplyState('SDW6736MS_OFF');
               window.scene.groupApplyState('SDW6726MS_OFF');
               window.scene.groupApplyState('SDW6504MS_off');

               window.currentConfig.hideVisibleInternal = "SDW6506JS_off";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6506JS', 'SDW6506JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SDW6506JS', 'animation445_1');
                     window.updateHotspotVisibility('SDW6506JS', 'animation445_2');
                  }, 2000);
               };
            });
            break;
         case 'SDW6736MS':
            window.scene.groupApplyState('SDW6736MS_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6767HS_off');
               window.scene.groupApplyState('SDW6757ES_off');
               window.scene.groupApplyState('SDW6747GS_off');
               window.scene.groupApplyState('SDW6888JS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6726MS_OFF');
                window.scene.groupApplyState('SDW6504MS_off');
               window.currentConfig.hideVisibleInternal = "SDW6736MS_Internal_OFF";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6736MS', 'SDW6736MS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SDW6736MS', 'animation4_7');
                     window.updateHotspotVisibility('SDW6736MS', 'animation4_7_1');
                  }, 2000);
               };
            });
            break;
         case 'SDW6504MS':
               window.scene.groupApplyState('SDW6504MS_on', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SDW6767HS_off');
                  window.scene.groupApplyState('SDW6757ES_off');
                  window.scene.groupApplyState('SDW6747GS_off');
                  window.scene.groupApplyState('SDW6888JS_OFF');
                  window.scene.groupApplyState('SDW6736MS_OFF');
                  window.scene.groupApplyState('SDW6726MS_OFF');
                  window.scene.groupApplyState('SDW6506JS_off');
                  window.scene.groupApplyState('SDW6504MS_Tray_OFF')
                  window.currentConfig.hideVisibleInternal = "SDW6506JS_off";
               });
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6504MS', 'SDW6504MS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SDW6504MS', 'animation4_8');
                     window.updateHotspotVisibility('SDW6504MS', 'animation4_8_1');
                  }, 2000);
               };
         break;
         case 'SDW6726MS':
            window.scene.groupApplyState('SDW6736MS_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SDW6767HS_off');
               window.scene.groupApplyState('SDW6757ES_off');
               window.scene.groupApplyState('SDW6747GS_off');
               window.scene.groupApplyState('SDW6888JS_OFF');
               window.scene.groupApplyState('SDW6506JS_off');
               window.scene.groupApplyState('SDW6726MS_Door');
            });
               window.currentConfig.hideVisibleInternal = "SDW6506JS_off";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDW6726MS', 'SDW6726MS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SDW6726MS', 'animation4_9');
                     window.updateHotspotVisibility('SDW6726MS', 'animation4_9_1');
                  }, 2000);
               };
         break;
            default:
            break;
      }
      if (bCategoryChanged) {
         setExpanded('panel4');
      }
      window.scene.groupApplyState(Products.category4.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat2. bCategoryChanged=',bCategoryChanged);
         fourthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      });//AAATONI);
      //end
      window.scene.groupApplyState('Side_Table_on');
      window.scene.groupApplyState(window.currentSelected.category4 + '_on');
      document.getElementById('demoDiv').style.height = '1250px';
      // console.log("----------------Checking Expanded----------------");
      // console.log(expanded);
         
         setTimeout(function () {
            window.setMenuScroll('panel4bh-header')
         }, 500);

         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 197);
         } else {
               document.getElementById("scroll_panel").scrollTo(0, 192);
         }
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category4.icon_stable').classList.add('selectDrawer');
      var temp_array = [0.3839546928204136, 0.01747399999999999, 1.6628646370462126, -22.795981798534676, 145.28899254897473];
      window.GotoPosInTimeNamedValue(temp_array, window.config.dishwasher, function () {
         document.querySelector('#container').style.pointerEvents = "auto";
      }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_dishwasher-0", true) });
      setTimeout(() => {
         window.scene.groupApplyState('Table_off');
         window.scene.groupApplyState('New_Drawer_Part_Off');
         window.scene.groupApplyState('Without_Table_Shadow');
         window.hide_all_drawer_oven_product();
         window.scene.groupApplyState(window.currentSelected.category1 + '_off');
         document.getElementById('internalLoader').classList.remove('show');
         document.getElementById('internalLoader').classList.add('hide');
         window.scene.groupApplyState('microwave_2_off');
         window.scene.groupApplyState('SMD2449FS_off');
         window.scene.groupApplyState('SMD2470AH_off');
         window.scene.groupApplyState('microwave_Table_Big_door_Off');
      }, 500);
      window.hide_all_oven();
      document.getElementById("hotspot1").style.visibility = 'hidden';
   }

   async function fifthDrawerDemoOnCompleted(bCategoryChanged, cb, itemToAdd) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      window.scene.setDoFTargetObject("new_sharp_cooktop-0");
      if (cb) {
         setTimeout(function () {
            //document.getElementById("hotspot2").style.visibility = 'visible';
            if (itemToAdd === Products.category5.items.findIndex((element) => element.id === window.currentSelected.category5)) {
               // console.log("AAATONI. cb at cat5");
               cb();
            } else {
               //   console.log("AAATONI. You clicked too quick");
            }
         }, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }
   // const fifthDrawerDemo = () => {
   async function fifthDrawerDemo(itemToAdd, previousItem) {
      console.log("cookTop drawer is called fifthDrawerDemo");
      if (window.congigurePlace == "third" || window.congigurePlace == "fourth") {
         window.scene.groupApplyState('Table_on');
         window.scene.groupApplyState('With_Table_Shadow');
      }
      window.pedestalCompability = true;
      window.congigurePlace = "fifth";
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }

      
      document.getElementById("select_STR3065HS").style.display = "none";
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none';
      document.getElementById('demoDiv').style.height = '1230px';
      if (expanded == 'panel2') {
         // console.log("here is panel 2 fifth expanded");
         document.getElementById("scroll_panel").scrollTo(0, 250);
      } else if (expanded == 'panel3') {
         // console.log("here is panel3 in fifth else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 425);
      } else if (expanded == 'panel7') {
         // console.log("here is panel7 in fifth else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 405);
      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 246);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 240);
         }
      }
      setTimeout(function () {
         window.setMenuScroll('panel5bh-header')
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category5.icon_stable').classList.add('selectDrawer');
      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      window.pedestalComp();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }
      window.currentConfig.currentDrawer = "cooktop";
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;
      if (document.getElementById(window.currentSelected.category5 + '_control_text') != null) {
         document.getElementById(window.currentSelected.category5 + '_control_text').innerHTML = "View Control Panel";
      }
      document.getElementById('SCR3042FB_control_text').innerHTML = "View Control Panel";
      document.getElementById('SDH3042DB_cooktop_text').innerHTML = "View Control Panel";
      document.getElementById('SDH3652DB_cooktop_text').innerHTML = "View Control Panel";
      if (window.ranges_position == "side") {
         window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_OFF');
      } else {
         window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      }
      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         if (!window.preventFade) {
            await window.FadeOutSharp(); //AAATONI
         }
         // console.log('AAATONI. after FadeOutSharp');
         // console.log('AAATONI. starting groupApplyStates');
         //Hide previous appliance
         // window.scene.groupApplyState(Products.category5.items[previousItem].productShow.replace("_on","_off"));
      }
      if (bCategoryChanged) {
         window.scene.groupApplyState('Wall_oven_hide_part_on');
         window.scene.groupApplyState('Microwave_drawer_hide_On');
         document.getElementById("hotspot3").style.visibility = 'visible';
         setExpanded('panel5');
      }
      window.cookTop = true;
      // Clear Radio Button values
      document.getElementById("select_cooktop_drawer").checked = false;
      document.getElementById("select_cooktop_cooktop").checked = false;
      if (window.STR3065HS_table_cooktop) {
         // this is for Island table cooktop
         window.scene.groupApplyState('STR3065HS_Table_OFF');
         window.scene.groupApplyState('Old_Centre_Table_ON');
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('Rangehood_Cabinet_OFF');
         window.scene.groupApplyState('Double_self_on');
         // Enable last selected Range Hood
         window.scene.groupApplyState(window.localStorage.getItem('rangehood'));
         // Enable Microwave
         window.scene.groupApplyState(window.localStorage.getItem('microwave'));
         window.scene.groupApplyState('New_Drawer_Part_Off');
         window.STR3065HS_table_cooktop = false;

      }
      if (window.STR3065HS_cooktop) {
         // this is for side platform cooktop
         window.scene.groupApplyState('STR3065HS_OFF');
         window.scene.groupApplyState('Cooktop_Regular_Cabinet_On');
         // we have to on last selected Microwave drawer
         window.scene.groupApplyState(window.localStorage.getItem('microwave'));
         window.scene.groupApplyState('New_Drawer_Part_Off');
         window.STR3065HS_cooktop = false;
      }

      window.scene.groupApplyState('Side_Table_on');
      //hide for checking
      window.scene.groupApplyState(window.localStorage.getItem('dishwasher'));

      console.log("======", window.cooktop_position);
      if (window.cooktop_position == "side") {
         // Here we hve a Existing Cooktop Conditions 
         window.yMinLimit = 2.253813205497491;
         window.yMaxLimit = 0.6374979715581001;
         window.valueForMin = 6;
         window.valueForMax = 0.1374979715581001;
         window.setZoomValue(-40, -20, 40, 60, 120, 270, 130);
         window.scene.groupApplyState("SCR3042FB_Table_OFF");
         window.scene.groupApplyState("SDH3042DB_Table_OFF");
         window.scene.groupApplyState("SDH3652DB_Table_OFF");
         window.scene.groupApplyState("SCH3043GB_cooktop_Table_OFF");
         // window.scene.groupApplyState('Marble_Fill_OFF');
         window.ranges_position = '';
         if (window.mob) {
            var temp_array = [1.1738393715580993, 0.5584866776461629, -12.218268501958836, 4.368326018130022, 295];
         } else {
            var temp_array = [1.1738393715580993, 0.5584866776461629, -26.218268501958836, 4.368326018130022, 270];
         }
         window.GotoPosInTimeNamedValue(temp_array, window.config.cooktops, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_cooktop-0", true) });
         window.hide_all_oven();
         window.scene.groupApplyState('Rangehood_Cabinet_OFF');
         window.scene.groupApplyState("Cooktop_Regular_Cabinet_On");
         window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
         window.scene.groupApplyState("SSG3061JS_Rangetop_Table_OFF");
         window.scene.groupApplyState("SSG3061JS_Rangetop_OFF");
         window.scene.groupApplyState("SSG3061JS_Rangetop_Int_OFF");
         window.scene.groupApplyState(window.localStorage.getItem('rangehood'));
         window.hideAlexaBoxCallouts();
         window.reverseState();
         //use switch case
         switch (window.currentSelected.category5) {
            case 'SDH3042DB':
               window.scene.groupApplyState('SDH3042DB_on', {}, function () {
                  window.scene.groupApplyState('SDH3652DB_off');
                  window.scene.groupApplyState('SCR3042FB_off');
                  window.scene.groupApplyState('Marble_Fill_OFF');
                  displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        document.getElementById("animation6").style.visibility = 'visible';
                        window.updateHotspotVisibility('SDH3042DB', 'animation6_5');
                        window.updateCalloutPopupVisibility('SDH3042DB', 'SDH3042DB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     }, 2000);
                  };
               });
               break;
            case 'SDH3652DB':
               window.scene.groupApplyState('SDH3652DB_on', {}, function () {
                  window.scene.groupApplyState('SDH3042DB_off');
                  window.scene.groupApplyState('SCR3042FB_off');
                  window.scene.groupApplyState('SCH3043GB_off');
                  window.scene.groupApplyState('Marble_Fill_OFF');
                  // fadein fadeout effect                
                  displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        window.updateCalloutPopupVisibility('SDH3652DB', 'SDH3652DB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                        window.updateHotspotVisibility('SDH3652DB', 'animation6_1');
                        window.updateHotspotVisibility('SDH3652DB', 'animation6_5');
                     }, 2000);
                  };
               });
               break;
            case 'SCR3042FB':
               window.scene.groupApplyState('SCR3042FB_on', {}, function () {
                  window.scene.groupApplyState('SDH3042DB_off');
                  window.scene.groupApplyState('SDH3652DB_off');
                  window.scene.groupApplyState('SCH3043GB_off');
                  window.scene.groupApplyState('Marble_Fill_OFF');
                  displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        window.updateCalloutPopupVisibility('SCR3042FB', 'SCR3042FB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                        window.updateHotspotVisibility('SCR3042FB', 'animation6_2');
                        window.updateHotspotVisibility('SCR3042FB', 'animation6_3');
                        window.updateHotspotVisibility('SCR3042FB', 'animation6_4');
                        window.updateHotspotVisibility('SCR3042FB', 'animation6_5');
                     }, 2000);
                     document.getElementById("SCR3042FB_accessory_text").innerHTML = 'View Accessory';
                  };
               });
               break;
            case 'SCH3043GB':
               await window.FadeOutSharp(); //AAATONI
               window.scene.groupApplyState('SCH3043GB_on', {}, function () {
                  // window.scene.groupApplyState('SCH3043GB_Cooktop_ON', {}, function () {
                     document.getElementById('internalLoader').classList.remove('show');
                     document.getElementById('internalLoader').classList.add('hide');
                     window.scene.groupApplyState('SDH3042DB_off');
                     window.scene.groupApplyState('SDH3652DB_off');
                     window.scene.groupApplyState('SCR3042FB_off');
                     window.scene.groupApplyState('Marble_Fill_OFF');

                     // displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        window.updateCalloutPopupVisibility('SCH3043GB', 'SCH3043GB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                        window.updateHotspotVisibility('SCH3043GB', 'animation6_7');
                        window.updateHotspotVisibility('SCH3043GB', 'animation6_8');
                        window.updateHotspotVisibility('SCH3043GB', 'animation6_9');
                        window.updateHotspotVisibility('SCH3043GB', 'animation6_5');
                     }, 2000);
                     // document.getElementById("SCR3042FB_accessory_text").innerHTML = 'View Accessory';
                     // };
                  // });
               });
               break;
            default:
               break;
         }
         if (!bCategoryChanged) {
            await window.FadeOutSharp(); //AAATONI
            window.scene.groupApplyState(Products.category5.items[itemToAdd].productShow, {}, function () {
               // console.log('AAATONI cb cat5. bCategoryChanged=',bCategoryChanged);
               fifthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted, itemToAdd);
            });//AAATONI
         } else {
            fifthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted, itemToAdd);
         }

      } else if (window.cooktop_position == "island") {
         document.getElementById("SDH3652DB_island_cooktop_text").innerHTML = "View Control Panel";
         document.getElementById("SDH3042DB_island_cooktop_text").innerHTML = "View Control Panel";
         document.getElementById("SCR3042FB_island_surface_text").innerHTML = "Cooktop Surface Close-Up";
         document.getElementById("SCR3042FB_island_accessory_text").innerHTML = 'View Accessory';
         document.getElementById("SCR3042FB_island_control_text").innerHTML = "View Control Panel";
         // Here we have to make a whole scenario for cooktop Island 
         window.yMinLimit = 2.253813205497491;
         window.yMaxLimit = 0.6374979715581001;
         window.valueForMin = 6;
         window.valueForMax = 0.1374979715581001;
         window.setZoomValue(-40, -20, 40, 60, 120, 270, 130);
         window.scene.groupApplyState('Table_on');
         window.reverseState();
         if (window.mob) {
            temp_array = [1.157999930066663, 0.6289071520002449, -25.581215033020943, 14.560298794391151, 150];
         } else {
            temp_array = [1.157999930066663, 0.6289071520002449, -25.581215033020943, 14.560298794391151, 150];
         }
         window.GotoPosInTimeNamedValue(temp_array, window.config.drawer_cooktop, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
            window.scene.setDoFTargetObject("cooktoptabledof-0");
            
            if (window.ranges_position == "side") {
               var currentranges = window.localStorage.getItem('ranges');
               if (currentranges == "SSG3061JS" || currentranges == "SSG3065JS") {
                  window.scene.groupApplyState('Normal_Induction');
               }
               if (currentranges == "SSR3061JS" || currentranges == "SSR3065JS") {
                  window.scene.groupApplyState('Electric_Induction');
               }
               var currentRangehood = window.localStorage.getItem('rangehood');
               if (currentRangehood == "SHC3662FS_on") {
                  window.scene.groupApplyState('SHC3662FS_on');
               }
               if (currentRangehood == "SHC3042FS_on" || currentRangehood == "SHC3062FS_on") {
                  window.scene.groupApplyState('SHC3062FS_on');
               }
               window.scene.groupApplyState('Marble_Fill_OFF');
            } else {
               window.scene.groupApplyState('Marble_Fill_ON');
            }
            setTimeout(function () {
               window.scene.groupApplyState('SDH3042DB_off');
               window.scene.groupApplyState('SDH3652DB_off');
               window.scene.groupApplyState('SCR3042FB_off');
               window.scene.groupApplyState('SHC3662FS_off');
               window.scene.groupApplyState('SHC3062FS_off');
               window.scene.groupApplyState('SCH3043GB_off');
               if (window.ranges_position != "side") {
                  window.scene.groupApplyState('Cooktop_Regular_Cabinet_ON');
                  window.scene.groupApplyState('Rangehood_Cabinet_ON');
               }
               window.scene.groupApplyState('Fridge_side_wall_on');
               window.scene.groupApplyState('With_Table_Shadow');
               document.getElementById("hotspot3").style.visibility = 'hidden';
            }, 1800);
         }, window.slowinout2, { target: window.scene.getObjectLocation("STR3065HS_T_dof_obj-0", true) });
         window.hide_all_oven();

         //use switch case
         switch (window.currentSelected.category5) {
            case 'SDH3042DB':
               window.scene.groupApplyState('SDH3042DB_Table_ON', {}, function () {
                  window.scene.groupApplyState('SDH3652DB_Table_OFF');
                  window.scene.groupApplyState('SCR3042FB_Table_OFF');
                  window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');
                  window.setTimeout(function () {
                     window.updateHotspotVisibility('SDH3042DB', 'animation_island6');
                     window.updateHotspotVisibility('SDH3042DB', 'animation6_6');
                     window.updateCalloutPopupVisibility('SDH3042DB', 'SDH3042DB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  }, 2000);
                  displayTextsOnCompleted = function () {
                  };
               });

               break;
            case 'SDH3652DB':
               window.scene.groupApplyState('SDH3652DB_Table_ON', {}, function () {
                  window.scene.groupApplyState('SDH3042DB_Table_OFF');
                  window.scene.groupApplyState('SCR3042FB_Table_OFF');
                  window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SDH3652DB', 'SDH3652DB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     window.updateHotspotVisibility('SDH3652DB', 'animation_island6_1');
                     window.updateHotspotVisibility('SDH3652DB', 'animation6_6');
                  }, 2000);
                  // fadein fadeout effect                
                  displayTextsOnCompleted = function () {
                  };
               });
               break;
            case 'SCR3042FB':
               window.scene.groupApplyState('SCR3042FB_Table_ON', {}, function () {
                  window.scene.groupApplyState('SDH3042DB_Table_OFF');
                  window.scene.groupApplyState('SDH3652DB_Table_OFF');
                  window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');

                  console.log('inside table');
                  window.setTimeout(function () {
                     window.scene.groupApplyState('Centre_Table_Marble_OFF');
                     window.updateCalloutPopupVisibility('SCR3042FB', 'SCR3042FB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     window.updateHotspotVisibility('SCR3042FB', 'animation_island6_2');
                     window.updateHotspotVisibility('SCR3042FB', 'animation_island6_3');
                     window.updateHotspotVisibility('SCR3042FB', 'animation_island6_4');
                     window.updateHotspotVisibility('SCR3042FB', 'animation6_6');
                  }, 2000);
                  displayTextsOnCompleted = function () {
                     document.getElementById("SCR3042FB_accessory_text").innerHTML = 'View Accessory';

                  };
               });
               break;
            case 'SCH3043GB':
               window.scene.groupApplyState('SCH3043GB_cooktop_Table_ON', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SDH3042DB_Table_OFF');
                  window.scene.groupApplyState('SDH3652DB_Table_OFF');
                  window.scene.groupApplyState('SCR3042FB_Table_OFF');
                  window.scene.groupApplyState('Centre_Table_Marble_OFF');

                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SCH3043GB', 'SCH3043GB_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     window.updateHotspotVisibility('SCH3043GB', 'animation6_7');
                     window.updateHotspotVisibility('SCH3043GB', 'animation6_8');
                     window.updateHotspotVisibility('SCH3043GB', 'animation6_9');
                     window.updateHotspotVisibility('SCH3043GB', 'animation6_6');
                  }, 2000);
                  // };
               });
               break;
            default:
               break;
         }
         if (!bCategoryChanged) {

            window.scene.groupApplyState('SCR3042FB_Table_OFF');
            window.scene.groupApplyState('SDH3042DB_Table_OFF');
            window.scene.groupApplyState('SDH3652DB_Table_OFF');
            window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');
            let selectedCooktop = window.currentSelected.category5;
            let selectApplyState = "";
            if (selectedCooktop == "SCR3042FB") {
               selectApplyState = "SCR3042FB_Table_ON";
            } else if (selectedCooktop == "SDH3042DB") {
               selectApplyState = "SDH3042DB_Table_ON";
            } else if (selectedCooktop == "SDH3652DB") {
               selectApplyState = "SDH3652DB_Table_ON";
            }
            window.scene.groupApplyState(selectApplyState, {}, function () {
               // console.log('AAATONI cb cat5. bCategoryChanged=',bCategoryChanged);
               fifthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted, itemToAdd);
            });//AAATONI
         } else {
            fifthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted, itemToAdd);
         }
      }
   }

   async function sixthDrawerDemoOnCompleted(bCategoryChanged, cb, itemToAdd) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      window.scene.setDoFTargetObject("new_sharp_hoodrange-0");
      if (cb) {
         setTimeout(function () {
            if (itemToAdd === Products.category6.items.findIndex((element) => element.id === window.currentSelected.category6)) {
               // console.log("AAATONI. cb at cat6");
               cb();
            } else {
               // console.log("AAATONI. You clicked too quick");
            }
         }, bCategoryChanged ? 1800 : 800);
      }
   }

   // const sixthDrawerDemo = () => {
   async function sixthDrawerDemo(itemToAdd, previousItem, previousItem7) {
      window.congigurePlace = "sixth";
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      window.pedestalCompability = true;
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";

      if (window.SWB3085HS_walloven) {
         document.querySelector("#hotspot4 .text").innerHTML = 'Wall Oven + Microwave Drawer\u2122 Ovens';
      }
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      window.hoodRange = true;
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      window.currentConfig.currentDrawer = "reset";
      window.scene.groupApplyState('Rangehood_Cabinet_OFF');
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      window.pedestalComp();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var j = 0; j < animations.length; j++) {
         animations[j].style.visibility = 'hidden';
      }

      var currentRangehood = window.localStorage.getItem('rangehood');
      if (currentRangehood == "SHC3042FS_on" || currentRangehood == "SHC3062FS_on") {
         if (document.getElementById(window.currentSelected.category6 + '_control_text') != null) {
            document.getElementById(window.currentSelected.category6 + '_control_text').innerHTML = "Control Panel Close-Up";
         }
         if (document.getElementById(window.currentSelected.category6 + '_underneath_text') != null) {
            document.getElementById(window.currentSelected.category6 + '_underneath_text').innerHTML = "Under the Hood";
         }
      } else {
         if (document.getElementById(window.currentSelected.category6 + '_control_text') != null) {
            document.getElementById(window.currentSelected.category6 + '_control_text').innerHTML = "Control Panel";
         }
         if (document.getElementById(window.currentSelected.category6 + '_underneath_text') != null) {
            document.getElementById(window.currentSelected.category6 + '_underneath_text').innerHTML = "Under the Hood";
         }
      }
      if (!bCategoryChanged) {
         await window.FadeOutSharp(); //AAATONI
         window.scene.groupApplyState('SMO1652DS_off');
         window.scene.groupApplyState('SMO1854DS_off');
         window.scene.groupApplyState('over_the_range_shelf_off');
         window.scene.groupApplyState('SMO1652_self_off');
         window.scene.groupApplyState('Side_Table_on');
      } else {
         window.scene.groupApplyState('SMO1652DS_off');
         window.scene.groupApplyState('SMO1854DS_off');
         window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_OFF');
         window.scene.groupApplyState('SH_2051_SMO1759JS_OFF');
         window.scene.groupApplyState('over_the_range_shelf_off');
         window.scene.groupApplyState('SMO1652_self_off');
         window.scene.groupApplyState('Wall_oven_hide_part_on');
         window.scene.groupApplyState('Microwave_drawer_hide_On');
         setExpanded('panel6');
         document.getElementById('demoDiv').style.height = '1278px';
      }
      window.cookTop = false;
      window.overTheRange = false;
      document.querySelector('#hotspot3 .text').innerHTML = 'Range hoods';
      if (window.ranges_position == 'side') {
         document.getElementById("hotspot11").style.visibility = 'visible';
         document.getElementById("hotspot2").style.visibility = 'hidden';
      } else {
         document.getElementById("hotspot2").style.visibility = 'visible';
         document.getElementById("hotspot11").style.visibility = 'hidden';
      }
      document.getElementById("hotspot3").style.visibility = 'visible';
      document.getElementById("hotspot4").style.visibility = 'visible';
      window.yMinLimit = 2.2939382772127528;
      window.yMaxLimit = 0.9195412170673495;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-60, -10, 60, 40, 75, 150, 130);
      if (expanded == 'panel2') {
         // console.log("here is panel 2 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 543);
         }
      } else if (expanded == 'panel3') {
         // console.log("here panel3 in sixth is else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 493);
      } else if (expanded == 'panel5') {
         // console.log("here is panel5 else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 298);
      } else if (expanded == 'panel6') {
         document.getElementById("scroll_panel").scrollTo(0, 505);
      } else if (expanded == 'panel7') {
         // console.log("here is panel 7 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 505);
         }
      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
      }
      setTimeout(function () {
         window.setMenuScroll('panel6bh-header');
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category6.icon_stable').classList.add('selectDrawer');
      if (window.STR3065HS_table_cooktop) {
         // this is for Island table cooktop
         window.scene.groupApplyState('STR3065HS_Table_OFF');
         window.scene.groupApplyState('Old_Centre_Table_ON');
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('Rangehood_Cabinet_OFF');
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
         // Enable last selected Range Hood
         window.scene.groupApplyState(window.localStorage.getItem('rangehood'));
         setTimeout(function () {
            // Enable Microwave
            window.scene.groupApplyState(window.localStorage.getItem('microwave'));
            window.scene.groupApplyState('New_Drawer_Part_Off');
         }, 3500);
         window.STR3065HS_table_cooktop = false;
      }
      if (window.STR3065HS_cooktop) {
         document.getElementById("hotspot8").style.visibility = 'visible';
         document.getElementById("hotspot2").style.visibility = 'hidden';
         setTimeout(() => {
            document.getElementById("hotspot2").style.visibility = 'hidden';
         }, 2000);
      }
      if (window.cooktop_position == "island") {
         setTimeout(() => {
            window.scene.groupApplyState('SDH3042DB_Table_off');
            window.scene.groupApplyState('SDH3652DB_Table_off');
            window.scene.groupApplyState('SCR3042FB_Table_OFF');
            window.scene.groupApplyState('SCH3043GB_cooktop_Table_OFF');
         }, 3000);
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
         document.getElementById("hotspot2").style.visibility = 'visible';
         window.cooktop_position = "side";
         
      }
      window.hideAlexaBoxCallouts();
      window.reverseState();
      //use switch case
      switch (window.currentSelected.category6) {
         case 'SHC3662FS':
            window.scene.groupApplyState('SHC3662FS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SHC3062FS_off');
               displayTextsOnCompleted = function () {
                  window.updateHotspotVisibility('SHC3662FS', 'animation7');
                  window.updateHotspotVisibility('SHC3662FS', 'animation7_1');
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SHC3662FS', 'SHC3662FS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  }, 2000);
                  if (window.mob) {
                     var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, 6.9890517124872888, 127.95918253135886];

                  } else {
                     var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, -1.9890517124872888, 127.95918253135886];

                  }
                  window.GotoPosInTimeNamedValue(temp_array, window.config.rangehoods, function () {
                     document.querySelector('#container').style.pointerEvents = "auto";
                  }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_hoodrange-0", true) });
               };
            });
            break;
         case 'SHC3062FS':
            window.scene.groupApplyState('SHC3062FS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SHC3662FS_off');
               // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SHC3062FS', 'SHC3062FS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SHC3062FS', 'animation7_2');
                     window.updateHotspotVisibility('SHC3062FS', 'animation7_3');
                  }, 2000);
                  if (window.mob) {
                     var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, 6.9890517124872888, 127.95918253135886];
                  } else {
                     var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, -1.9890517124872888, 127.95918253135886];
                  }
                  window.GotoPosInTimeNamedValue(temp_array, window.config.rangehoods, function () {
                     document.querySelector('#container').style.pointerEvents = "auto";
                  }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_hoodrange-0", true) });
               // };
            });
            break;
         case 'SHC3042FS':
            window.scene.groupApplyState('SHC3062FS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SHC3662FS_off');
               window.setTimeout(function () {
                  window.updateCalloutPopupVisibility('SHC3042FS', 'SHC3042FS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                  // enable animation callouts
                  window.updateHotspotVisibility('SHC3042FS', 'animation7_4');
                  window.updateHotspotVisibility('SHC3042FS', 'animation7_5');
               }, 2000);
               if (window.mob) {
                  var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, 6.9890517124872888, 127.95918253135886];

               } else {
                  var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, -1.9890517124872888, 127.95918253135886];
               }
               window.GotoPosInTimeNamedValue(temp_array, window.config.rangehoods, function () {
                  document.querySelector('#container').style.pointerEvents = "auto";
               }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_hoodrange-0", true) });
            });
            break;
         default:
            break;
      }
      window.scene.groupApplyState(Products.category6.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat6. bCategoryChanged=',bCategoryChanged);
         sixthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted, itemToAdd);
      });//AAATONI
      // hiding callouts
      document.getElementById("hotspot1").style.display = 'none';
      document.getElementById("hotspot6").style.display = 'none';
      window.hide_all_oven();
      document.getElementById("hotspot3").style.visibility = 'hidden';
   }
   async function seventhDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      // window.scene.setDoFTargetObject("new_sharp_hoodrange-0");
      window.scene.setDoFTargetObject("extarnal1-0");
      if (cb) {
         setTimeout(function c7() {
            if (window.ranges_position == "side") {
               document.getElementById("hotspot11").style.visibility = 'visible';
               document.getElementById("hotspot2").style.visibility = 'hidden';
            } else {
               document.getElementById("hotspot2").style.visibility = 'visible';
               document.getElementById("hotspot11").style.visibility = 'hidden';
            }
            if (document.getElementById("select_SMD3070AS").style.display == "flex") {
               document.getElementById("select_SMD3070AS").style.display = "none";
            }
            //document.getElementById("hotspot3").style.visibility = 'visible';
            document.getElementById("hotspot4").style.visibility = 'visible';
            cb();
         }, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }
   //  const seventhDrawerDemo = () => {
   async function seventhDrawerDemo(itemToAdd, previousItem, previousItem6) {
      window.congigurePlace = "seventh";
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      window.pedestalCompability = true;
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";
      if (window.SWB3085HS_walloven) {
         document.querySelector("#hotspot4 .text").innerHTML = 'Wall Oven + Microwave Drawer\u2122 Ovens';
      }
      if (window.ranges_position == "side") {
         document.getElementById("hotspot11").style.visibility = 'visible';
         document.getElementById("hotspot2").style.visibility = 'hidden';
      } else {
         document.getElementById("hotspot2").style.visibility = 'visible';
         document.getElementById("hotspot11").style.visibility = 'hidden';
      }
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      window.overTheRange = true;
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      window.currentConfig.currentDrawer = "overTheRange";
      window.scene.groupApplyState('Rangehood_Cabinet_OFF');
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;
      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      window.pedestalComp();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var j = 0; j < animations.length; j++) {
         animations[j].style.visibility = 'hidden';
      }
      if (document.getElementById(window.currentSelected.category7 + '_over_range_text') != null) {
         document.getElementById(window.currentSelected.category7 + '_over_range_text').innerHTML = "Open Microwave";

      }
      if (document.getElementById(window.currentSelected.category7 + '_over_range_text_control') != null) {
         document.getElementById(window.currentSelected.category7 + '_over_range_text_control').innerHTML = "Control Panel";
      }
      if (document.getElementById(window.currentSelected.category7 + '_over_range_text_underneath') != null) {
         document.getElementById(window.currentSelected.category7 + '_over_range_text_underneath').innerHTML = "Underneath Close Up";
      }
      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         await window.FadeOutSharp(); //AAATONI
      } else {
         await window.FadeOutSharp(); //AAATONI
         setExpanded('panel7');
      }
      window.cookTop = false;
      window.hoodRange = false;
      document.querySelector('#hotspot3 .text').innerHTML = 'Over-the-Range Microwave Ovens';
      document.getElementById("hotspot3").style.visibility = 'visible';
      document.getElementById("hotspot4").style.visibility = 'visible';
      window.yMinLimit = 2.2939382772127528;
      window.yMaxLimit = 0.9195412170673495;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-60, -10, 60, 40, 75, 150, 130);
      document.getElementById('demoDiv').style.height = '1030px';
      document.getElementById("scroll_panel").scrollTo(0, 49);
      setTimeout(function () {
         window.setMenuScroll('panel7bh-header')
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category7.icon_stable').classList.add('selectDrawer');
      if (window.STR3065HS_table_cooktop) {
         // this is for Island table cooktop
         window.scene.groupApplyState('STR3065HS_Table_OFF', {}, function () {
            window.scene.groupApplyState('Old_Centre_Table_ON');
            window.scene.groupApplyState('Double_self_on');
         });
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('Rangehood_Cabinet_OFF');
         // Enable Microwave
         window.scene.groupApplyState(window.localStorage.getItem('microwave'));
         window.scene.groupApplyState('New_Drawer_Part_Off');
         // Enable last selected Cooktop
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
         window.STR3065HS_table_cooktop = false;
      }
      if (window.STR3065HS_cooktop) {
         document.getElementById("hotspot8").style.visibility = 'visible';
         setTimeout(() => {
            document.getElementById("hotspot2").style.visibility = 'hidden';
         }, 2000);
      }
      window.hideAlexaBoxCallouts();
      window.reverseState();
      //use switch case
      switch (window.currentSelected.category7) {
         case 'SMO1652DS':
            window.scene.groupApplyState('SMO1652DS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SMO1854DS_off');
               window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_OFF');
               window.scene.groupApplyState('SMO1754JS_Oven_OFF');
               window.scene.groupApplyState('SH_2051_SMO1759JS_OFF');
               window.scene.groupApplyState('SMO1652DS_in_on');
               window.scene.groupApplyState('SMO1652DS_Alpha_on');
               window.currentConfig.hideVisibleInternal = "SMO1652DS_in_off";
               displayTextsOnCompleted = function () {
                  window.updateHotspotVisibility('SMO1652DS', 'animation5');
                  window.updateHotspotVisibility('SMO1652DS', 'animation51');
                  window.updateHotspotVisibility('SMO1652DS', 'animation52');
                  window.updateCalloutPopupVisibility('SMO1652DS', 'SMO1652DS_allDrawerss');
               };
            });
            break;
         case 'SMO1854DS':
            window.scene.groupApplyState('SMO1854DS_on', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_OFF');
               window.scene.groupApplyState('SMO1754JS_Oven_OFF');
               window.scene.groupApplyState('SMO1652DS_on');
               window.scene.groupApplyState('SMO1652DS_in_on');
               window.scene.groupApplyState('SMO1845DS_Alpha_on');
               window.scene.groupApplyState('SH_2051_SMO1759JS_OFF');
               window.currentConfig.hideVisibleInternal = "SMO1652DS_in_off";
               displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SMO1854DS', 'SMO1854DS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SMO1854DS', 'animation5_1');
                     window.updateHotspotVisibility('SMO1854DS', 'animation5_11');
                     window.updateHotspotVisibility('SMO1854DS', 'animation5_12');
                  }, 2000);
               };
            });
            break;
         case 'SMO1759JS':
            await window.FadeOutSharp(); //AAATONI
            window.scene.groupApplyState('SH_2051_SMO1759JS_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('SH_2051_SMO1759JS', {}, function () {
                  //  Other model OFF
                  window.scene.groupApplyState('SHC2432FS_off');
                  window.scene.groupApplyState('SHC3662FS_off');
                  window.scene.groupApplyState('SHC3062FS_off');
                  window.scene.groupApplyState('over_the_range_shelf_on');
                  window.scene.groupApplyState('Side_Table_on');
                  window.scene.groupApplyState('SMO1652DS_off');
                  window.scene.groupApplyState('SMO1854DS_off');
                  window.scene.groupApplyState('SMO1754JS_Oven_OFF');
                  window.scene.groupApplyState('SH_2051_SMO1759JS');
                  window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_OFF');
                  document.getElementById('alexaBox-container').style.display = 'block'
                  window.scene.groupApplyState('SMO1759JS_on', {}, function () {
                     // displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        window.updateCalloutPopupVisibility('SMO1759JS', 'SMO1759JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                        // enable animation callouts
                        window.updateHotspotVisibility('SMO1759JS', 'animation5_4');
                        window.updateHotspotVisibility('SMO1759JS', 'animation5_41');
                        window.updateHotspotVisibility('SMO1759JS', 'animation5_42');
                        window.updateHotspotVisibility('SMO1759JS', 'overTheRange_alexaBox');
                     }, 2000);
                     // };
                  });
               });

            });
            break;
         case 'SMO1969JS':
            window.scene.groupApplyState('SH_2051_SMO1759JS_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               //  Other model OFF
               window.scene.groupApplyState('SMO1652DS_off');
               window.scene.groupApplyState('SMO1854DS_off');
               window.scene.groupApplyState('SMO1754JS_Oven_OFF');
               window.scene.groupApplyState('SH_2050_SMO1969JS');
               window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_OFF');
               document.getElementById('alexaBox-container').style.display = 'block'
               window.scene.groupApplyState('SMO1969JS_on', {}, function () {
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SMO1969JS', 'SMO1969JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SMO1969JS', 'animation5_5');
                     window.updateHotspotVisibility('SMO1969JS', 'animation5_51');
                     window.updateHotspotVisibility('SMO1969JS', 'animation5_52');
                     window.updateHotspotVisibility('SMO1969JS', 'overTheRange_alexaBox');
                  }, 2000);
                  // };
               });

            });
            break;
         case 'SMO1754JS':
            window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               // Other model OFF
               window.scene.groupApplyState('SMO1652DS_off');
               window.scene.groupApplyState('SMO1854DS_off');
               window.scene.groupApplyState('SH_2051_SMO1759JS_OFF');
               window.scene.groupApplyState('SH_2052_SMO1754JS');
               window.scene.groupApplyState('SH_2052_SMO1754JS_Grey');
               window.scene.groupApplyState('SH_2052_Oven_Tex_Brown');
               window.scene.groupApplyState('SMO1754JS_on', {}, function () {
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SMO1754JS', 'SMO1754JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SMO1754JS', 'animation5_3');
                     window.updateHotspotVisibility('SMO1754JS', 'animation5_31');
                     window.updateHotspotVisibility('SMO1754JS', 'animation5_32');
                  }, 2000);
                  // };
               });
            });
            break;
         case 'SMO1752JS':
            window.scene.groupApplyState('SH_2052_SMO1754JS_Oven_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               // Other model OFF
               window.scene.groupApplyState('SMO1652DS_off');
               window.scene.groupApplyState('SMO1854DS_off');
               window.scene.groupApplyState('SH_2051_SMO1759JS_OFF');
               window.scene.groupApplyState('SH_2052_SMO1754JS');
               window.scene.groupApplyState('SH_1983_SMO1752JS_White');
               window.scene.groupApplyState('SH_1983_Oven_Tex_Black');
               window.scene.groupApplyState('SMO1752JS_on', {}, function () {
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SMO1752JS', 'SMO1752JS_allDrawerss'); // @uthor:YK. Btn Id, 2. callout id
                     // enable animation callouts
                     window.updateHotspotVisibility('SMO1752JS', 'animation5_2');
                     window.updateHotspotVisibility('SMO1752JS', 'animation5_21');
                     window.updateHotspotVisibility('SMO1752JS', 'animation5_22');
                  }, 2000);
                  // };
               });
            });
            break;
         default:
            break;
      }
      if (window.mob) {
         var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, 6.9890517124872888, 127.95918253135886];

      } else {
         var temp_array = [2.107800541229233, -0.1277788857512855, 10.522524798176256, -1.9890517124872888, 127.95918253135886];

      }
      window.GotoPosInTimeNamedValue(temp_array, window.config.rangehoods, function () {
         document.querySelector('#container').style.pointerEvents = "auto";
      }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_hoodrange-0", true) });

      window.scene.groupApplyState(Products.category7.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat6. bCategoryChanged=',bCategoryChanged);
         seventhDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted, itemToAdd);
      });//AAATONI
      // hiding callouts
      document.getElementById("hotspot1").style.display = 'none';
      document.getElementById("hotspot6").style.display = 'none';
      window.hide_all_oven();
      document.getElementById("hotspot3").style.visibility = 'hidden';
   }
   async function eighthDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      if (document.getElementById('SMD3070AS').classList.contains('selected')) {
         // Apply DOF
         window.scene.setDoFTargetObject("ovan_SMD3070AS43-0");
      } else {
         // Apply DOF
         window.scene.setDoFTargetObject("new_sharp_oven-0");
      }
      if (cb) {
         setTimeout(function c8() {
            if (window.ranges_position == 'side') {
               document.getElementById("hotspot11").style.visibility = 'visible';
               document.getElementById("hotspot2").style.visibility = 'hidden';
            } else {
               document.getElementById("hotspot2").style.visibility = 'visible';
               document.getElementById("hotspot11").style.visibility = 'hidden';
            }
            document.getElementById("hotspot3").style.visibility = 'visible';
            cb();
         }, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }

   // const eighthDrawerDemo = () => {
   async function eighthDrawerDemo(itemToAdd, previousItem) {
      console.log("microwave+drawer Oven");
      console.log('window.currentConfig.currentDrawer ', window.currentConfig.currentDrawer);
      console.log('window.currentConfig.currentDrawer ', window.currentConfig.currentDrawer);
      console.log('window.currentConfig.currentDrawer ', window.currentConfig);
      console.log('window.config.wall_ovens ', window.config.wall_ovens);
      console.log(' window.currentSelected.category1 ', window.currentSelected.category1);
      window.congigurePlace = "eighth";
      window.SWB3085HS_walloven = true;
      window.pedestalInstall = false;
      window.pedestalCompability = false;
      // Handling Double Camera angle
      window.SMD3070AS_drawer_install = false;
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      document.getElementById("SMD3070AS").classList.remove('selected');
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none'
      // console.log("********* eighthDrawerDemo calling ************");
      // console.log(window.currentConfig.currentDrawer);
      if (window.currentConfig.currentDrawer == 'reset') {
         setTimeout(function () {
            window.scene.groupApplyState('Fridge_side_wall_off');
         }, 1200)

      }
      document.getElementById("SWB3085HS_panel_text").innerHTML = "Control Panel Close Up";
      document.getElementById("SWB3085HS_oven_text").innerHTML = "Open Oven";
      document.getElementById("SWB3085HS_drawer_text").innerHTML = "Open Drawer";
      window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
      // Surbhi gotopos with conditionsg4638
      var temp_array;
      window.reverseState();
      
      if (window.currentConfig.currentDrawer == "microwave") {
         window.scene.groupApplyState('Fridge_side_wall_on');
         window.scene.groupApplyState('microwave_Table_Big_door_On');
         // console.log("-----Inside the microwave ---------");
         temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 50, 152.46605138838333];
         // the above present cam is traveling cam-----

         //       if we gonna add any condition here for a particular model------ it will affect the traveling cam

         // console.log(window.config.microwave_drawers);
         window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.microwave_drawers, function () {
            // alert("come inside");
            window.delaysecondpanelIntersect1a();   // no use

            // console.log("calling delaysecondpanelIntersect end");

            setTimeout(function () {
               window.scene.groupApplyState('Fridge_side_wall_off');
            }, 800);

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
      }
      // console.log('window.currentConfig.currentDrawer ',window.currentConfig.currentDrawer);
      else if (window.currentConfig.currentDrawer == "fridge") {
         console.log("-----Inside eighth Drawer Fridge ---------");
         console.log("-----category8 data---------", window.currentSelected.category8);
         console.log("-----category2 data---------", window.currentSelected.category2);
         console.log("-----currentConfig data---------", window.currentConfig);
         console.log("-----currentConfig data---------", window.currentSelected);
         console.log("window.wallOvenCategory.wallOvenOnly", window.wallOvenCategory);
         console.log("window.wallOvenCategory.wallOvenOnly", window.wallOvenCategory.wallOvenOnly);
         console.log("window.wallOvenCategory.comboWallOven", window.wallOvenCategory.comboWallOven);
         // SWB  -----category present below is for wallOven only
         // condition will be added here only/-----------
         if (window.wallOvenCategory.wallOvenOnly == window.currentSelected.category2) {
            if (window.currentSelected.category2 == "SWB3052DS") {
               console.log("-----Inside eighth Drawer Fridge ---------", window.currentSelected.category2);
               var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -44.6029752581640646, 214.66329650582966];
            }
            if (window.currentSelected.category2 == "SWB3052GS") {
               var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -48.947901675616224, 214.66329650582966];
            }
            else if (window.currentSelected.category2 == "SWA3052DS") {
               var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -48.947901675616224, 214.66329650582966];
            }
            else if (window.currentSelected.category2 == "SWA3052GS") {
               var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -48.947901675616224, 214.66329650582966];
            }
            else if (window.currentSelected.category2 == "SSC2489GS") {
               var temp_array = [1.7752368394956048, 0.013285610089663625, 12.515923667192565, -7.947901675616224, 214.66329650582966];

            }
            window.GotoPosInTimeNamedValue(temp_array, window.config.wall_ovens, function () {
               // This GOTOPOS should come after the async functions
               // console.log("calling delaysecondpanelIntersect start");
               window.delaysecondpanelIntersect();
               // console.log("calling delaysecondpanelIntersect end");
            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
         }
         // console.log('window.currentConfig.category8',window.currentConfig.category8);
         if (window.wallOvenCategory.comboWallOven == window.currentSelected.category8) {
            console.log("the working of code SWB3085HS")
            if (window.currentSelected.category8 == "SWB3085HS") {
               console.log("this click is working well-----SWB3085HS")
               var temp_array = [1.4955448626614598, -0.024220389910336378, -8.853827071541769, -44.602975258164065, 191.63868925190678];
            }
            window.GotoPosInTimeNamedValue(temp_array, window.config.combo_wall_ovens, function () {
               // This GOTOPOS should come after the async functions
               // console.log("calling delaysecondpanelIntersect start");
               window.delaysecondpanelIntersect1();
               // console.log("calling delaysecondpanelIntersect end");

            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
         }
      }
      else if (window.currentConfig.currentDrawer == "range") {
         // console.log("-----Inside the Range ---------");
         window.scene.groupApplyState('Fridge_side_wall_off');
         if (document.getElementById("SMD3070AS").classList.contains('selected')) {
            var temp_array = [0.7722699999999993, 0.021736, -13.208294483756275, -49.79664726071187, 134.07480498151855];
            // alert('Inside the Range if');
         } else {
            if (window.currentSelected.category2 == "SWB3052DS") {
               var temp_array = [1.31955506266146, -0.03542038991033637, -8.853827071541769, -44.602975258164065, 214.66329650582966];
            }
            if (window.currentSelected.category2 == "SWB3052GS") {
               var temp_array = [1.31955506266146, -0.03542038991033637, -8.853827071541769, -44.602975258164065, 214.66329650582966];
            }
            else if (window.currentSelected.category2 == "SWA3052DS") {
               var temp_array = [1.204889788350463, 0.1845901777476891, -22.657609373593054, -44.6360708802969677, 134.06101132436365];

            }
            else if (window.currentSelected.category2 == "SWA3052GS") {
               var temp_array = [1.204889788350463, 0.1845901777476891, -22.657609373593054, -44.6360708802969677, 134.06101132436365];

            }
            else if (window.currentSelected.category2 == "SSC2489GS") {
               var temp_array = [1.1492684864308695, 0.11167088, -15.774983705791877, -65.077078660630587, 128.02438969442684];
            }
         }
         window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.wall_ovens, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
            // alert('menu js 1')
         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
      } else if (window.currentConfig.currentDrawer === "awards") {
         var temp_array = [1.497800541229233, 0.071788857512855, 150, 10, 270]; //updated Value
         window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.combo_wall_ovens, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
            window.delaysecondpanelIntersectfromAwards();
         }, window.slowinout2, { target: window.scene.getObjectLocation("Trophy_H1-0", true) });
      } else {
         console.log("-- SWB model coming from Else -- ");
         window.setTimeout(function () {
            var temp_array = [1.4955448626614598, -0.024220389910336378, -8.853827071541769, -44.602975258164065, 191.63868925190678]; //updated Value
            window.GotoPosInTimeNamedValuewalloven(temp_array, window.config.combo_wall_ovens, function () {
               document.querySelector('#container').style.pointerEvents = "auto";
            }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_oven-0", true) });
            window.scene.groupApplyState('Fridge_side_wall_off');
         }, 300)
      }

      // window.currentConfig.currentDrawer = "comboWallOven";
      // console.log('AAATONI. eighthDrawerDemo:',itemToAdd);
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;
      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var j = 0; j < animations.length; j++) {
         animations[j].style.visibility = 'hidden';
      }
      // console.log(window.currentConfig.hideVisibleInternal);
      if (!bCategoryChanged) {
         // console.log('AAATONI. before FadeOutSharp');
         if (window.SMD3070ASStatus.selectedModel != 'SMD3070AS_walloven') {
            await window.FadeOutSharp(); //AAATONI
         }
      }
      window.cookTop = false;
      window.overTheRange = false;
      window.hoodRange = false;
      window.comboCookTop = false;
      hideFridge = true;
      // console.log("hideFridge",hideFridge);
      window.localStorage.setItem('wallOven', 'walloven');
      hideInternals();
      // console.log("**************************** okok");
      // console.log(window.SMD3070ASStatus.selectedModel);
      window.hideAlexaBoxCallouts();
      //use switch case
      
      console.log('window.currentSelected.category8', window.currentSelected.category8)
      switch (window.currentSelected.category8) {
         case 'SWB3085HS':
            window.scene.groupApplyState('SWB3085HS_on', {}, function () {
               window.pedestalInstall = false;
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               // Interior On
               window.scene.groupApplyState('SWB3085HS_INT_ON');
               // Off All Walloven
               window.scene.groupApplyState('SWB3052DS_off');
               window.scene.groupApplyState('SWA3052DS_off');
               window.scene.groupApplyState('SMD3070AS_off');
               window.scene.groupApplyState('SSC2489GS_ovan_off');
               window.scene.groupApplyState('SMD2479JS_OFF');
               // Remove all Microwave Drawer
               window.scene.groupApplyState('SMD2449FS_off');
               window.scene.groupApplyState('SMD2489ES_off');
               window.scene.groupApplyState('SMD2470ASY_off');
               window.scene.groupApplyState('SMD2470AH_off');
               window.scene.groupApplyState('KB6524PSY_off');
               window.scene.groupApplyState('SMD3070ASS_Drawer_Oven_off');
               // make microwave close door
               window.scene.groupApplyState('New_Drawer_Part_On');
               window.scene.groupApplyState('SMD3070ASS_Oven_Self_off');
               document.getElementById("hotspot13").style.visibility = 'hidden';
               document.getElementById("animation11_3").style.visibility = 'hidden';
               window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_ON');
               window.scene.groupApplyState('SKMD24U0ES_Pedestal_OFF');
               window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
               window.scene.groupApplyState('Double_self_on', {}, function () {
                  window.scene.groupApplyState('single_wall_oven_filler_off'); //TODO: Question. needed?
                  window.scene.groupApplyState('Double_self_off');
                  window.scene.groupApplyState('singal_oven_self_off');
                  window.scene.groupApplyState('SWB3052DS_internals_off');
                  window.scene.groupApplyState('SWA3052DS_off');
                  window.scene.groupApplyState('SMD3070AS_off');
                  window.scene.groupApplyState('self_3070_new_off');
                  window.currentConfig.hideVisibleInternal = "SWB3052DS_internals_off";
                  document.getElementById('alexaBox-container').style.display = 'block'
                  displayTextsOnCompleted = function () {
                     window.setTimeout(function () {
                        window.updateCalloutPopupVisibility('SWB3085HS', 'SWB3085HS_allDrawerss');
                        window.updateHotspotVisibility('SWB3085HS', 'animation8');
                        window.updateHotspotVisibility('SWB3085HS', 'animation8_1');
                        window.updateHotspotVisibility('SWB3085HS', 'animation8_2');
                        window.updateHotspotVisibility('SWB3085HS', 'SWB3085HS_alexaBox');
                        window.scene.groupApplyState('SWB3085HS_Wall_Oven_Icon_ON', {}, function () {
                           window.AwardAnimation("SWB3085HS", "SWB3085HS_Wall_Oven_Icon")
                        })

                        window.currentConfig.currentDrawer = "comboWallOven";
                     }, 1000);
                  };
               });
            });
            break;
         default:
            break;
      }
      if (bCategoryChanged) {
         setExpanded('panel8');
      }
      // alert(JSON.stringify(Products.category8.items[0]));
      // alert(itemToAdd);
      // here items[0] should be zero
      window.scene.groupApplyState(Products.category8.items[0].productShow, {}, function () {
         // console.log('AAATONI cb cat2. bCategoryChanged=',bCategoryChanged);
         eighthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      });//AAATONI);
      //end
      window.yMinLimit = 2.092189365135304;
      window.yMaxLimit = 0.5924245719999998;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-60, -60, 60, 60, 105, 214.66329650582966, 130);
      if (window.mob) {
         if (window.isiphone) {
            document.getElementById('demoDiv').style.height = '1150px';
         } else {
            document.getElementById('demoDiv').style.height = '1320px';
         }
      } else {
         document.getElementById('demoDiv').style.height = '1182px';
      }

      if (expanded == 'panel2') {
         // console.log("here is panel 2 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 543);
         }
      } else if (expanded == 'panel3') {
         // console.log("here panel3 in sixth is else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 493);
      } else if (expanded == 'panel5') {
         // console.log("here is panel5 else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 298);
      }
      else if (expanded == 'panel7') {
         // console.log("here is panel 7 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 505);
         }
         // document.getElementById("scroll_panel").scrollTo(0,505);
      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
      }
      setTimeout(function () {
         window.setMenuScroll('panel8bh-header')
         window.pedestalComp();
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category8.icon_stable').classList.add('selectDrawer');

      window.scene.groupApplyState('Side_Table_on');

      document.getElementById("hotspot4").style.visibility = 'hidden';

      // Off Combo Products
      if (window.STR3065HS_table_cooktop) {

         // this is for Island table cooktop
         window.scene.groupApplyState('STR3065HS_Table_OFF', {}, function () {
            window.scene.groupApplyState('Old_Centre_Table_ON');

         });
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('Rangehood_Cabinet_OFF');
         // Enable last selected Range Hood
         window.scene.groupApplyState(window.localStorage.getItem('rangehood'));
         // Enable Microwave
         window.scene.groupApplyState(window.localStorage.getItem('microwave'));
         window.scene.groupApplyState('New_Drawer_Part_Off');
         // Enable last selected Cooktop
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
         window.STR3065HS_table_cooktop = false;
      }
      if (window.STR3065HS_cooktop) {
         // alert("XYZ")
         console.log("Cooktop Combo for first Drawer Demo");
         // this is for side platform cooktop
         window.scene.groupApplyState('Cooktop_Regular_Cabinet_On');
         window.scene.groupApplyState('Marble_Fill_OFF');
         window.scene.groupApplyState('STR3065HS_OFF');
         // Enable last selected Cooktop
         window.scene.groupApplyState(window.localStorage.getItem('cooktop'));
         setTimeout(() => {
            window.scene.groupApplyState('New_Drawer_Part_Off');
            // Enable Microwave
            window.scene.groupApplyState(window.localStorage.getItem('microwave'));
         }, 1200);
         window.STR3065HS_cooktop = false;
      }
      if (window.SMD3070ASStatus.selectedModel == "SMD3070AS_walloven") {
         // clear 30" variable
         window.SMD3070AS_walloven = false;
         window.SMD3070ASStatus.selectedModel = "";
         window.currentSelected.category1 = "SMD2499FS";
         window.localStorage.setItem('microwave', 'SMD2499FS_on');
         document.getElementById("hotspot7").style.visibility = "hidden";
         document.querySelector('#SMD3070ASS_Drawer_Oven').classList.remove('selected');
         document.querySelector('#SMD2499FS').classList.add('selected');
         document.querySelector('#SWB3052GS').classList.add('selected');
         document.querySelector('#SWA3052DS').classList.remove('selected');
         document.querySelector('#SWB3052DS').classList.remove('selected');
         window.localStorage.setItem('wall_oven', 'SWB3052DS_on');
         window.currentSelected.category2 = "SWB3052GS";
         window.scene.groupApplyState('SWA3052DS_off');
         window.scene.groupApplyState('SMD3070AS_off');
      }
     
   }

   async function ninthDrawerDemoOnCompleted(bCategoryChanged, cb, itemToAdd) {
      console.log("ninthDrawerDemoOnCompleted");
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      window.scene.setDoFTargetObject("new_sharp_cooktop-0");
      if (cb) {
         setTimeout(function () {
            if (itemToAdd === Products.category9.items.findIndex((element) => element.id === window.currentSelected.category9)) {
               // console.log("AAATONI. cb at cat5");
               cb();
            } else {
               //   console.log("AAATONI. You clicked too quick");
            }
         }, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }

   // const ninthDrawerDemo = () => {
   async function ninthDrawerDemo(itemToAdd, previousItem) {
      console.log("the combo cooktop +mircowave")
      // window.congigurePlace = "ninth";
      console.log("ninthDrawerDemo");
      window.pedestalCompability = false;
      window.pedestalInstall = false;
      
      if (document.getElementById("select_SMD3070AS").style.display == "flex") {
         document.getElementById("select_SMD3070AS").style.display = "none";
      }
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none';
      window.currentConfig.currentDrawer = "comboCooktop";
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      window.stopAllAnim();
      window.pedestalComp();

      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }

      if (!bCategoryChanged) {
         await window.FadeOutSharp(); //AAATONI

      }

      if (bCategoryChanged) {
         window.scene.groupApplyState('Wall_oven_hide_part_on');
         window.scene.groupApplyState('Microwave_drawer_hide_On');
         window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_ON');
         setExpanded('panel9');
      }
      window.cookTop = true;
      window.comboCookTop = true;

      window.yMinLimit = 2.253813205497491;
      window.yMaxLimit = 0.6374979715581001;
      window.valueForMin = 6;
      window.valueForMax = 0.1374979715581001;
      window.setZoomValue(-40, -20, 40, 60, 120, 270, 130);
      document.getElementById('demoDiv').style.height = '1430px';
      window.hideAlexaBoxCallouts();
      window.reverseState();
      if (expanded == 'panel2') {
         // console.log("here is panel 2 sixth expanded");

         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 543);
         }
      } else if (expanded == 'panel3') {
         // console.log("here panel3 in sixth is else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 493);
      } else if (expanded == 'panel5') {
         // console.log("here is panel5 else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 298);
      }
      else if (expanded == 'panel7') {
         // console.log("here is panel 7 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 505);
         }
      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
      }
      setTimeout(function () {
         window.setMenuScroll('panel9bh-header')
         window.pedestalComp();
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category9.icon_stable').classList.add('selectDrawer');
      window.hide_all_oven();
      document.getElementById("select_STR3065HS").style.display = "flex";
      document.getElementById("select_cooktop").style.display = "none";

      window.pauseIconClick = false;
   }

   // tenth 
   async function tenthDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      // window.scene.setDoFTargetObject("new_sharp_dishwasher-0");
      if (cb) {
         setTimeout(cb, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }

   async function eleventhDrawerDemoOnCompleted(bCategoryChanged, cb) {
      if (!bCategoryChanged) {
         await window.FadeInSharp();
      }
      //AAATONI.Moved DOF to the end of the call
      // Apply DOF
      // window.scene.setDoFTargetObject("new_sharp_dishwasher-0");
      if (cb) {
         setTimeout(cb, bCategoryChanged ? 1800 : 800);
      }
      setTimeout(window.scene.clearRefine(), bCategoryChanged ? 1800 : 800);
   }

   // const tenthDrawerDemo
   async function tenthDrawerDemo(itemToAdd, previousItem) {

      // we have false this variables to avoid restriction of fRotMinLimit 
      window.cookTop = false;
      window.overTheRange = false;
      window.hoodRange = false;
      window.comboCookTop = false;
      window.pedestalCompability = true;
      document.getElementById("select_STR3065HS").style.display = "none";
      document.getElementById("select_cooktop").style.display = "none";

      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none';
      window.congigurePlace = "tenth";
      window.currentConfig.currentDrawer = "ranges";
      window.ranges_position = "side";
      window.STR3065HS_cooktop = '';
      window.localStorage.setItem('current_product', 'SSG3065JS');
      // var bCategoryChanged;
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      hideInternals();
      window.stopAllAnim();
      window.reverseState();
      window.pedestalComp();
      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }

      if (document.getElementById(window.currentSelected.category10 + '_allranges_text') != null) {
         document.getElementById(window.currentSelected.category10 + '_allranges_text').innerHTML = "Open Oven";
      }
      if (document.getElementById(window.currentSelected.category10 + '_allranges_control_text') != null) {
         document.getElementById(window.currentSelected.category10 + '_allranges_control_text').innerHTML = "View Control Panel";
      }
      if (document.getElementById(window.currentSelected.category10 + '_allranges_cooktop_text') != null) {
         document.getElementById(window.currentSelected.category10 + '_allranges_cooktop_text').innerHTML = "Cooktop Surface Close-Up";
      }
      if (document.getElementById(window.currentSelected.category10 + '_allranges_knob_text') != null) {
         document.getElementById(window.currentSelected.category10 + '_allranges_knob_text').innerHTML = "Turn Knob";
      }
      if (!bCategoryChanged) {
         await window.FadeOutSharp(); //AAATONI
      }
      window.clearPreviousSelectedAwardHotspot();
      window.yMinLimit = 2.253813205497491;
      window.yMaxLimit = 0.6374979715581001;
      window.valueForMin = 6;
      window.valueForMax = 0.1374979715581001;
      window.setZoomValue(-40, -50, 40, 60, 150, 270, 170);
      window.scene.groupApplyState(window.currentSelected.category10 + '_on');
      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }
      window.scene.groupApplyState('Table_on');
      window.hideAlexaBoxCallouts();


      //use switch case
      switch (window.currentSelected.category10) {
         case 'SSG3065JS':
            await window.FadeOutSharp();
            window.scene.groupApplyState('SSG3061JS_Rangetop_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('Side_Table_on');
               window.scene.groupApplyState('Marble_Fill_OFF');
               window.scene.groupApplyState("SSG3061JS_Rangetop_Table_ON");
               window.scene.groupApplyState('STR3065HS_OFF');
               window.scene.groupApplyState("SCR3042FB_off");
               window.scene.groupApplyState('SDH3042DB_off');
               window.scene.groupApplyState('SDH3652DB_off');
               window.scene.groupApplyState('SCH3043GB_off');
               window.scene.groupApplyState("Cooktop_Regular_Cabinet_Off");
               window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_OFF');
               window.scene.groupApplyState("SSG3061JS_Rangetop_ON");
               window.scene.groupApplyState('SSG3061JS_Rangetop_Int_ON', {}, function () {
                  window.scene.groupApplyState('Normal_Induction');
                  window.scene.groupApplyState("RangeTop_Railing_With_Metal_Part");
               });
               window.scene.groupApplyState('SSG3061JS_Rangetop_Glow_OFF');

               // displayTextsOnCompleted = function () {
               window.setTimeout(function () {
                  window.updateCalloutPopupVisibility('SSG3065JS', 'SSG3065JS_allRanges');
                  // enable animation callouts
                  window.updateHotspotVisibility('SSG3065JS', 'animation101');
                  window.updateHotspotVisibility('SSG3065JS', 'animation101_1');
                  window.updateHotspotVisibility('SSG3065JS', 'animation101_12');
                  window.updateHotspotVisibility('SSG3065JS', 'animation101_13');
                  window.scene.groupApplyState('STR3065HS_Side_Table_Icon_OFF', {}, function () {
                     window.scene.groupApplyState('SSG3065JS_Rangetop_Icon_ON', {}, function () {
                        window.AwardAnimation('SSG3065JS', 'SSG3065JS_Rangetop_Icon');
                     })
                  })
               }, 2000);
            });
            break;
         case 'SSG3061JS':
            await window.FadeOutSharp();
            window.scene.groupApplyState('SSG3061JS_Rangetop_ON', {}, function () {
               document.getElementById('internalLoader').classList.remove('show');
               document.getElementById('internalLoader').classList.add('hide');
               window.scene.groupApplyState('Side_Table_on');
               window.scene.groupApplyState('Marble_Fill_OFF');
               window.scene.groupApplyState("SSG3061JS_Rangetop_Table_ON");
               window.scene.groupApplyState('STR3065HS_OFF');
               window.scene.groupApplyState("SCR3042FB_off");
               window.scene.groupApplyState('SDH3042DB_off');
               window.scene.groupApplyState('SDH3652DB_off');
               window.scene.groupApplyState("Cooktop_Regular_Cabinet_Off");
               window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_OFF');
               window.scene.groupApplyState("SSG3061JS_Rangetop_ON");
               window.scene.groupApplyState('SSG3061JS_Rangetop_Int_ON', {}, function () {
                  window.scene.groupApplyState('Normal_Induction');
                  window.scene.groupApplyState("RangeTop_Railing_Without_Metal_Part");
               });
               window.scene.groupApplyState('SSG3061JS_Rangetop_Dull_ON');
               window.scene.groupApplyState('SSG3061JS_Rangetop_Glow_OFF');
               // displayTextsOnCompleted = function () {
               window.setTimeout(function () {
                  window.updateCalloutPopupVisibility('SSG3061JS', 'SSG3061JS_allRanges');
                  // enable animation callouts
                  window.updateHotspotVisibility('SSG3061JS', 'animation10');
                  window.updateHotspotVisibility('SSG3061JS', 'animation10_1');
                  window.updateHotspotVisibility('SSG3061JS', 'animation10_12');
                  window.updateHotspotVisibility('SSG3061JS', 'animation10_13');
               }, 2000);
               // };
            });
            break;
         case 'SSR3061JS':
            window.scene.groupApplyState('SSR3061JS_on', {}, function () {
               window.scene.groupApplyState('SSG3061JS_Rangetop_ON', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');

                  window.scene.groupApplyState('Side_Table_on');
                  window.scene.groupApplyState('Marble_Fill_OFF');
                  window.scene.groupApplyState("SSG3061JS_Rangetop_Table_ON");
                  window.scene.groupApplyState('STR3065HS_OFF');
                  window.scene.groupApplyState("SCR3042FB_off");
                  window.scene.groupApplyState('SDH3042DB_off');
                  window.scene.groupApplyState('SDH3652DB_off');
                  window.scene.groupApplyState("Cooktop_Regular_Cabinet_Off");
                  window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_OFF');
                  window.scene.groupApplyState('SSG3061JS_Rangetop_Int_ON', {}, function () {
                     window.scene.groupApplyState('Hot_Surface_Indicator_OFF', {}, function () {
                        window.scene.groupApplyState('Electric_Induction');
                        window.scene.groupApplyState('SSG3061JS_Rangetop_Glow_OFF');
                     });
                     window.scene.groupApplyState("RangeTop_Railing_Without_Metal_Part");
                  });
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SSR3061JS', 'SSR3061JS_allRanges');
                     // enable animation callouts
                     window.updateHotspotVisibility('SSR3061JS', 'animation102');
                     window.updateHotspotVisibility('SSR3061JS', 'animation102_1');
                     window.updateHotspotVisibility('SSR3061JS', 'animation102_12');
                     window.updateHotspotVisibility('SSR3061JS', 'animation102_13');
                  }, 2000);
                  // };
               });
            });
            break;
         case 'SSR3065JS':
            window.scene.groupApplyState('SSR3065JS_on', {}, function () {
               window.scene.groupApplyState('SSG3061JS_Rangetop_ON', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');

                  window.scene.groupApplyState('Side_Table_on');
                  window.scene.groupApplyState('Marble_Fill_OFF');
                  window.scene.groupApplyState("SSG3061JS_Rangetop_Table_ON");
                  window.scene.groupApplyState('STR3065HS_OFF');
                  window.scene.groupApplyState("SCR3042FB_off");
                  window.scene.groupApplyState('SDH3042DB_off');
                  window.scene.groupApplyState('SDH3652DB_off');
                  window.scene.groupApplyState("Cooktop_Regular_Cabinet_Off");
                  window.scene.groupApplyState('SSG3061JS_Rangetop_Table_Strip_OFF');
                  window.scene.groupApplyState('SSG3061JS_Rangetop_Int_ON', {}, function () {
                     window.scene.groupApplyState('Hot_Surface_Indicator_OFF', {}, function () {
                        window.scene.groupApplyState('Electric_Induction');
                        window.scene.groupApplyState('SSG3061JS_Rangetop_Glow_OFF');
                     });

                     window.scene.groupApplyState("RangeTop_Railing_With_Metal_Part");
                  });
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     window.updateCalloutPopupVisibility('SSR3065JS', 'SSR3065JS_allRanges');
                     // enable animation callouts
                     window.updateHotspotVisibility('SSR3065JS', 'animation103');
                     window.updateHotspotVisibility('SSR3065JS', 'animation103_1');
                     window.updateHotspotVisibility('SSR3065JS', 'animation103_12');
                     window.updateHotspotVisibility('SSR3065JS', 'animation103_13');
                  }, 2000);
                  // };
               });
            });
            break;
         default:
            break;
      }
      if (bCategoryChanged) {
         setExpanded('panel10');
      }
      window.scene.groupApplyState(Products.category10.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat2. bCategoryChanged=',bCategoryChanged);
         tenthDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      });//AAATONI);
      if (expanded == 'panel2') {
         // console.log("here is panel 2 sixth expanded");

         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 543);
         }
      } else if (expanded == 'panel3') {
         // console.log("here panel3 in sixth is else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 493);
      } else if (expanded == 'panel5') {
         // console.log("here is panel5 else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 298);
      } else if (expanded == 'panel7') {
         // console.log("here is panel 7 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 505);
         }
      } else if (expanded == 'panel10') {

         if (window.mob) {
            // console.log("panel10 expaned mob")
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 445);
         }

      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
      }

      document.getElementById('demoDiv').style.height = '1450px';

      setTimeout(function () {
         window.setMenuScroll('panel10bh-header')
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category10.icon_stable').classList.add('selectDrawer');
      window.hide_all_oven();

      window.pauseIconClick = false;

      if (window.drawer_position == 'selected') {
         temp_array = [2.616657, 0.000025999999999998247, 2.6699326181782777, 30, 152.46605138838333];
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            window.scene.groupApplyState('Side_Table_off');
            window.drawerRanges();
            window.drawer_position = "";

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });
      } else {
         if (window.mob) {
            var temp_array = [1.0780228394506648, 0.3107990595397148, -4.0863900941049085, -29.902466457453913, 270];
         } else {
            var temp_array = [1.0780228394506648, 0.3107990595397148, -4.0863900941049085, -45, 250];

         }
         window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
            document.querySelector('#container').style.pointerEvents = "auto";
            window.scene.setDoFTargetObject("new_sharp_cooktop-0");

         }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_cooktop-0", true) });
      }
   }

   async function eleventhDrawerDemo(itemToAdd, previousItem) {
      // we have false this variables to avoid restriction of fRotMinLimit 
      window.cookTop = false;
      window.hoodRange = false;
      window.comboCookTop = false;
      window.pedestalCompability = true;
      // Remove canvas zoomout
      document.getElementById('reset_canvas').style.display = 'none';
      window.congigurePlace = "eleventh";
      window.currentConfig.currentDrawer = "pedestal";

      // var bCategoryChanged;
      var bCategoryChanged = (previousItem == null) ? true : false;
      var displayTextsOnCompleted = null;

      // Hide texts/drawers before fadeOut
      window.HideAlldrawers();
      window.hide_drawer_callouts_anim();
      hideInternals();
      window.stopAllAnim();
      window.reverseState();
      window.clearPreviousSelectedAwardHotspot();
      window.hide_all_oven();
      window.hideAlexaBoxCallouts();
      window.pedestalComp();


      for (var i = 0; i < hotspots.length; i++) {
         hotspots[i].style.visibility = 'hidden';
      }
      for (var i = 0; i < animations.length; i++) {
         animations[i].style.visibility = 'hidden';
      }

      if (document.getElementById(window.currentSelected.category11 + '_allranges_text') != null) {
         document.getElementById(window.currentSelected.category11 + '_allranges_text').innerHTML = "Open";
      }


      if (!bCategoryChanged) {
         await window.FadeOutSharp(); //AAATONI
      }

      document.getElementById('demoDiv').style.height = '1450px';

      setTimeout(function () {
         window.setMenuScroll('panel10bh-header')
      }, 500);
      if (document.querySelector('.icon_stable.selectDrawer') != null) {
         document.querySelector('.icon_stable.selectDrawer').classList.remove('selectDrawer');
      }
      document.querySelector('#category11.icon_stable').classList.add('selectDrawer');

      if(window.currentSelected.category11 === 'RemovethePedestal'){
         window.localStorage.setItem('pedestal', 'RemovethePedestal_on'); 
      }else if(window.currentSelected.category1 === 'SMD2499FS'){
         window.localStorage.setItem('pedestal', 'SKCD24U0GS_on');
      }else{
         window.localStorage.setItem('pedestal', 'SKMD24U0ES_on'); 
      }

      if (document.getElementById('SKCD24U0GS').classList.contains('selected')) {
         document.getElementById('SKMD24U0ES').classList.add('opacityCard');
      }else if(document.getElementById('SKMD24U0ES').classList.contains('selected')){
         document.getElementById('SKCD24U0GS').classList.add('opacityCard');
      }

      // check which drawer is selected
      window.applyDrawerCategoryStates();

      window.scene.groupApplyState(window.currentSelected.category11 + '_on');
      window.pauseIconClick = false;

      if (window.mob) {
         // zoomOutbutton
         document.getElementById('reset_canvas_Mob').style.display = 'flex';
         document.getElementById('navButtonMob').style.borderRight = '1px solid grey';
      }
      document.getElementById("hotspot13").style.visibility = 'visible';
      var temp_array = [2.616657, 0.000025999999999998247, 2.8600740700999916, -25.311314182589758, 152.46605138838333];
      // var temp_array = [2.616657, 0.000025999999999998247, 2.8600740700999916, -25.311314182589758, 290];
      window.GotoPosInTimeNamedValue(temp_array, window.config.microwave_drawers, function () {
         document.querySelector('#container').style.pointerEvents = "auto";
         document.getElementById('hotspot6').style.visibility = 'visible'
      }, window.slowinout2, { target: window.scene.getObjectLocation("new_sharp_tableoven-0", true) });


      window.yMinLimit = 3.4721705271702347;
      window.yMaxLimit = 2.4192280571000184;
      window.valueForMin = 6;
      window.valueForMax = 0;
      window.setZoomValue(-60, -35, 60, 30, 140, 165, 130);

      if (bCategoryChanged) {
         setExpanded('panel11');
      }

      if (expanded == 'panel2') {
         // console.log("here is panel 2 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 543);
         }
      } else if (expanded == 'panel3') {
         // console.log("here panel3 in sixth is else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 493);
      } else if (expanded == 'panel5') {
         // alert("panel5")
         // console.log("here is panel5 else if expanded");
         document.getElementById("scroll_panel").scrollTo(0, 298);
      } else if (expanded == 'panel7') {
         // console.log("here is panel 7 sixth expanded");
         if (navigator.userAgent.match(/Mac/)) {
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
         else {
            document.getElementById("scroll_panel").scrollTo(0, 505);
         }
      } else if (expanded == 'panel10' || expanded == 'panel11') {
         if (window.mob) {
            // console.log("panel10 expaned mob")
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 445);
         }

      } else {
         if (window.mob) {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 294);
         } else {
            // console.log("else expanded");
            document.getElementById("scroll_panel").scrollTo(0, 300);
         }
      }

      // window.pedestalAddRemove();
      window.scene.groupApplyState('Side_Table_off');
      window.scene.setDoFTargetObject("");
      //use switch case
      switch (window.currentSelected.category11) {
         case 'SKCD24U0GS':
            await window.FadeOutSharp();
            window.scene.groupApplyState('SKCD24U0GS_On', {}, function () {
               window.scene.groupApplyState('SMD2449FS_Pedestal_ON', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SKMD24U0ES_Pedestal_OFF');
                  window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_OFF');
                  window.scene.groupApplyState('Table_Dull_Pedestal_OFF');


                  // displayTextsOnCompleted = function () {
                  document.getElementById("hotspot13").style.visibility = 'hidden';
                  window.setTimeout(function () {
                     document.getElementById("animation11_3").style.display = 'none';
                     window.updateCalloutPopupVisibility('SKCD24U0GS', 'SKCD24U0GS_allRanges');
                     // enable animation callouts
                     window.updateHotspotVisibility('SKCD24U0GS', 'animation11_1');
                  }, 2000);
                  // };
                  window.pedestalInstall = true;
               });
            });
            break;
         case 'SKMD24U0ES':
            await window.FadeOutSharp();
            window.scene.groupApplyState('SKMD24U0ES_on', {}, function () {
               window.scene.groupApplyState('SKMD24U0ES_Pedestal_ON', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SKMD24U0ES_Pedestal_Part_OFF');
                  window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_OFF');
                  window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
                  window.scene.groupApplyState('Table_Dull_Pedestal_OFF');

                  document.getElementById("hotspot13").style.visibility = 'hidden';
                  // displayTextsOnCompleted = function () {
                  window.setTimeout(function () {
                     document.getElementById("animation11_3").style.display = 'none';
                     window.updateCalloutPopupVisibility('SKMD24U0ES', 'SKMD24U0ES_allRanges');
                     // enable animation callouts
                     window.updateHotspotVisibility('SKMD24U0ES', 'animation11_2');
                  }, 2000);
                  // };
                  window.pedestalInstall = true;
               });
            });
            break;
         case 'RemovethePedestal':
            await window.FadeOutSharp();
            window.scene.groupApplyState('RemovethePedestal_on', {}, function () {
               window.scene.groupApplyState('SMD2449FS_Pedestal_Wall_ON', {}, function () {
                  document.getElementById('internalLoader').classList.remove('show');
                  document.getElementById('internalLoader').classList.add('hide');
                  window.scene.groupApplyState('SMD2449FS_Pedestal_OFF');
                  window.scene.groupApplyState('SKMD24U0ES_Pedestal_OFF');
                  window.scene.groupApplyState('Table_Dull_Pedestal_ON');

                  window.drawerPartON();
                  document.getElementById("hotspot13").style.visibility = 'hidden';
                  document.getElementById('animation11_3').style.visibility = 'visible';
                  document.getElementById("animation11_3").style.display = 'block';
                  document.getElementById("reset_canvas").style.display = 'block';
                  window.pedestalInstall = false;
               });
            });
            break;
         default:
            break;
      }


      window.scene.groupApplyState(Products.category11.items[itemToAdd].productShow, {}, function () {
         // console.log('AAATONI cb cat2. bCategoryChanged=',bCategoryChanged);
         eleventhDrawerDemoOnCompleted(bCategoryChanged, displayTextsOnCompleted);
      });//AAATONI);
      

   }

   const category1Items = allProducts.category1.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList2 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList2.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SMD2479JS",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"

      ]
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {
            // console.log('distributorProductListdistributorProductList',distributorProductList)
            if (distributorProductList2.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }
      if (droplist.length > 1) {
         console.log('item YOGI YOGI', item.name);
         // if(droplist.length > 0){
         // droplist = droplist.split(",");
         // }
         console.log("droplist for Cat1 *********");
         console.log(JSON.stringify(droplist));
         console.log(droplist.includes('SMD2499FS'));
         if (droplist.includes('SMD2499FS') == false) {
            droplist.push('SMD2499FS');
         }

         if (distributors_url == "Jones" || distributors_url == "Smith") {
            setTimeout(function () {
               document.getElementById("SMD3070ASS_Drawer_Oven_mui").style.display = "none";
            }, 500);
         }
         for (let i = 0; i < droplist.length; i++) {
            // console.log("item.name",item.name);
            // console.log("droplist i - ",droplist[i]);
            if (item.name != "SMD2499FS" || item.name == "SMD3070ASY") {
               if (item.name != "SMD3070ASY" || item.name == "SMD2499FS") {
                  if (item.name == droplist[i]) { return false }
               }
            }
         }
      }
      return <AccordionDetails key={item.id} id={item.id + "_mui"} >
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '85px', padding: '10px' }} /></div></Col>

            {/* <Col xs="12">
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}><span className="cartText">Download</span></a> 
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
         </Row>
      </AccordionDetails >
   })
   const category2Items = allProducts.category2.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList2 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList2.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWB3052GS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ];

      if (distributorProductList2.includes('SWB3052DS') == false) {
         distributorProductList2.push('SWB3052DS');

         if (distributors_url == "renosappliance" || distributors_url == "Smith" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SWB3052DS_mui").style.display = "none";
            }, 500);
         }

      }
      if (distributorProductList2.includes('SWA3052DS') == false) {
         distributorProductList2.push('SWA3052DS');
         if (distributors_url == "renosappliance" || distributors_url == "Smith" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SWA3052DS_mui").style.display = "none";
            }, 500);
         }
      }
      if (distributorProductList2.includes('SWA3062GS') == false) {
         distributorProductList2.push('SWA3062GS');
      }
      if (distributorProductList2.includes('SWB3062GS') == false) {
         distributorProductList2.push('SWB3062GS');
      }
      if (distributorProductList2.includes('SMD3070AS') == false) {
         distributorProductList2.push('SMD3070AS');
      }
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {
            // console.log('distributorProductListdistributorProductList',distributorProductList)
            if (distributorProductList2.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // if (droplist.includes('SWB3052DS') == false) {
      //    droplist.push('SWB3052DS');
      // }
      // if (droplist.includes('SWA3052DS') == false) {
      //    droplist.push('SWA3052DS');
      // }
      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         // console.log('item YOGI YOGI',item.name);
         // droplist = droplist.split(",");

         for (let i = 0; i < droplist.length; i++) {
            if (item.display != "SWB3052DS" || item.display != "SWB3062GS" || item.display == "SWA3052DS" || item.display == "SWA30626GS") {
               if (item.display != "SWA3052DS" || item.display != "SWA3062GS" || item.display == "SWB3052DS" || item.display == "SWB3062GS") {
                  if (item.display == droplist[i]) { return false }
               }
               // if (item.name == droplist[i]) { return false }
            }
         }
      }


      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain downloadSpecTwo" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )

   const category3Items = allProducts.category3.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('3distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products',distributorProductList);
      var distributorProductList2 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList2.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ]
      // var distributorProductList2 = [...distributorProductList]
      // console.log('distributorProductList2',distributorProductList2);
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {
            // console.log('distributorProductListdistributorProductList',distributorProductList)
            if (distributorProductList2.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }
      // console.log("droplist cat 2 ##########################");
      // console.log(droplist);
      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         // console.log('item YOGI YOGI',item.name);
         // droplist = droplist.split(",");

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "SJG2254FS") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }

      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '65px', padding: '10px', marginTop: '5px' }} /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" id="downloadSpec" className="addToCartBtnDownload cartBtnMain downloadSpecThree" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )

   const category4Items = allProducts.category4.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList2 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList2.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ]
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {
            // console.log('distributorProductListdistributorProductList',distributorProductList)
            if (distributorProductList2.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         // console.log('item YOGI YOGI',item.name);
         // droplist = droplist.split(",");

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "SDW6757ES") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }



      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '65px', padding: '10px' }} /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )

   const category5Items = allProducts.category5.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList5 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList5.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ]

      if (distributorProductList5.includes('SDH3042DB') == false) {
         distributorProductList5.push('SDH3042DB');

         if (distributors_url == "lowe" || distributors_url == "renosappliance" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SDH3042DB_mui").style.display = "none";
            }, 500);
         }

      }

      if (distributorProductList5.includes('SDH3652DB') == false) {
         distributorProductList5.push('SDH3652DB');

         if (distributors_url == "lowe" || distributors_url == "renosappliance" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SDH3652DB_mui").style.display = "none";
            }, 500);
         }

      }
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {

            if (distributorProductList5.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }

      // Hide the product which are not required 
      setTimeout(() => {
         document.getElementById("SDH3042DB_mui").style.display = 'none';
         document.getElementById("SDH3652DB_mui").style.display = 'none';
      }, 100);



      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain downloadSpecFive" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )

   const category6Items = allProducts.category6.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList2 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList2.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ]
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {
            if (distributorProductList2.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }
      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         // console.log('item YOGI YOGI',item.name);
         // droplist = droplist.split(",");

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "SHC3662FS") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }


      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '65px', padding: '10px' }} /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain downloadSpecSix" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>


   }

   )

   const category7Items = allProducts.category7.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList7 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList7.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList2', distributorProductList2)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ]

   

         if (distributorProductList7.includes('SMO1652DS') == false) {
            distributorProductList7.push('SMO1652DS');
   
            if (distributors_url == "lowe" || distributors_url == "renosappliance" || distributors_url == "defaultconfig") {
               setTimeout(function () {
                  document.getElementById("SMO1652DS_mui").style.display = "none";
               }, 500);
            }
   
         }
   
         if (distributorProductList7.includes('SMO1854DS') == false) {
            distributorProductList7.push('SMO1854DS');
   
            if (distributors_url == "lowe" || distributors_url == "renosappliance" || distributors_url == "defaultconfig") {
               setTimeout(function () {
                  document.getElementById("SMO1854DS_mui").style.display = "none";
               }, 500);
            }
   
         }
      /// var distributorProductList7 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {

            if (distributorProductList7.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }

      // Hide the product which are not required 
      setTimeout(() => {
         document.getElementById("SMO1652DS_mui").style.display = 'none';
         document.getElementById("SMO1854DS_mui").style.display = 'none';
      }, 100);


      return <AccordionDetails key={item.id} style={{ marginTop: '7px' }} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '65px', padding: '10px' }} /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }

   )

   const category8Items = allProducts.category8.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList8 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList8.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList8', distributorProductList8)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "SWB3085HS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ];

      if (distributorProductList8.includes('SWB3052DS') == false) {
         distributorProductList8.push('SWB3052DS');

         if (distributors_url == "renosappliance" || distributors_url == "Smith" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SWB3052DS_mui").style.display = "none";
            }, 500);
         }

      }
      if (distributorProductList8.includes('SWA3052DS') == false) {
         distributorProductList8.push('SWA3052DS');
         if (distributors_url == "renosappliance" || distributors_url == "Smith" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SWA3052DS_mui").style.display = "none";
            }, 500);
         }
      }
      if (distributorProductList8.includes('SWB3085HS') == false) {
         distributorProductList8.push('SWB3085HS');
      }


      // if (droplist.includes('SWB3052DS') == false) {
      //    droplist.push('SWB3052DS');
      // }
      // if (droplist.includes('SWA3052DS') == false) {
      //    droplist.push('SWA3052DS');
      // }
      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         // console.log('item YOGI YOGI',item.name);
         // droplist = droplist.split(",");

         for (let i = 0; i < droplist.length; i++) {
            if (item.display != "SWB3052DS" || item.display != "SWB3062GS" || item.display == "SWA3052DS" || item.display == "SWA30626GS") {
               if (item.display != "SWA3052DS" || item.display != "SWA3062GS" || item.display == "SWB3052DS" || item.display == "SWB3062GS") {
                  if (item.display == droplist[i]) { return false }
               }
               // if (item.name == droplist[i]) { return false }
            }
         }
      }


      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )

   const category9Items = allProducts.category9.items.map((item) => {
      // console.log("category9Items");
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      // let droplist = urlParams.get('droplist');
      // console.log('distributor_data', distributor_data)
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      // console.log('distributors_url ----------------------------');
      // console.log(distributors_url);
      // console.log('droooooooooooooooooooooooooooplist');
      // console.log('distributors products', distributorProductList);
      var distributorProductList9 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList9.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList9', distributorProductList9)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "SWB3085HS",
         "STR3065HS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3061JS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"
      ]


      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {

            if (distributorProductList9.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         // console.log('item YOGI YOGI',item.name);
         // droplist = droplist.split(",");

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "STR3065HS") {
               if (item.name == droplist[i]) { return false }

            }

         }
      }




      return <AccordionDetails key={item.id} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )
   const category10Items = allProducts.category10.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      var distributorProductList10 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList10.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList10', distributorProductList10)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "SWB3085HS",
         "STR3065HS",
         "SSG3061JS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"

      ]

      if (distributorProductList10.includes('SSG3061JS') == false) {
         distributorProductList10.push('SSG3061JS');

         if (distributors_url == "Smith" || distributors_url == "renosappliance" || distributors_url == "defaultconfig") {
            setTimeout(function () {
               document.getElementById("SSG3061JS_mui").style.display = "none";
            }, 500);
         }

      }
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {

            if (distributorProductList10.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "SSG3061JS") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }


      return <AccordionDetails key={item.id} style={{ marginTop: '7px' }} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '65px', padding: '10px' }} /></div></Col>
            {/* { removeCartDisplay &&  */}
            {/* <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            <Col xs="12" className="addToCartBtnDownload cartBtnMain" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>

      </AccordionDetails>
   }
   )

   const category11Items = allProducts.category11.items.map((item) => {
      // Condition for Hiding Product from DropList
      const windowUrl = window.location.search;
      const urlParams = new URLSearchParams(windowUrl);
      let droplist = [];
      let distributors_url = urlParams.get('distributor');
      var distributorProductList = distributor_data[distributors_url];
      var distributorProductList11 = [];
      if (distributorProductList != undefined) {
         for (let product = 0; product <= distributorProductList.length - 1; product++) {
            distributorProductList11.push(distributorProductList[product]);
         }
      }
      // console.log('distributorProductList10', distributorProductList10)
      let allProductsList = ["SMD2499FS",
         "SMD2489ES",
         "SMD2470ASY",
         "SMD2470AH",
         "KB6524PSY",
         "SMD3070ASY",
         "SWB3062GS",
         "SWA3062GS",
         "SWB3052DS",
         "SWA3052DS",
         "SSC2489GS",
         "SMD3070AS",
         "SJG2254FS",
         "SJG2351FS",
         "SDW6757ES",
         "SDW6747GS",
         "SDW6767HS",
         "SDW6888JS",
         "SDW6506JS",
         "SCR3042FB",
         "SDH3042DB",
         "SDH3652DB",
         "SHC3662FS",
         "SHC3062FS",
         "SMO1652DS",
         "SMO1854DS",
         "SWB3085HS",
         "STR3065HS",
         "SSG3061JS",
         "SMD2479JS",
         "STR3065HS",
         "SSG3065JS",
         "SSR3061JS",
         "SSR3065JS",
         "SMD2440JS",
         "SMO1752JS",
         "SMO1754JS",
         "SMO1759JS",
         "SMO1969JS",
         "SHC3042FS",
         "SCH3043GB",
         "SJF2955KS",
         "SDW6504MS",
         "SDW6736MS",
         "SDW6726MS"

      ]

      // if (distributorProductList10.includes('SSG3061JS') == false) {
      //    distributorProductList10.push('SSG3061JS');

      //    if (distributors_url == "Smith" || distributors_url == "renosappliance" || distributors_url == "defaultconfig") {
      //       setTimeout(function () {
      //          document.getElementById("SSG3061JS_mui").style.display = "none";
      //       }, 500);
      //    }

      // }
      // var distributorProductList2 = [...distributorProductList]
      if (distributorProductList != undefined) {
         allProductsList.forEach(ele => {

            if (distributorProductList11.indexOf(ele) >= 0) {
               return false;
            } else {
               droplist.push(ele);
            }

         });
      }

      // console.log('droooooooooooooooooooooooooooplist');
      if (droplist.length > 1) {

         for (let i = 0; i < droplist.length; i++) {
            if (item.name != "SSG3061JS") {
               if (item.name == droplist[i]) { return false }
            }

         }
      }

      // setTimeout(() => {
      //       if(document.getElementById("SKCD24U0GS").classList.contains('selected')){
      //          document.getElementById("SKMD24U0ES").classList.add("opacityCard");
      //       }
      // }, 100);


      return <AccordionDetails key={item.id} style={{ marginTop: '7px' }} id={item.id + "_mui"}>
         <Row id={item.id} className={`${classes.productCard} cartMainDiv`} style={{ cursor: 'pointer', margin: '0px' }} onClick={window.selectProduct}>
            <Col xs="10" ><b className="card_head">{item.display}</b></Col>

            <Col className="checkBoxIcon" xs="2" style={{ textAlign: 'right', fontSize: '6px', color: 'red' }}><span><img src="./img/icons/checkbox.png" alt="ICON1" style={{}} /></span></Col>

            <Col xs="7" style={{ textAlign: 'left', fontSize: '14px' }}><div style={{ textAlign: 'left', paddingLeft: '5px' }}>{item.text}</div></Col>
            <Col xs="5" style={{ textAlign: 'right', }}><div className='card_product'><img src={item.img} alt="ICON1" style={{ width: '65px', padding: '10px' }} /></div></Col>
            {/* { removeCartDisplay &&  */}
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col>

            {/* <Col xs="12" className="addToCartBtn cartBtnMain downloadSpecEleven" style={{ backgroundColor: '#999999', cursor: 'pointer', marginBottom: '1px' }}>
               <a href={item.path} target="_blank" className="cartBtnMain2" style={{ backgroundColor: '#999999', color: '#ffff', padding: '0', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400', textTransform: 'capitalize', letterSpacing: '0' }}>  <span className="cartText">Download Spec Sheet</span></a>
            </Col>

            {/* { removeCartDisplay &&  */}
            {/*
            <Col xs="12" className="addToCartBtn cartBtnMain" onClick={addToCartHandler} style={{ backgroundColor: '#e72224', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#e72224', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}>  <span className="cartText">Add to My Kitchen</span></button>
            </Col> */}

            {/* { !removeCartDisplay &&  */}
            <Col xs="12" className="removeFromCartBtn cartBtnMain" onClick={removeCartHandler} style={{ backgroundColor: '#333', cursor: 'pointer' }}>
               <button className="cartBtnMain2" style={{ backgroundColor: '#333', color: '#ffff', fontSize: '12px', textAlign: 'right', textDecoration: 'none', border: 'none', float: 'right', paddingRight: '8px', fontWeight: '400' }}> <span className="cartText">Remove From My Kitchen</span></button>
            </Col>
            {/* } */}
         </Row>
      </AccordionDetails>
   }
   )

   window.handleKitchenNavigation = () => {
      document.location.href = window.sharpTwentyFourURL;
   }


   const mobArrow = () => {
      var mobArrowIcon = document.getElementById("mobArrow");
      mobArrowIcon.style.opacity = "0";
      var leftMenuMob = document.getElementById("leftIconMenu");

      leftMenuMob.scrollTo({
         top: 0,
         left: 450,
         behavior: "smooth",
      });


      var mobArrowIconScroll = document.getElementById("mobArrowScroll");
      mobArrowIconScroll.style.opacity = "1";
   }

   const mobArrowScroll = () => {
      var mobArrowIconScroll = document.getElementById("mobArrowScroll");
      mobArrowIconScroll.style.opacity = "0";

      var mobArrowIcon = document.getElementById("mobArrow");
      mobArrowIcon.style.opacity = "1";

      var leftMenuMob = document.getElementById("leftIconMenu");
      leftMenuMob.scrollTo({
         top: 0,
         left: 0,
         behavior: "smooth",
      });

   }



   return (<>
      <div className='sharp_logo'>
         <img src="./img/final/SHARP_logo.svg" alt="Sharp Logo" style={{}} />
      </div>
      <div className='select_appliances'>
         <span>Select Your Appliances Model</span>
      </div>

      <div className='KitchenNavigationButton' onClick={window.handleKitchenNavigation} style={{ display: 'none' }}>
         <button className='NavigationButton'><img src='./img/arrow_new.svg' alt="Navigation arrow" className='NavigationButtonIcon' /></button>
         <span className="NavigationButtonText">Go to 24" 3D Showroom</span>
      </div>
      <StyledMenu open={open} aria-hidden={!isHidden} {...props}>

         <Container>
            <Row style={{ marginTop: "0px", borderTop: '1px solid #dddddd' }}>
               <Col id="leftIconMenu" xs="2" style={{ border: '0px solid red' }}>
                  <div id='mobileContainer'>
                     <div id="category1" onClick={firstDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/drawer.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/drawer.svg" alt="ICON1" />
                        <span className="tooltiptext ovenTooltip">Microwave Drawer™ Ovens</span>
                     </div>

                     <div id="category7" onClick={seventhDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/overTheRange.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/overTheRange.svg" alt="ICON1" />
                        <span className="tooltiptext overTheRangeTooltip">Over-the-Range Microwave Ovens</span>
                     </div>

                     <div id="category2" onClick={secondDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/wallOven.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/wallOven.svg" alt="ICON1" />
                        <span className="tooltiptext wallovenTooltip">Wall Ovens</span>
                     </div>

                     <div id="category3" onClick={thirdDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/refrejrator.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/refrejrator.svg" alt="ICON1" />
                        <span className="tooltiptext">Refrigerators</span>
                     </div>
                     <div id="category4" onClick={fourthDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/diswasher.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/diswasher.svg" alt="ICON1" />
                        <span className="tooltiptext dishwasherTooltip">Dishwashers</span>
                     </div>
                     <div id="category5" onClick={fifthDrawerTrigger} className='icon_stable'>
                        <img className="normal" src="./img/icons/cooktop.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/cooktop.svg" alt="ICON1" />
                        <span className="tooltiptext cooktopTooltip">Cooktops</span>
                     </div>
                     <div id="category6" onClick={sixthDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/hood range.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/hood range.svg" alt="ICON1" />
                        <span className="tooltiptext rangeHoodsTooltip">Range Hoods</span>
                     </div>
                     <div id="category8" onClick={eighthDrawer} className='icon_stable' style={{}}>
                        <img className="normal" src="./img/icons/combo_walloven.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/combo_walloven.svg" alt="ICON1" />
                        <span className="tooltiptext wallovenTooltip" style={{ width: '300px' }}>Wall Oven + Microwave Drawer™ Oven</span>

                     </div>
                     <div id="category9" onClick={ninthDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/combo_cooktop.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/combo_cooktop.svg" alt="ICON1" />
                        <span className="tooltiptext cooktopTooltip" style={{ width: '300px' }}>Cooktop + Microwave Drawer™ Oven</span>
                     </div>
                     <div id="category10" onClick={tenthDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/ranges.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/ranges.svg" alt="ICON1" />
                        <span className="tooltiptext cooktopTooltip" style={{ width: '300px' }}>Ranges</span>
                     </div>
                     <div id="category11" onClick={eleventhDrawer} className='icon_stable'>
                        <img className="normal" src="./img/icons/underthecounterMicroPedestals.svg" alt="ICON1" style={{}} />
                        <img className="active" src="./img/icons2/underthecounterMicroPedestalsActive.svg" alt="ICON1" />
                        <span className="tooltiptext cooktopTooltip" style={{ width: '300px' }}>Under-the-Counter Pedestals</span>
                     </div>
                  </div>

               </Col>
               <div id='mobArrow' onClick={mobArrow} style={{ display: 'none' }}>
                  <img src="./img/mobArrowIcon.png" alt='mobArrow' style={{ width: '14px', height: '18px', position: 'absolute', top: '14px' }} />
               </div>
               <div id='mobArrowScroll' onClick={mobArrowScroll} style={{ display: 'none' }}>
                  <img src="./img/mobArrowIcon.png" alt='mobArrowScroll' style={{ width: '14px', height: '18px', position: 'absolute', top: '17px' }} />
               </div>
               <Col xs="10" >

                  <div id='scroll_panel' style={{ borderLeft: '1px solid #dddddd', height: '85vh', overflowY: 'auto', overflowX: 'hidden', scrollbarWidth: 'thin', position: 'absolute', left: '53px', top: '45px' }}>
                     <div id='demoDiv'>
                        <Accordion expanded={expanded === 'panel1'} onChange={window.handleChange('panel1')} style={{}}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                           >
                              <Typography onClick={firstDrawer} className={classes.heading} style={{ lineHeight: '18px' }}>Microwave Drawer™ Ovens</Typography>

                           </AccordionSummary>

                           {category1Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel7'} onChange={window.handleChange('panel7')} style={{ borderBottom: '1px solid #dddddd', borderLeft: '1px solid #dddddd' }}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel7bh-content"
                              id="panel7bh-header"
                           >
                              <Typography onClick={seventhDrawer} className={classes.heading} style={{ lineHeight: '18px' }}>Over-the-Range Microwave Ovens</Typography>
                           </AccordionSummary>

                           {category7Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel2'} onChange={window.handleChange('panel2')} style={{}}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel2bh-content"
                              id="panel2bh-header"
                           >
                              <Typography onClick={secondDrawer} className={classes.heading}>Wall Ovens</Typography>

                           </AccordionSummary>

                           {category2Items}

                        </Accordion>
                        <Accordion expanded={expanded === 'panel3'} onChange={window.handleChange('panel3')} style={{}}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel3bh-content"
                              id="panel3bh-header"
                           >
                              <Typography onClick={thirdDrawer} className={classes.heading}>Refrigerators</Typography>

                           </AccordionSummary>

                           {category3Items}

                        </Accordion>
                        <Accordion expanded={expanded === 'panel4'} onChange={window.handleChange('panel4')} style={{}}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                           >
                              <Typography onClick={fourthDrawer} className={classes.heading}>Dishwashers</Typography>
                           </AccordionSummary>

                           {category4Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel5'} onChange={window.handleChange('panel5')} style={{}}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel5bh-content"
                              id="panel5bh-header"
                           >
                              <Typography onClick={fifthDrawerTrigger} className={classes.heading}>Cooktops</Typography>
                           </AccordionSummary>

                           {category5Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel6'} onChange={window.handleChange('panel6')} style={{ borderBottom: '1px solid #dddddd', borderLeft: '1px solid #dddddd' }}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel6bh-content"
                              id="panel6bh-header"
                           >
                              <Typography onClick={sixthDrawer} className={classes.heading}>Range Hoods</Typography>
                           </AccordionSummary>

                           {category6Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel8'} onChange={window.handleChange('panel8')} style={{ borderBottom: '1px solid #dddddd', borderLeft: '1px solid #dddddd' }}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel8bh-content"
                              id="panel8bh-header"
                           >
                              <Typography onClick={eighthDrawer} className={classes.heading} style={{ lineHeight: '18px' }}>Wall Oven + Microwave Drawer™ Oven</Typography>
                           </AccordionSummary>

                           {category8Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel9'} onChange={window.handleChange('panel9')} style={{ borderBottom: '1px solid #dddddd' }}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel9bh-content"
                              id="panel9bh-header"
                           >
                              <Typography onClick={ninthDrawer} className={classes.heading}>Cooktop + Microwave Drawer™ Oven</Typography>
                           </AccordionSummary>

                           {category9Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel10'} onChange={window.handleChange('panel10')} style={{ borderBottom: '1px solid #dddddd' }}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel10bh-content"
                              id="panel10bh-header"
                           >
                              <Typography onClick={tenthDrawer} className={classes.heading}>Ranges</Typography>
                           </AccordionSummary>

                           {category10Items}

                        </Accordion>

                        <Accordion expanded={expanded === 'panel11'} onChange={window.handleChange('panel11')} style={{ borderBottom: '1px solid #dddddd' }}>
                           <AccordionSummary
                              expandIcon={<ArrowRightIcon />}
                              aria-controls="panel11bh-content"
                              id="panel11bh-header"
                           >
                              <Typography onClick={eleventhDrawer} className={classes.heading}>Under-the-Counter Pedestals</Typography>
                           </AccordionSummary>

                           {category11Items}
                        </Accordion>


                     </div>
                  </div>
               </Col>
            </Row>
         </Container>

      </StyledMenu>
   </>
   )
}


Menu.propTypes = {
   open: bool.isRequired,
}

export default Menu;
